export const locale = {
    lang: 'ar',
    data: {
        HELLO: 'Hello {{value}}',
        MG_ACCOUNTS: {
            BANK_ACCOUNTS: "الحسابات البنكية",
            ALL: "الكل",
            ACTIVE: "نشط",
            DIACTIVE: "غير نشط",
            BANK_NAME: "اسم البنك",
            CARD_NUM: "رقم البطاقة",
            NEW_CARD_NUM: "رقم البطاقة الجديد",
            IBAN_NUMBER: "رقم الآيبان",
            CURRENCY_TYPE: "نوع العملة",
            STATUS: "الحالة",
            ACTIVITY: "النشاط",
            ADD_BANK_ACCOUNT: 'إضافة حساب بنكي',
            CANT_EDIT_IBAN: "لا يمكن تعديل رقم الآيبان",
            BANK_ACCOUNT_NOT_REGISTERED: "لم يتم تسجيل أي حساب بنكي.",
            NO_BANK_ACC: 'لا يوجد حساب بنكي متاح',
            NEW_BANK_WARNING: "وقت الانتظار لتأكيد معلومات الحساب البنكي هو ساعة واحدة على الأقل ويوم عمل واحد على الأكثر.",
            ACTIVE_DIALOG_TITLE: 'هل أنت متأكد من التعطيل؟',
            ACTIVE_DIALOG_TEXT: 'إذا تم تعطيل الحساب، فلن يكون من الممكن استخدامه في قسم طلبات الشحن والسحب.',
            ADD_BANK: {
                ADD_BANK_ACCOUNT: 'إضافة حساب بنكي',
                CARD_NUMBER: 'رقم البطاقة',
                IR: 'إيران',
                IBAN: 'رقم الآيبان',
                APPROVED_BANKS: 'البنوك المعتمدة',
                CURRENCY_TYPE: 'نوع العملة'
            },
            EDIT_BANK: {
                EDIT_BANK_ACCOUNT: 'تعديل الحساب البنكي'
            },
            ALERT: {
                BANK_ACCOUN_OWNER_NAME: 'يجب أن يكون الحساب البنكي باسم "{{fullname}}".',
                CARD_NUMBER_BANK_INVALID: 'حسابات {{bankName}} غير معتمدة، يرجى تسجيل رقم بطاقة آخر.'
            }
        },
        MG_GENERAL: {
            CANCEL: 'إلغاء',
            SAVE: 'حفظ',
            VIEW_ALL: 'عرض الكل',
            VIEW_LESS: 'عرض أقل',
            EDIT: 'تعديل',
            VERIFY_PERSONAL_DATA_TITLE: 'لم يتم التحقق من معلوماتك الشخصية',
            VERIFY_PERSONAL_DATA_LINK: 'تأكيد المعلومات',
            ACCEPT: 'قبول',
            LANGUAGE: 'اللغة',
            "CONTINUE": "متابعة",
            SUCCESSFUL_OPERATION: 'عملية ناجحة',
            DELETE: 'حذف',
            DISPLAY_ORDER_FILTER: 'تصفية ترتيب العرض',
            DETAILS: 'التفاصيل',
            NEXT: 'التالي',
            PREV: 'السابق',
            FILTER: 'تصفية',
            SELECT_DATES: 'اختيار التواريخ',
            ORDER: 'ترتيب',
            WITHDRAWALS: 'السحوبات',
            RECEIPTS: 'الإيصالات',
            APPLY: 'تطبيق',
            FILTERS_AND_SORTS: 'التصفية والترتيب',
            COPY: 'تم النسخ',
            FINISH: 'إنهاء'
        },
        NAV: {
            BUY_LIST: "سجل المشتريات",
            BUY_VOUCHER: "شراء قسيمة",
            DASHBOARD: "لوحة التحكم",
            DEPOSIT: "الإيداع",
            EXCHANGE_LOCAL_PAYMENT: "محفظة TC",
            E_MONEY_WITHDRAWAL: "الدفع الإلكتروني",
            LOCAL_SEND: "الدفع المحلي",
            LOCAL_WITHDRAWAL: "الدفع المحلي",
            MY_ACCOUNTS: "حساباتي",
            SEND: "إرسال",
            TC_ACCOUNTS: "حسابات TC",
            TC_WALLET_SEND: "تحويل TC إلى TC",
            TRANSACTIONS: "المعاملات",
            WALLETS: "المحافظ",
            WITHDRAW: "السحب",
            WITHDRAWAL: "السحب",
            CRYPTO_WITHDRAWAL: 'الدفع بالعملات الرقمية',
            CRYPTOCURRENCY_ACCOUNTS: 'حسابات العملات الرقمية',
            NEW_REQUEST: 'طلب جديد',
            BANK_ACCOUNTS: 'الحسابات البنكية',
            E_MONEY_ACCOUNTS: 'حسابات الأموال الإلكترونية',
            VOUCHER: 'قسيمة',
            POINT: 'النقاط',
            WITHDRAW_LIST: 'قائمة السحب',
            FRIENDS: 'الأصدقاء',
            SUPPORTS: 'الدعم',
            TICKETS: 'التذاكر',
            FAQ: 'الأسئلة الشائعة',
            PROFILE: 'الملف الشخصي',
            SETTING: 'الإعدادات',
            MY_WALLETS: 'محافظي',
            EXCHANGE: 'التبادل',
            SUPPORT: 'الدعم',
            RECIEVE: 'استلام',
            RECIEVEـTC_WALLET: 'استلام TC',
            LOCAL_RECIEVE: 'استلام محلي',
            TC_WALLET: 'محفظة TC',
            DEPOSIT_MONEY_CURRENCY: 'الدفع المحلي',
            DEPOSIT_CRYPTO: 'الدفع بالعملات الرقمية',
            DEPOSIT_ELECTRONIC_MONEY: 'الدفع الإلكتروني',
            DIGITAL_CURRENCY_PAYMENT: 'إيداع العملات الرقمية',
            DIGITAL_CURRENCY_PAYMENT_WITHDRAWAL: 'سحب العملات الرقمية',
            ANNOUNCEMENT: 'الإعلانات',
            PAYMENT_GATEWAY: "بوابة الدفع",
            MY_REQUEST_HISTORY: 'تاريخ طلباتي',
            CLIENT_REQUEST_HISTORY: 'تاريخ طلبات العميل',
            SETTLEMENT_REQUEST_HISTORY: 'تاريخ طلبات التسوية',
            P2P: 'P2P',
            P2P_MY_ORDERS: 'طلباتي',
            P2P_NEW_AD: 'إنشاء إعلان بيع',
            P2P_AD_LISTINGS: 'شراء من P2P',
            AFFILIATE_SUP: 'التسويق بالعمولة',
            AFFILIATE_PROGRAM_SUP: 'برنامج التعاون',
            AFFILIATE_REQUEST: 'إرسال طلب تعاون',
            AFFILIATE_MY_PROGRAM: 'برنامجي التابع',
            AFFILIATE_VIEW_TRANSACTIONS: 'تاريخ برنامج التسويق بالعمولة',
            AFFILIATE_MY_INTRODUCTION_PROGRAM_SUP: 'إرسال طلب تعاون',
            AFFILIATE_ENTER_CODE: 'رمز التعريف',
            AFFILIATE_CASHBACK: 'سجل الاسترداد النقدي',
            BANK_TRANSFER_PAYMENT: 'دفع التحويل البنكي',
            TRANSACTIONS_LIST: 'قائمة المعاملات',
            SOCIAL_MEDIA: 'وسائل الإعلام',
        },
        DASHBOARD: {
            CURRENCY: 'العملة',
            EXCHANGE_RATE: {
                EXCHANGE_RATE: 'سعر الصرف',
                SELL: 'بيع',
                BUY: 'شراء',
                FIAT_EXCHANGE_RATE: 'سعر صرف العملة الورقية',
                CRYPTO_EXCHANGE_RATE: 'سعر صرف العملات الرقمية',
                BOTH_EXCHANGE_RATE: 'سعر تحويل العملات الرقمية إلى العملات الورقية',
            },
            POINTS: {
                WITHDRAW: 'السحب',
                TRANSACTIONS: 'المعاملات',
                MY_POINTS: 'نقاطي',
            },
            TRANSFORM: {
                THE_ONLY_TRANSFER_OPPORTUNITY: 'تم تمديد فرصة التحويل!!!',
                CLICK: 'اضغط هنا!',
                TRANSFER: 'تحويل',
                MORE_DETAILS: 'مزيد من التفاصيل',
                DAY: 'يوم',
                MINUTE: 'دقيقة',
                SECOND: 'ثانية',
                HOURS: 'ساعات',
                CRYPTO_REVELUTION: 'ثورة العملات الرقمية على توب تشينج!',
                TRANSFER_TO_GC_P_ONE: 'تحويل محافظ العملات الرقمية في TC',
                TRANSFER_TO_GC_P_TWO: 'إلى المنصة المتخصصة GreenChange',
                NEW_ENVIROMENT: 'GreenChange بيئة جديدة لتبادل العملات الرقمية تلقائيًا'
            },
            ACTIVE_REQUESTS: {
                ACTIVE_REQUESTS: 'الطلبات النشطة',
                TRACKING_NUMBER: 'رقم التتبع',
                AMOUNT_AND_TYPE: 'المبلغ والنوع',
                CHANGE_STATUS_DATE: 'تغيير تاريخ الحالة',
                STATUS: 'الحالة',
                MESSAGE: 'الرسالة',
                INFO: 'لمعرفة أحدث حالة للتطبيقات اضغط على زر التحديث'
            },
            DOWNLOAD_APP: {
                TITLE: 'تحميل التطبيق',
                DOWNLOAD: 'تحميل'
            },
            WALLET: 'محفظة',
            SHOW_ALL: 'إظهار الكل',
        },
        BREAD_CRUMB: {
            ACCOUNTS: "الحسابات",
            ADD_ACCOUNT: "إضافة حساب",
            ADD_BANK_ACCOUNT: "إضافة حساب بنكي جديد",
            ADD_SERVICE_ACCOUNT: "إضافة حساب جديد",
            ADD_Service_ACCOUNT: "إضافة حساب أموال إلكترونية جديد",
            ADD_TICKET: "تذكرة جديدة",
            ADD_WALLET: "إضافة محفظة",
            ANOUNNCEMENT: "الإعلانات",
            BANK: "البنك",
            TRANSFER: 'تحويل',
            BUY: "شراء",
            CASH: "نقدًا",
            CATEGORY: "الفئة",
            CREDIT: "الأرصدة",
            DASHBOARD: "لوحة التحكم",
            DEPOSIT: "إيداع المحفظة",
            DETAIL: "التفاصيل",
            EDIT_ACCOUNT: "تعديل",
            EDIT_WALLET: "تعديل المحفظة",
            ELECTRONIC_MONEY: "الأموال الإلكترونية",
            ELECTRONIC_MONEY_LIST: "قائمة طلبات الدفع الإلكتروني",
            EXCHANGE: "التبادل",
            EXCHANGE_LOCAL_LIST: "قائمة تبادل محفظة TC",
            E_MONEY_WITHDRAWALS_LIST: "قائمة سحب الأموال الإلكترونية",
            FAQ: "الأسئلة الشائعة",
            FRIENDS: "الأصدقاء",
            HISTORY: "قائمة الطلبات",
            LIST: "القائمة",
            LOCAL_RECEIVE_LIST: "قائمة المدفوعات المحلية المستلمة",
            LOCAL_SEND_LIST: "قائمة المدفوعات المحلية",
            LOCAL_WITHDRAWALS_LIST: "قائمة السحوبات المحلية",
            MONEY_CURRENCY: "طرق الدفع المحلية",
            MONEY_CURRENCY_LIST: "قائمة طلبات الدفع المحلية",
            MY_ACCOUNTS: "حساباتي",
            MY_WALLETS: "محافظي",
            NEW: "جديد",
            NEW_REQUEST: "طلب جديد",
            NOTIFICATION: "الإشعارات",
            NOTIFICATIONS: "الإشعارات",
            P2P: 'P2P',
            MY_AFFILIATE_PROGRAM: 'برنامجي التابع',
            MY_AFFILIATE_HISTORY: 'سجل برامجي',
            SELL_SUCCESSFUL: 'بيع ناجح',
            BUY_SUCCESSFUL: 'شراء ناجح',
            MY_ORDERS: 'طلباتي',
            ADVERTISE: 'إعلاني',
            REGISTER_NEW_AD: 'تسجيل إعلان جديد',
            SELL: 'بيع',
            ONLINE: "عبر الإنترنت",
            POINT: "نقطة",
            POINT_LIST: "قائمة النقاط",
            PROFILE: "الملف الشخصي",
            RECEIVE_DETAIL: "تفاصيل المدفوعات المستلمة",
            RECEIVE_OTHER_WAYS_LIST: "قائمة المدفوعات المستلمة من طرق دفع أخرى",
            RECEIVE_TC_WALLET_LIST: "قائمة المدفوعات المستلمة من محافظ TC",
            REQUEST_DETAIL: "تفاصيل الطلب",
            SEND: "إرسال",
            SETTING: "الإعدادات",
            SUPPORT: "الدعم",
            TC_ACCOUNTS: "محافظ TC",
            TC_WALLET_LIST: "قائمة طلبات المحافظ",
            TC_WALLET_SEND_LIST: "قائمة مدفوعات محفظة TC",
            TICKETS: "التذاكر",
            TRANSACTIONS: "المعاملات",
            TRANSACTIONS_LIST: "قائمة المعاملات",
            TRANSFER_INFO: 'تدريب على التحويلات',
            VOUCHER: "قسيمة",
            WALLETS: "المحافظ",
            WALLET_TC: "محفظة TC",
            WITHDRAWAL: "السحب",
            CRYPTO_LIST: 'قائمة العملات الرقمية',
            DIGITAL_CURRENCY: 'العملات الرقمية',
            CRYPTO_WITHDRAWAL_LIST: 'قائمة سحب العملات الرقمية',
            MY_REQUEST_HISTORY: 'سجل طلباتي',
            CLIENT_REQUEST_HISTORY: 'تاريخ طلبات العميل',
            SETTLEMENT_REQUEST_HISTORY: 'تاريخ طلبات التسوية',
            SEND_AFFLIATE_REQUEST: "إرسال طلب تعاون",
            INVITEE: 'برنامجي التعريفي',
            IDENTIFICATION_CODE: 'رمز التعريف',
            AFFILIATE_PROGRAM: 'برنامج التسويق بالعمولة',
            PAYMENT_GATEWAY: "بوابة الدفع",
            AFFILIATE: 'التسويق بالعمولة',
            WITHDRAWAL_BANK: 'السحب - تحويل بنكي',
            AFFILIATE_REQUEST: "إرسال طلب تعاون",
            INVITEE_ENTER_CODE: 'رمز الإحالة',
            INVITEE_INDEX: 'رمز الإحالة',
            INVITEE_HISTORY: 'سجل الاسترداد النقدي',
            CRYPTO: 'العملات الرقمية',
            MY_ADS: 'إعلاناتي',
            AUTHENTICATION: 'المصادقة',
            CHANGE_MOBILE_NUMBER: 'تغيير رقم الهاتف',
            TWO_FACTOR_AUTHENTICATION: 'المصادقة الثنائية',
            DIRECT_DEPOSIT_TITLE: 'التحويل البنكي',
            BANK_TRANSFER_PAYMENT: 'دفع التحويل البنكي',
            TRANSACTION_DETAIL: 'تفاصيل المعاملة',
            CHAT_WITH_SELLER: "محادثة مع البائع",
            CHAT_WITH_BUYER: "محادثة مع المشتري",
            DEPOSIT_OFFLINE: 'إيداع غير متصل',
            CARD_OFFLINE_DEPOSIT: 'إيداع بطاقة إلى بطاقة غير متصل',
            SOCIAL_MEDIA: 'وسائل التواصل الاجتماعي',
        },
        QUICK_ACCESS: {
            BUY_VOUCHER: "شراء قسيمة",
            CHANGE: "تغيير",
            DEPOSIT: "الإيداع",
            DEPOSIT_E_MONEY_LIST: "قائمة طلبات الأموال الإلكترونية",
            DEPOSIT_LOCAL_PAYMENT_LIST: "قائمة الطلبات المحلية",
            DEPOSIT_NEW: "إيداع جديد",
            EXCHANGE: "التبادل",
            EXCHANGE_LOCAL_PAYMENT_LIST: "قائمة التبادلات المحلية",
            EXCHANGE_NEW: "تبادل جديد",
            "EXCHANGE_NEW_E_MONEY": "تبادل أموال إلكترونية جديد",
            "EXCHANGE_NEW_LOCAL_PAYMENT": "تبادل محلي جديد",
            "E_MONEY_LIST": "قائمة طلبات الأموال الإلكترونية",
            "FAQ": "الأسئلة الشائعة",
            "FRIENDS": "الأصدقاء",
            "LIST": "القائمة",
            "LOCAL_PAYMENT_LIST": "قائمة الطلبات المحلية",
            "MY_ACCOUNTS": "حساباتي",
            "MY_FRIENDS": "أصدقائي",
            "MY_WALLETS": "محافظي",
            "NEW": "جديد",
            "NEW_BANK_ACCOUNT": "حساب بنكي جديد",
            "NEW_E_MONEY": "طلب أموال إلكترونية جديد",
            "NEW_E_MONEY_ACCOUNT": "حساب أموال إلكترونية جديد",
            "NEW_LOCAL_PAYMENT": "طلب محلي جديد",
            "NEW_TICKET": "تذكرة جديدة",
            "NEW_WALLET": "محفظة جديدة",
            "POINT": "نقطة",
            "PROFILE": "الملف الشخصي",
            "RECIEVE": "استلام",
            "RECIEVE_LOCAL_LIST": "قائمة المدفوعات المحلية المستلمة",
            "RECIEVE_TC_WALLET_LIST": "قائمة المدفوعات المستلمة من المحفظة",
            "SEND": "إرسال",
            "SEND_LOCAL_PAYMENT_LIST": "قائمة المدفوعات المحلية المرسلة",
            "SEND_NEW": "إرسال جديد",
            "SEND_TC_WALLET": "إرسال من المحفظة",
            "SEND_TC_WALLET_LIST": "قائمة المدفوعات المرسلة من المحفظة",
            "SETTING": "الإعدادات",
            "SUPPORT": "الدعم",
            "TC_ACCOUNTS": "حسابات TC",
            "TICKETS": "تذكرة",
            "TRANSACTIONS": "المعاملات",
            "VOUCHER": "قسيمة",
            "VOUCHER_LIST": "قائمة الطلبات",
            "WALLET": "المحفظة",
            "WALLET_TRANSACTIONS": "معاملات المحفظة",
            "WITHDRAWAL": "السحب",
            "WITHDRAWAL_E_MONEY_LIST": "قائمة سحوبات الأموال الإلكترونية",
            "WITHDRAWAL_LOCAL_PAYMENT_LIST": "قائمة السحوبات المحلية",
            "WITHDRAWAL_NEW": "سحب جديد",
            "WITHDRAWAL_POINT": "سحب النقاط",
            "WITHDRAWAL_POINT_LIST": "قائمة سحب النقاط",
            "WITHDRAWAL_POINT_TRANSACTIONS": "معاملات النقاط",
            "BUY": "شراء",
            "ACCOUNTS": "الحسابات",
            "CHANGE_WITH": 'استبدال "{{title}}" بـ ...',
            ALERT: {
                SAVE_CHANGE_SUCCESSFULLY: "تم حفظ التغييرات بنجاح",
            }
        },
        ANNOUNCEMENT: {
            "ACTIVE_ANNOUNCEMENTS": "الإعلانات النشطة",
            "ARCHIVE": "الأرشيف",
            "MORE": "المزيد",
            VIDEO: {
                "TITLE": "عودة التيثر إلى توب تشينج!",
                "SUBTITLE": "تغييرات صغيرة، نتائج كبيرة.",
                "TEXT": "كل قطع خدماتنا المالية أصبحت متكاملة.",
                "TEXT1": "تمتع بمعاملات أسرع وأكثر أمانًا ابتداءً من اليوم.",
                "TEXT2": "3- صفر رسوم معاملات",
                "TEXT3": "4- تحويل أسرع إلى الحساب البنكي",
                "TEXT4": "5- أمان عالي للمعاملات",
                "TEXT31": "مركز المساعدة",
                "TEXT32": "الصفحة.",
            },
            ALERT: {
                NO_CONTENT: "لا يوجد محتوى للعرض",
            }
        },
        PISHING: {
            "PISHING": "التصيد الاحتيالي",
            "IS_AN_OPERATION_OF_DECEPTION": "هو عملية خداع!",
            "PISHING_TEXT": "وفقًا للقوانين واللوائح، فإن صاحب الحساب مسؤول عن جميع المعاملات والتبادلات التي تتم عبر حسابات المواطنين وبطاقاتهم المصرفية، ولا يُقبل أي ادعاء بتأجير الحساب للجهات القانونية الضريبية أو القضائية. في حالة قيام شخص بتأجير حسابه الوطني ورمزه لشخص آخر والاحتفاظ في حسابه بأموال ناتجة عن أعمال إجرامية أو التسبب في تحويلها، فإنه بالإضافة إلى المشاركة في الجريمة الرئيسية، يتحمل عقوبة تلك الجريمة أيضًا وفقًا لقوانين مكافحة غسيل الأموال.",
        },
        EVENT: {
            "TITLE1": "ثورة العملات الرقمية في توب تشينج!",
            "DESCRIPTION1": "تحويل محافظ العملات الرقمية إلى منصة جديدة ومتخصصة تسمى Green Change",
            "DESCRIPTION2": "بيئة جديدة لتبادل العملات الرقمية تلقائيًا",
            "TITLE2": "Green Change",
            "BTN": "اضغط هنا للمزيد من المعلومات!",
            "IMG": "الأصول/الوسائط/الصور/الأحداث/",
        },
        AUTH: {
            "CONFIRM_ADDRESS": "التحقق من العنوان",
            "CONFIRM_MOBILE": "التحقق من رقم الهاتف المحمول",
            "CONFIRM_PERSONAL": "التحقق من المعلومات الشخصية",
            "CONFIRM_PICTURE": "التحقق من الصورة",
            "ERROR_404": "لم يتم العثور على الطلب",
            "ERROR_500": "حدث خطأ. يرجى إعادة تحميل الصفحة والمحاولة مرة أخرى.",
            "ACCESS_DENIED": "ليس لديك صلاحية الوصول إلى هذه الصفحة.",
            "CONNECTION_ERROR": "تم فقدان اتصال الشبكة",
            "FORGOT_PASSWORD": "نسيت كلمة المرور",
            "TC_TERMS": "شروط TC",
            "ERROR_400": "طلب غير صالح",
            "INVALID_CAPTCHA": "كود التحقق غير صحيح",
            "LOGOUT": "تسجيل الخروج",
            "NO_ACCOUNT": "ليس لديك حساب؟",
            "REQUIRED": "مطلوب",
            "RESEND_CODE": "إعادة إرسال الرمز",
            "WE_SENT_ACTIVATION_CODE_TO_PHONE": "تم إرسال رمز التحقق إلى رقم هاتفك المحمول",
            LOGIN: {
                "SUBMIT": "تسجيل الدخول",
                "TITLE": "تسجيل الدخول",
            },

            TWO_FACTOR: {
                "TITLE": "التحقق الأمني",
                "CODE": "رمز المصادقة",
                "DESCRIPTION1": "يرجى إدخال رمز المصادقة الخاص بك",
                "DESCRIPTION2": "",
                "HINT": "أدخل الرمز المكون من {{value}} أرقام من تطبيق المصادقة",
                "SUBMIT": "إرسال",
                "VALIDATION_CODE": "يرجى إدخال رمز المصادقة",
            },

            RECOVER: {
                "CONFIRM_PASS": "إعادة تعيين كلمة المرور",
                "DESC1": "إذا كنت قد نسيت كلمة المرور",
                "DESC2": "يمكنك استعادتها عبر البريد الإلكتروني أو الرسائل القصيرة",
                "EMAIL": "البريد الإلكتروني",
                "PASS_NOT_SAME": "يجب أن تكون كلمة المرور المكررة مطابقة لكلمة المرور",
                "SMS": "رسائل قصيرة (SMS)",
                "TITLE": "استعادة كلمة المرور",
                BY_EMAIL: {
                    "CODE_SENT": "تم إرسال رمز التحقق إلى بريدك الإلكتروني",
                    "HINT": "يرجى إدخال رمز التحقق الذي تم إرساله إلى بريدك الإلكتروني",
                    "SPAM_HINT": "يرجى التحقق من مجلد البريد العشوائي إذا لم تستلم الرمز في صندوق الوارد الخاص بك",
                },
                BY_SMS: {
                    "CODE_SENT": "تم إرسال رمز التحقق إلى رقم هاتفك المحمول",
                    "HINT": "يرجى إدخال رمز الرسائل القصيرة (SMS)",
                },
                SUCCESS: {
                    "DESC": "يمكنك الآن تسجيل الدخول إلى حسابك",
                    "GO_TO_LOGIN": "العودة إلى صفحة تسجيل الدخول",
                    "TITLE": "تم تغيير كلمة المرور بنجاح",
                }


            },
            REGISTER: {
                "ALREADY_HAVE_ACCOUNT": "هل لديك حساب بالفعل؟",
                "CODE": "رمز التحقق",
                "DESC": "الوصف",
                "ENTER_EMAIL": "يرجى إدخال بريدك الإلكتروني",
                "LOGIN": "تسجيل الدخول",
                "PLEASE_COMPLETE_YOUR_FORM": "يرجى إكمال النموذج أدناه",
                "SENT_EMAIL_TEXT": "تم إرسال بريد إلكتروني يحتوي على رمز مكون من {{value}} أرقام إليك",
                "SENT_SMS_TEXT": "تم إرسال رسالة نصية قصيرة تحتوي على رمز مكون من {{value}} أرقام إليك",
                "SUBMIT_CONFIRM_EMAIL": "تأكيد",
                "SUBMIT_EMAIL": "إدخال",
                "SUBMIT_FORM": "إنشاء حساب",
                "TITLE": "تسجيل",
                "YOUR_EMAIL": "بريدك الإلكتروني",
                SUCCESS: {
                    "DESC": "يمكنك الآن تسجيل الدخول إلى حسابك",
                    "GO_TO_LOGIN": "تسجيل الدخول إلى الحساب",
                    "TITLE": "تم إكمال التسجيل بنجاح",
                }
            },
            INPUT: {
                "COUNTRY": "الدولة",
                "EMAIL": "البريد الإلكتروني",
                "FIRSTNAME": "الاسم",
                "FULLNAME": "الاسم الكامل",
                "GENDER": "الجنس",
                "I_ACCEPT": "قبول",
                "LASTNAME": "اسم العائلة",
                "NEW_CONFIRM_PASS": "تأكيد كلمة المرور الجديدة",
                "NEW_PASSWORD": "كلمة المرور الجديدة",
                "PASSWORD": "كلمة المرور",
                "PHONE": "رقم الهاتف المحمول",
                "TC_TERM": "الشروط والأحكام الخاصة بـ TC",
                "USERNAME": "اسم المستخدم",
            },
            VALIDATION: {
                INVALID_EMAIL: "البريد الإلكتروني المدخل غير صالح",
                PASSWORD: {
                    COUNT_CHARACTER: "8-32 حرفًا",
                    UPPERCASE_LETTER: "يجب أن تحتوي على حرف كبير واحد على الأقل [A-Z]",
                    HAS_NUMBER: "يجب أن تحتوي على رقم واحد على الأقل [0-9]",
                }
            }
        },
        NEW_AUTH: {
            "WELOCOME": "مرحبًا بك في TopChange",
            "ENTER_EMAIL": "يرجى إدخال بريدك الإلكتروني",
            "ENTER_VALID_EMAIL": "يرجى إدخال بريد إلكتروني صالح!",
            "CONTINUE": "متابعة",
            "CONFIRM_CODE": "رمز التأكيد",
            "ENTER_CODE_SENT": "يرجى إدخال الرمز المرسل إلى {{value}}",
            "CHECK_SPAM": "(تحقق أيضًا من مجلد البريد العشوائي)",
            "CONFIRM": "تأكيد",
            VERIFY: "تحقق",
            "INCORRECT_CODE": "الرمز المدخل غير صحيح",
            "RESEND": "إعادة الإرسال",
            "REGISTER": "تسجيل",
            "REGISTRATION": "التسجيل",
            "SET_PASSWORD": "يرجى تعيين كلمة مرور آمنة لحسابك",
            "PASSWORD": "كلمة المرور",
            "REPEAT_PASSWORD": "إعادة إدخال كلمة المرور",
            "MORE_THAN_8": "أكثر من 8 أحرف",
            "NUMBERS": "أرقام أو رموز",
            "UPPERCASE": "حرف كبير",
            "REFERRAL_CODE": "رمز الإحالة",
            "OPTIONAL": "(اختياري)",
            "PASSWORDS_NOT_MATCH": "كلمات المرور غير متطابقة",
            "TERMS": '<span>لقد قرأت وأوافق على</span><span class="role-text">الشروط والأحكام.</span>',
            "LOGIN": "تسجيل الدخول",
            "ENTER_EMAIL_PASSWORD": "يرجى إدخال بريدك الإلكتروني وكلمة المرور",
            "FORGET_PASSWORD": "نسيت كلمة المرور",
            "AUTHENTICATOR_CODE": "التحقق بخطوتين (2FA)",
            "ENTER_AUTHENTICATOR_CODE": "أدخل رمز التحقق المرسل إلى تطبيق المصادقة الخاص بك",
            "DONT_ACCESS_CODE": "ليس لديك وصول إلى الرمز؟",
            "REMOVE_TWO_FACTOR": "يرجى التواصل مع الدعم لإزالة رمز المصادقة الثنائية",
            "ONLINE_SUPPORT": "الدعم عبر الإنترنت",
            "SEND_CODE": "إرسال الرمز",
            SEND_CODE_AGAIN: "إعادة إرسال الرمز",
            TC_TERMS: "شروط وأحكام TC",
            VALIDATION: {
                MIN_LENGTH: "يجب أن يكون {{name}} مكونًا من {{value}} أرقام",
                MAX_LENGTH: "يجب أن يكون {{name}} مكونًا من {{value}} أرقام",
            },
            FORGET_PASSWORD_PAGE: {
                TITLE: "نسيت كلمة المرور",
                SUBTITLE: "يرجى إدخال بريدك الإلكتروني لاستعادة كلمة المرور.",
                ENTER_CODE_SENT: "يرجى إدخال الرمز المرسل إلى <span>{{value}}</span>.",
                VALIDATION: {
                    EMAIL_FORMAT: "يرجى إدخال البريد الإلكتروني بشكل صحيح!",
                },
                RESET_PASSWORD: {
                    TITLE: "كلمة المرور الجديدة",
                    SUBTITLE: "يرجى تعيين كلمة مرور جديدة لحسابك.",
                    CHANGE_PASSWORD: "تغيير كلمة المرور",
                },
                ALERT: {
                    SUCCESS_CHANGE_PASS_TITLE: "تم تغيير كلمة المرور بنجاح!",
                    SUCCESS_CHANGE_PASS_DESCRIPTION: "يرجى تسجيل الدخول مرة أخرى للوصول إلى حسابك.",
                }
            },
            ALERT_TERMS: {
                "TITLE": "تنبيه",
                "DESC": "يرجى قراءة شروط الاستخدام هذه بعناية. بالوصول إلى هذا الموقع وأي صفحة من صفحاته، فإنك توافق على الالتزام بشروط الاستخدام أدناه. إذا كنت لا توافق على شروط الاستخدام أدناه، فلا تدخل إلى هذا الموقع أو أي من صفحاته."
            },
            TERMS_RULES: {
                "VISITOR_RESPONSIBILITY": {
                    "TITLE": "مسؤولية الزوار",
                    "DESC": "المعلومات الواردة في هذا الموقع والخدمات المقدمة هنا ليست مخصصة للتوزيع أو الاستخدام من قبل أي شخص في أي دولة أو ولاية قضائية حيث يكون هذا التوزيع أو الاستخدام مخالفاً للقانون أو اللوائح المحلية. لا تتوفر أي من خدمات TopChange للأشخاص المقيمين في أي دولة حيث يكون تقديم هذه الخدمات مخالفاً للقانون أو اللوائح المحلية. تقع على عاتق زوار هذا الموقع مسؤولية التحقق من الشروط والامتثال لأي قانون أو لائحة محلية يخضعون لها."
                },
                "SCOPE_OF_SERVICES": {
                    "TITLE": "نطاق الخدمات",
                    "DESC": "يُدار هذا الموقع من قبل TopChange (الاسم المختصر - TC). TopChange ليست مشغل نقود إلكترونية ولا مزود خدمات دفع. توفر TopChange لزوار هذا الموقع خدمات معلوماتية لتسهيل شراء أو بيع النقود الإلكترونية والقسائم الإلكترونية لأشهر شركات الدفع العالمية وإجراء الدفعات المسبقة للسلع والخدمات التي يشتريها الزوار عبر الإنترنت."
                },
                "REGISTER": {
                    "TITLE": "التسجيل",
                    "DESC": "للتسجيل في موقع TC، يجب على الزوار تقديم المعلومات الشخصية التالية: الاسم الحقيقي واللقب؛ البريد الإلكتروني؛ رقم الهاتف؛ عنوان الإقامة؛ تاريخ الميلاد؛ بطاقة الهوية الشخصية (أو جواز السفر الوطني أو جواز السفر للسفر الخارجي أو رخصة القيادة)؛ صورة سيلفي مع بطاقة الهوية. تتحقق TC من المعلومات الشخصية باستخدام أي طرق تحقق متاحة. تتمتع محفظة TC للزائر بوظائف محدودة حتى يتم التحقق من جميع المعلومات."
                },
                "EXCLUSION_OF_WARRANTIES": {
                    "TITLE": "إخلاء مسؤولية الضمانات",
                    "DESC": "لا تقدم TC أي ضمانات صريحة أو ضمنية بشأن موقع TC. يُتاح موقع TC لزواره \"كما هو\" و\"كما هو متاح\" ولا تضمن TC تصحيح أي عيوب أو أخطاء. لا تضمن TC أن موقع TC سيلبي احتياجاتك، أو أنه سيكون غير منقطع أو في الوقت المناسب أو آمناً أو خالياً من الأخطاء."
                },
                "DISCLAIMER": {
                    "TITLE": "إخلاء المسؤولية وتحديدها",
                    "DESC": "في أقصى حد يسمح به القانون، لن تكون TC مسؤولة عن أي أضرار تبعية أو عرضية أو خاصة أو مباشرة أو غير مباشرة. باستثناء ما يقتضيه القانون، لن تكون TC مسؤولة عن أي خسارة ناتجة عن سبب لا تملك TC سيطرة مباشرة عليه. يشمل ذلك تعطل المعدات، والوصول غير المصرح به، والفيروسات، والسرقة، وأخطاء المشغل، والحريق، والحرب، والوباء، والتمرد، والأعمال الإرهابية، وأعمال الشغب، والحوادث وإجراءات الحكومة."
                },
                "INDEMNIFICATION": {
                    "TITLE": "التعويض",
                    "DESC": "كشرط لاستخدامك لموقع TC، فإنك توافق على تعويض TC ومزودي محتوى الطرف الثالث التابعين لها وإبراء ذمتهم من أي وجميع المطالبات والخسائر والمسؤوليات والتكاليف والمصروفات (بما في ذلك أتعاب المحامين) الناشئة عن استخدامك لموقع TC أو عن انتهاكك لشروط الاستخدام هذه."
                },
                "CONFIDENTIALITY": {
                    "TITLE": "السرية",
                    "DESC": "يقع على عاتقك الالتزام بالحفاظ على سرية أرقام محافظ TC وكلمات المرور. تقر وتوافق على أن أي تعليمات أو اتصالات تُنقل إليك أو نيابة عنك عبر أي موقع TC تتم على مسؤوليتك الخاصة. تقر وتوافق على أن TC مخولة بالاعتماد على رقم محفظتك وكلمة المرور للتعرف عليك وتوافق على عدم الإفصاح عن هذه المعلومات لأي شخص غير مفوض."
                },
                "TERMINATION": {
                    "TITLE": "الإنهاء",
                    "DESC": "تحتفظ TC بالحق في إنهاء استخدامك لهذا الموقع في أي وقت ولأي سبب، مع أو بدون سبب ودون إشعار مسبق."
                },
                "SEVERABILITY": {
                    "TITLE": "قابلية الفصل",
                    "DESC": "إذا اعتُبر لأي سبب أي حكم من أحكام شروط الاستخدام هذه غير صالح أو غير قابل للتنفيذ، فسيتم تطبيق هذا الحكم إلى أقصى حد مسموح به، وستظل الأحكام المتبقية سارية المفعول بالكامل."
                }
            }
        },
        SETTING: {
            "AUTO_CHANGES": "تغييرات النظام",
            "AUTHENTICATOR": "المصادقة",
            "BETWEEN_MY_WALLETS": "التحويل بين المحافظ",
            "DASHBOARD": "لوحة التحكم",
            "DEFAULT_LANGUAGE": "اللغة الافتراضية",
            "DISABLED": "غير نشط",
            "EMAIL": "البريد الإلكتروني",
            "EXCHANGE": "التبادل",
            "EXPERT_MESSAGES": "رسائل الدعم",
            "EXPERT_OR_FRIENDS_CHANGES": "تغييرات الأصدقاء أو المسؤولين",
            "FRIEND": "الأصدقاء",
            "FRIENDS": "الأصدقاء",
            "GENERAL_TEXT": "عام",
            "INTERNAL_TRANSFER": "التحويل الداخلي",
            "LOCAL": "محلي",
            "LOGIN": "تسجيل الدخول",
            "MESSAGE": "الرسائل",
            "MY_CHANGES": "تغييراتي",
            "NOTIFY_SYSTEM": "إشعارات النظام",
            "NOTIFY_SYSTEM_SETTING": "إشعارات النظام",
            "PAYMENTS": "المدفوعات",
            "PAYMENT_GATEWAY": "بوابة الدفع",
            "POINT": "سحب النقاط",
            "POINT_CHANGE": "تغيير النقاط",
            "POINT_WITHDRAWAL": "سحب النقاط",
            "POSSIBLE_TO_HAVE_SECURITY_CODE": "يجب إدخال رمز التحقق المرسل إلى بريدك الإلكتروني لحفظ التغييرات.",
            "QUICK_ACCESS": "الوصول السريع",
            "RECEIVE": "استلام",
            "REQUESTS": "الطلبات",
            "REQUEST_MESSAGE": "رسالة الطلب",
            "REQUEST_PAYMENT": "المدفوعات",
            "REQUEST_SECURITY": "الأمان",
            "REQUEST_SECURITY_SETTING": "الأمان",
            "SECURITY_SETTING": "إعدادات الأمان",
            "SEND": "إرسال",
            "SEND_CONFIRMATION_CODE": "إرسال رمز التحقق",
            "SERVICE": "الأموال الإلكترونية",
            "SETTING_GENERAL": "عام",
            "SETTING_REQUEST_SECURITY": "الأمان",
            "SMS": "رسائل قصيرة (SMS)",
            "SMS_CREDIT_CHANGE": "صلاحية تغيير لوحة التحكم بالرسائل القصيرة",
            "TICKET": "تذكرة",
            "TIME_ZONE": "الوقت المحلي",
            "TITLE": "الإعدادات",
            "VERIFIED": "التحقق",
            "VERIFY_BANK_ACCOUNT": "التحقق من الحساب البنكي",
            "VERIFY_INFO": "التحقق من المعلومات",
            "VERIFY_INFORMATION": "التحقق من المعلومات",
            "VOUCHER": "قسيمة",
            "WALLET_CHANGE": "تغيير المحفظة",
            "DISPLAY_LANGUAGE": "لغة العرض",
            "DISPLAY_LANGUAGE_DESCRIPTION": "سيظهر الموقع باللغة المحددة",
            "NOTIFICATION_LANGUAGE": "لغة الإشعارات",
            "NOTIFICATION_LANGUAGE_DESCRIPTION": "ستظهر الإشعارات باللغة المحددة",
            "TIME_ZONE_DESCRIPTION": "سيظهر التوقيت الزمني باللغة المحددة",
            "PLEASE_CONFIGURE_AUTHENTICATOR": "يرجى تفعيل المصادقة الثنائية (2FA) أولاً",
            GENERAL: {},
            OFF: "إيقاف",
            ON: "تشغيل",
            ENABLE: "تمكين",
            CHANGE: "تغيير",
            REMOVE: "إزالة",
            SECURITY: "الأمان",
            ADVANCED_SECURITY: "الأمان المتقدم",
            ANTI_PHISHING_CODE: "رمز الحماية من التصيد الاحتيالي",
            NOTIFICATION: {},
            USER_QUICK_ACCESS: {},
            ANTI_PHISHING_DES: "احمِ حسابك من محاولات التصيد وتأكد من أن رسائل الإشعارات تصلك فقط من TopChange.",
            P2P: 'P2P',
            TWO_FACTOR_AUTHENTICATION: {
                "TWO_FACTOR_AUTHENTICATION": "المصادقة الثنائية",
                "AUTHENTICATION": "المصادقة",
                "PROTECT_YOUR_ACCOUNT_AND_TRANSACTION": "احمِ حسابك ومعاملاتك عند تسجيل الدخول وإجراء الطلبات",
                "HAVING_TROUBLE": "هل تواجه مشكلة؟",
                "ENABLE_GOOGLE_AUTHENTICATOR": "تمكين المصادقة",
                "CHANGE_GOOGLE_AUTHENTICATOR": "تغيير المصادقة",
                "DOWNLOAD_APP": "تحميل التطبيق",
                "DOWNLOAD_APP_DESC": "استخدم تطبيقًا على هاتفك للحصول على رموز المصادقة الثنائية عند الطلب. نوصي باستخدام تطبيقات TOTP المستندة إلى السحابة مثل: Google Authenticator, 1Password, Authy, LastPass Authenticator, Microsoft Authenticator. يمكنك تنزيل Google Authenticator من الرابط أدناه:",
                "SCAN_QR_CODE": "مسح رمز الاستجابة السريعة",
                "SCAN_QR_CODE_DESC": "امسح رمز الاستجابة السريعة هذا في تطبيق المصادقة",
                "SCAN_QR_CODE_CHANGE_DESC": "اختر المحفظة التي ترغب في شحنها",
                "SCAN_QR_CODE_DESC_MANUAL": "إذا لم تتمكن من مسح رمز الاستجابة السريعة، يرجى إدخال هذا الرمز يدويًا في التطبيق.",
                "BACKUP_KEY": "مفتاح النسخ الاحتياطي",
                "BACKUP_NEW_KEY": "مفتاح نسخ احتياطي جديد",
                "BACKUP_KEY_DESC": "احفظ هذا المفتاح الاحتياطي في مكان آمن",
                "BACKUP_KEY_DESC_MANUAL": "سيسمح لك هذا المفتاح باستعادة المصادقة الثنائية في حال فقدان هاتفك. وإلا، فإعادة ضبط تطبيق المصادقة ستستغرق سبعة أيام على الأقل.",
                "ENABLE_DESC": "قم بتمكين المصادقة عن طريق التحقق من حسابك",
                "ENABLE_NEW_AUTH": "تمكين مصادقة جديدة",
                "ENABLE_NEW_AUTH_DESC": "يرجى إدخال رموز التحقق لتفعيل المصادقة الجديدة",
                "COMPLETE": "إكمال",
                "DONE": "تم",
                "ENABLE": "تمكين",
                "ALERT_SUCCESS_ENABLE": "تم تمكين المصادقة بنجاح لحماية حسابك.",
                "ALERT_SUCCESS_CHANGE": "يمكنك الآن استخدام المصادقة الجديدة لتسجيل الدخول.",
                "DOWNLOAD_FROM": "تحميل النموذج",
                "LABEL_VERIFY_CODE": "رمز التحقق عبر البريد الإلكتروني",
                "LABEL_TOTP_CODE": "رمز المصادقة الثنائية",
                HINT_TOTP_CODE: "يرجى إدخال رمز التحقق بخطوتين المكوَّن من 6 أرقام.",

                /*  HINT_VERIFY_CODE: 'Enter the {{codeLength}} digit code sent to {{email}}.', */
                "HINT_VERIFY_CODE": "يرجى التحقق من مجلد البريد العشوائي إذا لم تستلم الرمز في صندوق الوارد الخاص بك.",
                "COPIED_SUCCESSFULLY": "تم النسخ بنجاح",
                "REMOVE_CURRENT": "إزالة الحالي",
                "REMOVE_CURRENT_AUTH": "إزالة المصادقة الحالية",
                "REMOVE_CURRENT_AUTH_DESC": "إزالة المصادقة الحالية عن طريق التحقق من هويتك",
                "VERIFY_CHANGE": "تحقق",
                "VERIFY_CHANGE_TITLE": "التحقق من المصادقة الحالية",
                "VERIFY_CHANGE_DESC": "لتغيير المصادقة الحالية، تحقق من هويتك.",
                "BACK_TO_SECURITY": "العودة إلى الأمان",
                "ARE_U_SURE": "هل أنت متأكد من أنك تريد إزالة Google Authenticator؟",
                "REQUESTE_DISABLE": "سيتم تعطيل الطلبات التي تستخدم ”App Authenticator“ للمصادقة بعد تعطيل هذه الطريقة.",
                "DELETING_APP": "إزالة تطبيق المصادقة سيقلل من أمان حسابك.",
                "REMOVE_GOOGLE_AUTHENTICATOR": "إزالة المصادقة",
                "OFF": "إيقاف",
                "ON": "تشغيل",
                ALERT: {
                    GOOGLE_AUTHENTICATOR_SUCCESSFULLY_REMOVED: "تمت إزالة المصادقة عبر Google بنجاح!",
                }
            },
            ANTI_PHISHING: {
                "ENABLE_ANTI_PHISHING_CODE": "تمكين رمز مكافحة التصيد الاحتيالي",
                "WHAT_IS_IT": "ما هو رمز مكافحة التصيد الاحتيالي؟",
                "WHAT_IS_IT_ANS": "رمز مكافحة التصيد الاحتيالي هو رمز يساعد في منع محاولات التصيد من مواقع ويب أو عناوين بريد إلكتروني مزيفة تدّعي أنها TopChange.",
                "HOW_DOES_IT_WORK": "كيف يعمل؟",
                "HOW_DOES_IT_WORK_ANS": "بمجرد تعيين رمز مكافحة التصيد الفريد الخاص بك، سيتم تضمينه في جميع رسائل البريد الإلكتروني الحقيقية من TopChange.",
                "ANTI_PISHING_CODE": "رمز مكافحة التصيد الاحتيالي",
                "CREAT_ANTI_PISHING_CODE": "إنشاء رمز مكافحة التصيد الاحتيالي",
                "CHANGE_ANTI_PISHING_CODE": "تغيير رمز مكافحة التصيد الاحتيالي",
                "SHOW_ANTI_PISHING_CODE": "عرض رمز مكافحة التصيد الاحتيالي",
                "PLZ_ENTER_CODE": "يرجى إدخال من 4 إلى 20 حرفًا غير خاصة",
                "SECURITY_VERIFICATION": "التحقق الأمني",
                "ENTER_SIX_DIGIT_FROM_APP": "أدخل رمزًا مكونًا من 6 أرقام من تطبيق المصادقة",
                "TO_SECURE_YOUR_ACCOUNT_PLZ_COMPLETE_FLOWING_VERIFICATION": "لتأمين حسابك، يرجى إكمال عملية التحقق التالية.",
                "ANTI_PHISHING_CODE": "كود مكافحة التصيد الاحتيالي",
                "OLD_ANTI_PHISHING_CODE": "رمز مكافحة التصيد الاحتيالي القديم",
                "CHANGE_CODE": "تغيير الرمز",
                "AUTHENTICATOR_CODE": "رمز المصادقة",
            },
            ALERT: {
                "CHANGES_SAVED_SUCCESSFULLY": "تم حفظ التغييرات بنجاح.",
                "ENTER_CODE_THAT_SENT_TO_EMAIL_AND_PASSWORD": "أدخل الرمز المكون من {{codeLength}} أرقام المرسل إلى {{email}} و{{phone}}.",
            }
        },
        FRIENDS: {
            "ACCEPT": "قبول",
            "ADD_FRIEND": "إضافة صديق",
            "ALERT_DELETE": "هل أنت متأكد من حذف هذا المستخدم من قائمة أصدقائك؟",
            "BLOCK": "حظر",
            "BLOCKED_USER": "محظور",
            "DEPOSIT": "إيداع الحساب",
            "FRIEND": "صديق",
            "FRIENDS_REQUEST": "طلبات الصداقة",
            "MORE": "عرض المزيد",
            "MY_FRIENDS": "أصدقائي",
            "REJECT": "رفض",
            "SEND": "إرسال",
            "SEND_FRIEND_REQUEST": "إرسال طلب صداقة",
            "SEND_FRIEND_REQUEST_HINT": "أدخل البريد الإلكتروني للمستخدم لإرسال طلب صداقة. إذا غادر المستخدم، سيتم إرسال طلب صداقة إليه مرة أخرى.",
            "SEND_REQUEST": "إرسال طلب",
            "SENT_REQUEST": "تم إرسال الطلبات",
            "UNBLOCK": "إلغاء الحظر",
            "UNFRIEND": "إلغاء الصداقة",
            "WALLETS": "المحافظ",
            ALERT: {
                "CONFIRM_DELETE_REQUEST": "هل أنت متأكد من حذف هذا الطلب؟",
                "CONFIRM_REJECT_REQUEST": "هل أنت متأكد من رفض هذا الطلب؟",
                "REQUEST_SENT_SUCCESSFULLY": "تم إرسال طلب الصداقة بنجاح",
                "REQUEST_SENT_USER_NOT_FOUND": "المستخدم غير موجود في النظام. تمت دعوتهم عبر البريد الإلكتروني",
                "SUCCECC_ACCEPT": "تم قبول طلب الصداقة",
                "SUCCECC_BLOCK": "تم حظر المستخدم",
                "SUCCECC_DELETE": "تم حذف طلب الصداقة",
                "SUCCECC_DELETE_FIREND": "تمت إزالة المستخدم من قائمة أصدقائك",
                "SUCCECC_REJECT": "تم رفض طلب الصداقة",
            }
        },
        ACCOUNTS: {
            "ACCOUNT": "الحساب",
            "ACCOUNTS": "الحسابات",
            "ACCOUNTS_INFORMATION": "معلومات الحساب",
            "ACCOUNT_NO": "رقم الحساب",
            "ACCOUNT_NUMBER": "رقم الحساب",
            "ACCOUNT_OWNERS_NAME": "اسم مالك الحساب",
            "ADD_BANK_ACCOUNT": "حساب بنكي جديد",
            "TAG": "تصنيف",
            "BANK": "البنك",
            "BANKS": "البنوك",
            "SELECT_BANK": "اختيار البنك",
            "BANK_ADDRESS": "عنوان البنك",
            "BANK_NAME": "اسم البنك",
            "BRANCH_CODE": "رمز الفرع",
            "CARD_NO": "رقم البطاقة",
            "CARD_NUMBER": "رقم البطاقة",
            "EDIT_BANK_ACCOUNT": "تعديل الحساب البنكي",
            "EDIT_SERVICE_ACCOUNT": "تعديل حساب الأموال الإلكترونية",
            "IBAN_NUMBER": "رقم الآيبان",
            "MY_ACCOUNT": "حسابي",
            "NEW_BANKS": "حساب بنكي جديد",
            "NEW_SERVICE": "حساب أموال إلكترونية جديد",
            "NEW_SERVICE_ACCOUNT": "حساب أموال إلكترونية جديد",
            "OWNER": "مالك الحساب",
            "SERVICE": "الأموال الإلكترونية",
            "SERVICES": "الأموال الإلكترونية",
            "SWIFT_CODE": "رمز السويفت",
            "TC_ACCOUNT": "حساب TC",
            "TC_BANK_ACCOUNT": "حساب البنك TC",
            "CRYPTO": "العملات الرقمية",
            "NEW_CRYPTO": "حساب عملات رقمية جديد",
            "EDIT_CRYPTO_ACCOUNT": "تعديل حساب العملات الرقمية",
            "BANK_ACCOUNT_LIST": "قائمة الحسابات البنكية",
            "CRYPTO_ACCOUNT_LIST": "قائمة حسابات العملات الرقمية",
            "EMONEY_ACCOUNT_LIST": "قائمة حسابات الأموال الإلكترونية",
            "REJECTED_TITLE": "معلومات غير صالحة!",
            "REJECTED_TEXT": "يرجى إدخال تفاصيل الحساب للمراجعة والتعديل.",
            "BANK_IS_NOT_VALID": "يرجى اختيار البنك من الخيارات في القائمة",
            "CARD_NUMBER_IS_NOT_VALID": "رقم البطاقة غير صالح",
            "CARD_NUMBER_NOT_SUPPORTED": "رقم البطاقة المدخل غير مدعوم",
            "ENTER_RELATED_CARD_NUMBER": "يرجى إدخال رقم بطاقة {{bankName}}",
            "YOU_DONT_HAVE_ENOUGH_BANK_ACCOUNT_Q": "ليس لديك حساب بنكي كافٍ؟",
            "YOU_DONT_HAVE_ENOUGH_BANK_ACCOUNT": "ليس لديك حساب بنكي كافٍ",
            "FIRST_REGISTER_NEW_BANK_ACCOUNT": "قم أولاً بتسجيل حساب بنكي جديد.",
            "THEN_REGISTER_YOUR_WITHDRAWAL_REQUEST_FROM_BEGINNING": "ثم قم بتسجيل طلب السحب الخاص بك",
            "REGISTER_FROM_BEGINNING": "من البداية.",
            "BANK_ACCOUNT": "الحساب البنكي",
            "ADD_ACOUNT": "إضافة حساب",
            "TOTAL_RECEIVED": "إجمالي المستلم",
            "UN_ACCEPTABLE_BANK_HINT": "تجنب تسجيل حسابات المؤسسات المالية.",
            ALERT: {
                "ACCOUNT_INFO_COPIED": "تم نسخ معلومات الحساب إلى الحافظة",
                "ADD_BANK_ACCOUNT": "إضافة حساب بنكي",
                "ADD_SERVICE_ACCOUNT": "إضافة حساب أموال إلكترونية",
                "ADD_SUCCESS": "تم حفظ معلومات الحساب بنجاح. \n انتظر تأكيد المعلومات",
                "ADD_SUCCESS_EMONEY": "تم حفظ معلومات الحساب بنجاح.",
                "BANK_ACCOUNT_IS_PENDING": "سيتم التحقق من حسابك من قبل الخبراء بعد المراجعة.",
                "DELETE_BANK": "هل أنت متأكد من حذف هذا الحساب البنكي؟",
                "DELETE_SERVICE": "هل أنت متأكد من حذف هذا الحساب الإلكتروني؟",
                "DELETE_SUCCESS": "تم حذف الحساب بنجاح",
                "EDIT_SUCCESS": "تم تعديل معلومات الحساب بنجاح. \n انتظر تأكيد المعلومات.",
                "EDIT_SUCCESS_EMONEY": "تم تعديل معلومات الحساب بنجاح.",
                "VERIFY_NEEDS": "لم يتم التحقق من معلوماتك الشخصية.",
                "VERIFY_TIME_INFO": "سيتم التحقق من هذا الحساب تلقائيًا بعد الطلب الأول الناجح",
                "YOUR_SERVICE_ACCOUNT_IS_EMPTY": "لم يتم تسجيل حساب الأموال الإلكترونية.",
                "YOUR_CRYPTO_ACCOUNT_IS_EMPTY": "حساب العملات الرقمية فارغ، يرجى إضافة رقم الحساب الخاص بك.",
                "ADD_CRYPTO_ACCOUNT": "إضافة حساب عملات رقمية",
                "YOUR_BANK_ACCOUNT_IS_EMPTY": "لا يوجد حساب بنكي مسجل.",
                "FOR_ADD_BANK_ACCOUNT": "لإضافة حساب بنكي جديد",
                "UN_ACCEPTABLE_BANK": "عزيزي المستخدم، الحسابات البنكية من Saman Blue Bank Kosar melal and Noor Financial Institution غير معتمدة. يرجى الامتناع عن تسجيل معلومات حسابات هذه البنوك.",
                "IBAN_NUBER_IS_NOT_FOR_THIS_BANK": "رقم الآيبان المدخل لا يتطابق مع البنك المحدد.",
            }
        },
        TICKETS: {
            "ATTACHMENT": "إرفاق ملف",
            "DEPARTMENT": "القسم",
            "I_HAVE_TRACKING_NUMBER": "لدي رقم تذكرة",
            "LOCK_MESSAGE": "تم قفل محفظتك. لمزيد من المعلومات، يرجى إرسال تذكرة إلينا.",
            "MESSAGE": "الرسائل",
            "NEW_TICKET": "تذكرة جديدة",
            "PRIORITY": "الأولوية",
            "SUBJECT": "الموضوع",
            "TEXT": "ملاحظة",
            "TICKET_NO": "رقم التذكرة",
            "TICKET_NUMBER": "رقم التذكرة",
            "TICKET_STATE": "الحالة",
            ALERT: {
                "ADD_RATE_SUCCESS": "تم تقديم نقطتك بنجاح في النظام.",
                "ADD_SUCCESS": "تم تقديم تذكرتك بنجاح.",
                "CLOSED_BEFORE": "لقد أغلقت هذه التذكرة بالفعل.",
                "CLOSE_CONFIRM": "هل أنت متأكد أنك تريد إغلاق هذه التذكرة؟",
                "CLOSE_SUCCESS": "تم إغلاق التذكرة بنجاح.",
                "NOT_FOUND": "لم يتم العثور على التذكرة المطلوبة.",
                "SEND_MESSAGE_TO_OPEN_TICKETS": "لإعادة فتح التذكرة، تحتاج إلى إرسال رسالة.",
                "TICKET_HAS_BEEN_ARCHIVED": "تمت أرشفة هذه التذكرة ولا يمكن الرد عليها",
                "TICKET_HAS_BEEN_CLOSED": "تم إغلاق هذه التذكرة ولا يمكن الرد عليها",
                "TICKET_REPLY_SUCCESS": "تم إرسال رسالتك بنجاح.",
            }
        },
        FAQ: {
            "ASK_QUESTION": "طرح سؤال",
            "BROWSE_TOPICS": "الموضوعات الرئيسية",
            "FREQUENTLY_QUESTIONS": "الأسئلة الشائعة",
            "HOW_CAN_HELP": "مرحبًا، كيف يمكنني مساعدتك؟",
        },
        REQUEST: {
            "ACCEPT_ABOVE_INFO": "أوافق على دقة المعلومات المذكورة أعلاه.",
            "ACCOUNT_INFO": "معلومات الحساب",
            "AMOUNT": "مبلغ التعبئة",
            "ARCHIVE": "الأرشيف",
            "ARCHIVE_DATE": "تاريخ الأرشيف",
            "BALANCE": "الرصيد",
            "BANK": "البنك",
            "BONUS": "المكافأة",
            "BONUS_FIXED_AMOUNT": "المبلغ الثابت",
            "BUY_AMOUNT": "مبلغ الشراء",
            "CALCULATED_AMOUNT_ALONE": "المبلغ المحسوب",
            "CALCULATED_AMOUNT_BUNOS": "المبلغ مع المكافأة",
            "CHANGE_STATE": "تغيير الحالة",
            "CHANGE_STATUS_DATE": "تاريخ تغيير الحالة",
            "CHARGE_AMOUNT": "مبلغ التعبئة",
            "COMMISION": "العمولة",
            "DATE": "التاريخ",
            "DECIMAL_SCALE": "النطاق العشري",
            "DEPOSIT_INFORMATION": "معلومات الدفع",
            "DEPOSIT_PAYMENT_TYPE": "نوع الدفع للإيداع",
            "DETAIL": "التفاصيل",
            "DIGITAL_CURRENCY": "العملة الرقمية",
            "DONT_HAVE_WALLET_NUMBER": "ليس لدي رقم المحفظة.",
            "ELECTROINC_MONEY": "الأموال الإلكترونية",
            "ELECTRONIC_MONEY": "الأموال الإلكترونية",
            "ELECTRONIC_MONEY_NAME": "اسم الأموال الإلكترونية",
            "CRYPTO_NAME": "اسم العملة الرقمية",
            "CRYPTOCURRENCY": "العملة الرقمية",
            "ELECTRONIC_MONEY_PAYMENT": "دفع الأموال الإلكترونية",
            "END": "إنهاء",
            "EXCHANGE_RATE": "سعر الصرف",
            "EXCHANGE_TEXT": "التحويل",
            "EXCHANGE_TYPE": "نوع التبادل",
            "EXPERT_DESCRIPTION": "ملاحظة الخبراء",
            "FRIEND": "الصديق",
            "FROM_WALLET": "من المحفظة",
            "GET": "استلام",
            "GET_AMOUNT": "المبلغ المستلم",
            "GET_SERVICE": "خدمة استلام الأموال الإلكترونية",
            "INITIAL_COST": "التكلفة الأولية",
            "LOCAL_PAYMENT": "الدفع المحلي",
            "LOCATION": "موقع التسليم",
            "MAXIMUM_COMMISION": "العمولة القصوى",
            "MAXIMUM_BONUS": "المكافأة القصوى",
            "MAX_AMOUNT": "المبلغ الأقصى",
            "MESSAGE_PLACE_HOLDER": "إرسال رسالتك",
            "MINIMUM_COMMISION": "العمولة الدنيا",
            "MIN_AMOUNT": "المبلغ الأدنى",
            "MONEY_CURRENCY": "الدفع المحلي",
            "MORE_INFO": "مزيد من المعلومات",
            "MY_PAYMENT": "مدفوعاتي",
            "MY_WALLET": "محافظي",
            "PAYMENT_INFO_WILL_SEND_VIA_NOTIFICATION": "سيتم إرسال معلومات الدفع إليك عبر الإشعارات",
            "PAYMENT_TYPE": "نوع الدفع",
            "PAY_ACCOUNT": "الدفع من الحساب",
            "PAY_AMOUNT": "مبلغ الدفع",
            "PAY_CURRENCY": "عملة الدفع",
            "PAY_SERVICE": "خدمة الدفع الإلكتروني",
            "POINT": "نقطة",
            "QUANTITY": "الكمية",
            "RECEIVER": "المستلم",
            "RECEIVE_CURRENCY": "عملة الاستلام",
            "RECIEVE_CURRENCY": "عملة الاستلام",
            "RECIEVE_TYPE": "نوع الاستلام",
            "REFRENCE_NUMBER": "مبلغ الطلب",
            "REQUESTED_DATE": "تاريخ الطلب",
            "REQUESTS": "الطلبات",
            "REQUEST_DATE": "تاريخ الطلب",
            "REQUEST_INFO": "تفاصيل الطلب",
            "REQUEST_DEPOSIT_INFO": "معلومات الطلب",
            "REQUEST_LIST": "قائمة الطلبات",
            "SECURITY": "إعدادات الأمان",
            "SELECT_FRIEND": "اختيار صديق",
            "SELL_AMOUNT": "مبلغ البيع",
            "SEND_DATE": "تاريخ الإرسال",
            "SEND_TO_THIRD_PARTY": "إيداع في حساب طرف ثالث",
            "SEND_TO_THIRD_PARTY_TC_WALLET": "إرسال إلى محفظة الأصدقاء",
            "SERVICE_NAME": "الاسم",
            "THIRD_PARTY": "الطرف الثالث",
            "THIRD_PARTY_INFORMATION": "معلومات الطرف الثالث",
            "THIRD_PARTY_WALLET": "محفظة الطرف الثالث",
            "TOTAL_AMOUNT": "إجمالي المبلغ المدفوع",
            "TO_WALLET": "إلى المحفظة",
            "TRACKING_NUMBER": "رقم التتبع",
            "TRANSFER_DATE": "تاريخ التحويل",
            "TRANSFER": "التحويل",
            "TRANSFER_AMOUNT": "مبلغ التحويل",
            "VERIFY": "تأكيد",
            "WAITING": "انتظار",
            "WALLET": "المحفظة",
            "WALLET_NOT_FOUND": "لم يتم العثور على المحفظة",
            "WAYS_SEND_TO_OTHERS": "طرق الإرسال إلى الآخرين",
            "WHEN_RECEIVE_PAYMENT_INFO": "بعد استلام معلومات الدفع يمكنك متابعة الخطوات التالية",
            "WITHDRAWAL_AMOUNT": "مبلغ السحب",
            "WITHDRAWAL_TYPE": "طريقة السحب",
            "YOUR_REQUEST_SUBMITTED": "تم تقديم طلبك بنجاح.",
            "CRYPTO": "العملات الرقمية",
            "BY_LOCAL_PAYMENT": "عبر الدفع المحلي",
            "WITH_CRYPTOCURRENCY": "بواسطة العملات الرقمية",
            "WITH_EMONEY": "بواسطة الأموال الإلكترونية",
            "SERVICE_PAYMENT": "دفع الخدمة",
            "CRYPTO_PAYMENT": "دفع العملات الرقمية",
            "CONVERSATION_CLODES": "تم إغلاق هذه المحادثة",
            "PAYMENT_AMOUNT": "مبلغ الدفع",
            "NO_PAYMENT": "لا يوجد دفع مقدم للعرض.",
            "OTHER_WAYS_TRANSMISSION": "التحويل بطرق أخرى",
            "TRANSACTION_AMOUNT": "مبلغ المعاملة",
            "SELECT_BANK": "اختيار الحساب البنكي",
            "SELECT_PAYMENT_GATEWAY": "اختيار بوابة الدفع",
            "I_PAY": "أنا أدفع",
            "TOTAL_RECEIVED": "الإجمالي المستلم",
            "COMPLETE_THE_REQUESt": "إكمال الطلب",
            "CHANGE_INFORMATION": "تغيير المعلومات",
            "SUBMIT_REQUEST": "إرسال",
            "VERIFY_INFORMATION": "التحقق من المعلومات",
            "SUCCESS_ALERT": "تم تسجيل طلبك بنجاح.",
            "VERIFY_INFO_ERROR_ALERT": "تأكيد صحة المعلومات المذكورة أعلاه.",

            DEPOSIT: {
                "CHARGE_AMOUNT": "مبلغ الشحن",
                "CHARGE_TYPE": "طريقة الشحن",
                "DEPOSIT_INFO": "معلومات الدفع",
                "MONY_CURRENCY": "الدفع المحلي",
                BY_ID: {
                    "CREATE_ID": "إنشاء معرف",
                    "SELECT_WALLET": "اختيار المحفظة",
                    "CHANGE_DEFAULT_WALLET": "تغيير",
                    "PAY_BY_ID": "الدفع عبر معرف الإيداع",
                    "DEPOSIT_AMOUNT": "مبلغ الإيداع",
                    "MONEY_MEETING": "المبلغ المستلم",
                    "STEP1_TEXT": "قم أولاً بتحويل المبلغ إلى الحساب المستهدف عبر Satna أو Paya مع رقم معرف الإيداع.",
                    "STEP1_TEXT2": "تسجيل معرف الإيداع مطلوب",
                    "STEP2_TEXT": "انتظر حتى يتم شحن محفظتك، حيث سيتم إضافة المبلغ تلقائيًا إلى محفظتك خلال دورة Paya وستتلقى إشعارًا بذلك",
                    "ALERT": "إذا قمت بتحويل المبلغ من حساب Mellat Bank إلى طريقة الإيداع، فسيتم شحن محفظتك بشكل أسرع نظرًا لأن Mellat هو البنك المستهدف.",
                    "ALERT1": "عند تحويل الأموال، من الضروري تسجيل معرف الإيداع. إذا لم تقم بتسجيله أو قمت بإدخاله بشكل غير صحيح، فلن يتم شحن محفظتك؛ وسيتم إرجاع الأموال بعد 72 ساعة مع خصم رسوم الإيداع.",
                    "DESTINATION_IBAN": "وجهة الآيبان",
                    "DESTINATION_ACCOUNT_NUM": "رقم الحساب المستهدف",
                    "DESTINATION_ACCOUNT_OWNER_NAME": "اسم مالك الحساب",
                    "DEPOSIT_ID": "معرف الإيداع",
                    "ORIGIN_IBAN": "مصدر الآيبان",
                    "TIP1": "يجب أن يتم الإيداع باستخدام بطاقاتك المعتمدة في TC، وإلا فسيتم إرجاع المبلغ إلى حسابك بعد 24 ساعة.",
                    "TIP2": "إذا قمت بإيداع مبلغ من حساب غير الحساب المرتبط بالمعرف، فسيتم إرجاع الأموال بعد 72 ساعة مع خصم رسوم الإيداع.",
                    "ALERT_ADD": "يجب أن يكون رقم الآيبان باسمك ومؤكدًا في TC. سيكون لكل حساب بنكي معرف إيداع فريد بشكل دائم.",
                    "EMPTY_ID": "يرجى إنشاء معرف إيداع",
                    "NEW": "جديد",
                    "SELECT_DEFAULT_WALLET_TO_DEPOSIT": "المحفظة الافتراضية التي تريد شحنها بمعرف الإيداع؛ اختر.",
                    "SELECT_SOURCE_ACCOUNT": "لشحن محفظة الريال، قم بالإيداع في أحد الحسابات المستهدفة باستخدام معرف الإيداع.",
                    "ID_CREATED_SUCCESSFULLY": "تم إنشاء معرف الدفع بنجاح.",
                    "DEFAULT_WALLET_CHANGED_SUCCESSFULLY": "تمت العملية بنجاح",
                    "YOU_DONT_HAVE_ENOUGH_BANK_ACCOUNT": "ليس لديك حساب بنكي",
                    "FIRST_REGISTER_BANK_ACCOUNT": "قم أولاً بتسجيل حساب بنكي.",
                    "EDIT_MOBILE_NUMBER": "تعديل رقم الهاتف المحمول",
                    STATUS: {
                        "VERIFIED": "تم التحقق",
                        "REJECTED": "مرفوض",
                        "PENDING": "قيد الانتظار",
                    },
                    "EXCEPTION_IN_CREATION_ID": "خطأ في إنشاء المعرف",
                    "ID_CREATION_FAILED": "فشل إنشاء المعرف",
                    "ID_CREATION_PENDING": "يرجى الانتظار حتى يتم عرض معلومات الحساب المستهدف ومعرف الإيداع.",
                    "CREATE_ID_AGAIN_ALERT": "عزيزي المستخدم، يرجى إنشاء معرف مرة أخرى",
                    "CONTACT_SUPPORT_ALERT": "عزيزي المستخدم، يرجى الاتصال بالدعم لحل هذه المشكلة",
                },
                ALERT: {
                    "WAIT_FOR_GET_CASH_PAY_DETAIL": "تم تقديم طلبك بنجاح. يرجى الانتظار للحصول على رسالة أو مكالمة من الخبير.",
                    "WAIT_FOR_PROCESS_PAYMENT_REQUEST": "عزيزي المستخدم، بعد مراجعة وتأكيد مدفوعاتك المسجلة، سنقوم بشحن محفظتك وفقًا لذلك.",
                },
                CHARGING_TC: "شحن محافظ TC نقدًا وعن طريق البنوك",
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            "MESSAGE": "إشعار طلب الإيداع",
                            "REJECTED": "تم رفض الدفع",
                            "ACCOUNT_ASSIGNED": "معلومات الدفع",
                        },
                        BODY: {
                            "MESSAGE": "تم إرسال رسالة من قبل الخبير للطلب الذي يحمل رقم التتبع {{0}}.",
                            "REFUND": "تمت إعادة الطلب برقم التتبع {{0}} إلى محفظتك.",
                            "REJECTED": "تم رفض الطلب برقم التتبع {{0}}.",
                            "AUTO_REJECTED": "تم رفض الطلب برقم التتبع {{0}}.",
                            "DONE": "تم إكمال الطلب برقم التتبع {{0}} بنجاح",
                            "ACCOUNT_ASSIGNED": "تم تسجيل معلومات الحساب البنكي لدفع طلب الإيداع برقم التتبع {{0}}.",
                        }
                    }
                },
                STEPS_HINT: {
                    "SELECT_WALLET": "اختر المحفظة التي ترغب في شحنها",
                    "ENTER_EMONEY_AMOUNT": "أدخل مبلغ الأموال الإلكترونية الذي ترغب في دفعه لشحن المحفظة.",
                    "ENTER_CRYPTO_AMOUNT": "أدخل مبلغ العملات الرقمية الذي ترغب في دفعه لشحن المحفظة.",
                    "ACCEPT_INFO": "لإرسال طلب، تحقق من المعلومات وتأكد من صحتها.",
                    "ENTER_EXCHANGE_AMOUNT": "أدخل المبلغ الذي تريد تحويله.",
                    "PAYMENT_EMONEY": "يرجى إيداع المبلغ في الحساب المذكور ثم تسجيل معلومات الدفع الخاصة بك.",
                    "ENTER_AMOUNT": "أدخل المبلغ الذي ترغب في إيداعه",
                    "BANK_WAITING": "تم تقديم طلبك بنجاح، يرجى الانتظار لاستلام معلومات الحساب للدفع",
                    "CASH_WAITING": "تم تقديم طلبك بنجاح، يرجى الانتظار لاستلام معلومات موقع الدفع",
                    "BANK_PAYMENT": "يرجى إيداع المبلغ المستحق في الحساب المذكور",
                    "CASH_PAYMENT": "بعد التسليم، قم بتسجيل معلومات الدفع",
                    "ONLINE_PAYMENT": "تم تقديم طلبك بنجاح، يرجى اختيار البنك الخاص بك ودفع المبلغ عبر الإنترنت",
                    "CREDIT_ENTER_PAYMENT_INFO": "يرجى إدخال معلومات الدفع.",
                    "GATEWAY_PAY": "تم تقديم طلبك بنجاح. يرجى دفع المبلغ المطلوب عبر بوابة الموقع المصدر بالنقر على زر الدفع.",
                },
                CRYPTO: {
                    "WITH_CRYPTO": "عن طريق العملات الرقمية",
                    "WIDOE_GUIDE": "دليل الفيديو",
                    "CURRENCY_TYPE": "نوع العملة الرقمية",
                    "SELECT_NETWORK": "حدد الشبكة",
                    "CONTROL_ADDRESS": "تحقق بعناية من عنوان الإيداع الخاص بك. إذا قمت بإدخال عنوان غير صحيح، فقد تصبح أصولك غير قابلة للوصول.",
                    "DIRECT_DEPOSIT": "تجنب الإيداعات المباشرة من منصات التداول الدولية، خاصة الأمريكية مثل CoinBase وKraken، التي تفرض قيودًا على المستخدمين الإيرانيين. إذا لزم الأمر، استخدم محفظة شخصية، عناوين مؤقتة، وطرق تحويل متعددة الطبقات للحفاظ على أصولك آمنة.",
                    "DEPOSIT_ADDRESS": "عنوان إيداع Tether",
                    "ASSETS_SECURITY": "للحفاظ على أصولك آمنة، يرجى إيداع Tether فقط في هذا العنوان. قد يؤدي إيداع أي عملة أخرى في هذا العنوان إلى خسارة أصولك.",
                    "SELECT_TRANSFER_NETWORK": "للحصول على عنوان إيداع Tether، قم أولاً بتحديد شبكة التحويل.",
                },
                DIRECT_DEPOSIT: {
                    DIRECT_DEPOSIT_TITLE: 'التحويل البنكي',
                    ALERT: 'يجب أن يتم الإيداع باستخدام بطاقاتك الموثقة على TC، وإلا سيتم رد المبلغ إلى حسابك بعد 24 ساعة.',
                    ALERT_LINE_TWO: 'سيتم شحن المحفظة التي اخترتها بعد تأكيد الإيداع وفقًا لسعر الصرف الفوري.',
                    DESC_DIRECT_DEPOSIT: 'لشحن محفظتك، قم بتحويل الأموال إلى أحد الحسابات المحددة.',
                    MY_BANK_ACCOUNT: 'حساباتي البنكية',
                    DEPOSIT_AMOUNT_GUIDE_TEXT_ONE: 'أولاً، قم بتحويل المبلغ إلى الحساب المستهدف عبر ساتنا أو بايا أو بول.',
                    MONEY_MEETING: 'تسوية الأموال',
                    DEPOSIT_AMOUNT_GUIDE_TEXT_TWO: 'سيتم شحن المحفظة التي اخترتها بعد تأكيد إيداعك وفقًا لسعر الصرف الفوري.',
                    SELECT_WALLET_FOR_DIRECT_DEPOSIT: 'اختر المحفظة الافتراضية التي ترغب في شحنها.',
                    ONLY_RIAL_WALLET: 'يمكنك شحن محفظة الريال فقط.',

                },
                OFFLINE: {
                    TITLE: 'إيداع غير متصل',
                    CARD_OFFLINE_DEPOSIT: 'إيداع بطاقة إلى بطاقة غير متصل',
                    IBAN_OFFLINE_DEPOSIT: 'آيبان غير متصل',
                    DEPOSIT_CARD_NUMBER: 'رقم بطاقة الإيداع',
                    CONTINUED_GUIDE: 'دليل الاستمرار',
                    CARD_PAGE_DESC_SUPPORT: 'قم بالدفع باستخدام رقم البطاقة أعلاه وأرسل إيصال الدفع إلى الدعم لمتابعة هذه الحالة.',
                    EN_IBAN_OFFLINE: 'Iban Offline',
                    HOW_IS_THIS_ROUTE_DONE: 'كيف يتم هذا المسار؟',
                    IBAN_PAGE_DESC_NUMBER: 'لتحويلات الآيبان، يرجى التواصل مع الدعم قبل إجراء الدفع. سيتم التحقق من المبلغ ووجهة الإيداع، وسيتم تنسيق تفاصيل الدفع بشكل خاص لطلبك.',
                    ALERT_IBAN_PAGE: 'قبل أي تحويل آيبان، يرجى التنسيق مع الدعم أولاً.',
                    WALLET_TC: 'محفظة TC',
                    BANK_CARD: 'البطاقة البنكية',
                    AMOUNT_RECEIVED: 'المبلغ المستلم:',
                    ALERT_SELECT_BANK: 'يمكنك فقط اختيار بنك قمت بالتحقق منه مسبقًا في TC.',
                    ALERT_RATE_BANK: 'يجب إجراء الإيداع باستخدام البطاقات المعتمدة في TC، وإلا سيتم إعادة المبلغ إلى حسابك بعد 72 ساعة. سيتم شحن محفظتك المختارة بسعر الصرف اللحظي عند تأكيد الإيداع.',
                    SUBMIT_FORM: 'إرسال النموذج',
                    REFRENCE_NUMBER: 'مرجع المعاملة / رمز المستند / الرقم المرجعي',
                    ALERT_PRICE_RATE_COMMISSION: 'هذا ليس المبلغ النهائي لشحن المحفظة. قد تؤثر العمولة وسعر الصرف اللحظي على المبلغ النهائي. لمزيد من المعلومات، يرجى التواصل مع الدعم.',
                    INFO_EXCHANGE_RAGE_SUBMIT: 'سعر الصرف وقت تقديم الطلب: كل {{payAmount}} {{payAmountCurrency}} يعادل {{getAmount}} {{getAmountCurrency}}، وسيتم احتساب السعر النهائي بناءً على سعر الصرف وقت استلام الإيداع.',
                    CARD_NUMBER: 'رقم البطاقة',
                    IBAN_NUMBER: 'رقم الآيبان',
                    ALERT_UNNECESSARY_FORM_SUBMISSION_WARNING: 'إذا لم يتم تأكيد إيداعك بنجاح، يُرجى الامتناع عن إرسال نماذج غير ضرورية.',
                }
            },

            WITHDRAWAL: {
                "ACCOUNT_INFORMATION": "تفاصيل الحساب",
                "BANK_ACCOUNT": "الحساب البنكي",
                "DEPOSIT_TO_MY_ACCOUNT": "إيداع في حسابي",
                "DEPOSIT_TO_THIRD_PARTY_ACCOUNT": "إيداع في حساب طرف ثالث",
                "E_MONEY_PAYMENT": "إيداع الأموال الإلكترونية",
                "E_MONEY_WITHDRAWAL": "سحب الأموال الإلكترونية",
                "LOCAL_PAYMENT": "الدفع المحلي",
                "LOCAL_WITHDRAWAL": "سحب الدفع المحلي",
                "LOCATION": "موقع التسليم",
                "RECEIVER_NAME": "اسم المستلم",
                "RECEIVER_NAME_HINT": "إذا كان المستلم شخصًا آخر غيرك، يرجى كتابة اسمه الكامل.",
                "SELECT_ACCOUNT": "اختيار الحساب",
                "TO_CRYPTOCURRENCY_ACCOUNT": "إلى حساب العملات الرقمية",
                "TO_EMONEY_ACCOUNT": "إلى حساب الأموال الإلكترونية",
                "ALERT_PENDING_PROCCESING": "بانتظار الموافقة والمراجعة",
                "ALERT_PENDING_PROCCESING_Text": "بعد التحقق من المعلومات وتأكيدها، سيتم إضافة المبلغ تلقائيًا إلى حسابك خلال دورة الدفع، وستتلقى إشعارًا بذلك.",
                "SETTLEMENT_TIME": "وقت التسوية",
                "SETTLEMENT_TIME_TEXT": "سيتم تحويل المبلغ تلقائيًا إلى حساباتك خلال دورة العمل العادية* بحلول الساعة 17:00 من اليوم التالي وسيتم إشعارك بذلك.",
                "WITHDRAW_BANK_RULE_TEXT": "إجمالي مبلغ السحب يصل إلى {{value}} مليون تومان، مع حد أقصى {{count}} طلبات سحب في اليوم.",
                "WITHDRAW_ADD_BANK_ACCOUNT_TEXT": "بسبب الحد اليومي للإيداع في كل حساب بنكي ({{value}} مليون تومان)؛ لاستلام المبلغ بالكامل، قم بتسجيل {{accountCount}} حساب بنكي إضافي أو قم بتعديل المبلغ المطلوب.",
                "WITHDRAW_BANK_ACCOUNT_PENDING_VERIFY": "الحساب البنكي قيد التحقق",
                "WITHDRAW_BANK_ACCOUNT_PENDING_VERIFY_TEXT": "يتم التحقق من معلومات حسابك البنكي، يرجى تسجيل طلب السحب بعد التحقق من الحساب.",
                "DEPOSIT_TO": "إيداع إلى",
                "WITHDRAWAL_INFO": "معلومات السحب",
                "WAIT_FOR_CONFIRMATION_OF_ACCOUNT": "انتظر تأكيد معلومات الحساب",
                "ACCOUNT_SELECTION_IS_REQUIRED": "اختيار الحساب مطلوب.",
                RECEIVED_AMOUNT_EXCEEDS_DAILY_SETTLEMENT_LIMIT: "المبلغ المستلَم يتجاوز الحد الأقصى المسموح به للتسوية اليومية.",
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: "إشعار طلب السحب",

                        },
                        BODY: {
                            "DONE": "تم تنفيذ الطلب برقم التتبع {{0}}. تم سحب مبلغ {{1}} من محفظتك.",
                            "MESSAGE": "تم إرسال رسالة من قبل الخبير للطلب الذي يحمل رقم التتبع {{0}}.",
                            "REFUND": "تمت إعادة الطلب برقم التتبع {{0}}.",
                            "REJECT": "تم رفض الطلب برقم التتبع {{0}}.",
                            "REJECTED": "تم رفض الطلب برقم التتبع {{0}}.",
                        }
                    }
                },
                STEPS_HINT: {
                    "SELECT_EMONEY_ACCOUNT": "حدد حساب الأموال الإلكترونية الذي ترغب في الإيداع إليه.",
                    "SELECT_CRYPTO_ACCOUNT": "حدد حساب العملات الرقمية الذي ترغب في الإيداع إليه.",
                    "SELECT_WALLET": "اختر المحفظة التي ترغب في سحب المبلغ منها.",
                    "ENTER_AMOUNT": "أدخل مبلغ السحب من المحفظة المطلوبة.",
                    "ACCEPT_INFO": "لإرسال طلب، تحقق من المعلومات وتأكد من صحتها.",
                    "SELECT_BANK_ACCOUNT": "حدد الحساب البنكي الذي تريد الإيداع إليه.",
                    "SELECT_LOCATION": "حدد المدينة المطلوبة لاستلام المبلغ.",
                    "ENTER_RECEIVER_NAME": "أدخل الاسم الأول والأخير للمستلم.",
                    "TRANSFER_TO_ACCOUNT": "قم بتحويل المبلغ المطلوب إلى حساب {{value}}.",
                },
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: "يجب ألا يتجاوز مبلغ السحب رصيد محفظتك.",
                },
                CRYPTO: {
                    "CHECK_NETWORK": "تأكد من أن الشبكة التي تختارها للتحويل تتطابق مع شبكة عنوان الوجهة.",
                    "TO_ADDRESS": "عنوان الوجهة",
                    "LOSE_ASSETS": "إدخال عنوان غير صحيح سيؤدي إلى فقدان أصولك.",
                    "WITHDRAW_AMOUNT": "مبلغ السحب",
                    "TETHER": "Tether",
                    "BALANCE": "الرصيد",
                    "WITHDARABLE": "متاح",
                    "MIN": "الحد الأدنى",
                    "MAX": "الحد الأقصى",
                    "CALCULATES": "الحسابات",
                    "FILL_INFO": "أدخل المعلومات أولاً",
                    "CANCEL": "إلغاء",
                    "REGISTER": "إرسال",
                    "NETWORK_FEE": "رسوم المعاملة",
                    "FINAL_WITHDRAW_AMOUNT": "المبلغ المرسل إلى عنوان محفظتك",
                    "WITHDRAW_CONFIRMATION": "تأكيد السحب",
                    "ENSURE_NETWORK": "تأكد من صحة عنوان الشبكة.",
                    "CANNOT_CANCEL": "بمجرد تقديم الطلب، لا يمكن إلغاؤه.",
                    "NETWORK": "الشبكة",
                    "CANCEL_CONFIRM": "إلغاء",
                    "ACCEPT": "قبول",
                    "REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE": "لا يمكن أن يتجاوز مبلغ السحب الحد الأقصى للسحب على الشبكة ({{amount}} {{currency}}).",
                    "REQUESTED_AMOUNT_IS_LESS_THAN_BALANCE": "لا يمكن أن يكون مبلغ السحب أقل من الحد الأدنى للسحب ({{amount}} {{currency}}).",
                    "DEPOSIT": "شحن المحفظة",
                    "YOU_DONT_HAVE_A_CRYPTO_WALLET": "ليس لديك محفظة عملات رقمية.",
                    "PLEASE_CREATE_A_WALLET_FIRST": "يرجى إنشاء محفظة أولاً.",
                    "YOUR_WALLET_IS_EMPTY": "محفظتك فارغة!",
                    "FIRST_UP_TO_BALANCE_WALLET": "يرجى شحن رصيدك أولاً حتى تتمكن من متابعة السحب.",
                    "PROCESSING": "قيد المعالجة",
                    "ALERT_PENDING_PROCCESING": "يتم حاليًا معالجة عملية السحب على شبكة البلوكشين. قد تستغرق هذه العملية بعض الوقت، يرجى التحلي بالصبر.",
                    "FROM_WALLET": "من المحفظة",
                    "WITHDRAWAL_AMOUNT_FROM_WALLET": "مبلغ السحب من المحفظة",
                    "DESTINATION_ADDRESS": "عنوان الوجهة",
                    "TRANSACTION_ID": "معرف المعاملة (التجزئة)",
                    "AMOUNT_DEPOSITED_TO_DESTINATION_ADDRESS": "المبلغ المودع في عنوان الوجهة",
                    "NETWORK_TRANSFER_FEE": "رسوم تحويل الشبكة",
                    "REJECTED_TITLE": "سبب رفض الطلب",
                }
            },
            SEND: {
                "ENTER_ALERT_INFORMATION": "يرجى إدخال المعلومات المطلوبة.",
                "INTERNAL_TRANSFER": "التحويل الداخلي",
                "LOCAL_SEND": "الدفع المحلي",
                "TC_TO_TC": "تحويل TC إلى TC",
                "RECEIVER": "المستلم",
                "RECEIVER_FULL_NAME": "الاسم الكامل للمستلم",
                "RECEIVER_USER_NAME": "اسم مستخدم المستلم",
                "SEND_AMOUNT": "مبلغ الإرسال",
                "PAY_AMOUNT": "مبلغ الدفع",
                "SEND_FROM_TC_WALLET": "الإرسال من محفظة TC",
                "SEND_TYPE": "نوع الإرسال",
                "SEND_DATE": "تاريخ الإرسال",
                "TO_TC": "إلى TC",
                "SEND": "إرسال",
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: "يجب ألا يتجاوز مبلغ الإرسال رصيد المحفظة.",
                    WITHDRAWAL_AMOUNT_IS_MORE_THAN_BALANCE: "لا يمكن أن يتجاوز مبلغ السحب، شاملاً الرسوم، رصيد المحفظة.",
                },
                ALERT: {
                    "SEND_TC_WALLET_SUCCESS": "تم الإرسال إلى المحفظة الوجهة بنجاح.",
                    "WAIT_FOR_GET_CASH_PAY_DETAIL": "تم تقديم طلبك بنجاح. يرجى الانتظار للحصول على رسالة أو مكالمة من الخبير.",
                    "WAIT_FOR_PROCESS_PAYMENT_REQUEST": "عزيزي المستخدم، بعد مراجعة وتأكيد مدفوعاتك المسجلة، سنقوم بشحن محفظتك وفقًا لذلك.",
                },
                TC_WALLET_SEND: "دفع محفظة TC",
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            ACCOUNT_ASSIGNED: "إرسال معلومات طلب الدفع",
                        },
                        BODY: {
                            "DONE": "تم تنفيذ الطلب برقم التتبع {{0}} بنجاح. تم إيداع مبلغ {{1}} في حساب وجهتك.",
                            "REFUND": "تمت إعادة الطلب برقم التتبع {{0}}.",
                            "REJECTED": "تم رفض الطلب برقم التتبع {{0}}.",
                            "TO_ANOTHER": "تم إكمال الطلب برقم التتبع {{0}} بنجاح.",
                            "ACCOUNT_ASSIGNED": "تم تسجيل معلومات الحساب البنكي لدفع طلب الإرسال برقم التتبع {{0}}.",
                        }
                    }
                },
                STEPS_HINT: {
                    "SELECT_THIRD_PARTY_WALLET": "حدد محفظة المستلم لإرسال المبلغ",
                    "ENTER_SEND_AMOUNT": "أدخل مبلغ الدفع",
                    "ACCEPT_INFO": "لإرسال الطلب، تحقق من المعلومات وتأكد من صحتها.",
                    "BANK_WAITING": "تم تقديم طلبك بنجاح، يرجى الانتظار لاستلام معلومات الحساب للدفع.",
                    "BANK_PAYMENT": "يرجى إيداع المبلغ المستحق في الحساب المذكور.",
                    "CASH_WAITING": "تم تقديم طلبك بنجاح، يرجى الانتظار لاستلام معلومات موقع الدفع.",
                    "CASH_PAYMENT": "بعد التسليم، قم بتسجيل معلومات الدفع",
                    "ENTER_PAYMENT_INFO": "يرجى إدخال معلومات الدفع.",
                    "ONLINE_PAYMENT": "تم تقديم طلبك بنجاح، يرجى اختيار البنك الخاص بك ودفع المبلغ عبر الإنترنت.",
                },
                TC_WALLET: {
                    NOTIFY: {
                        NOTIFICATION: {
                            BODY: {
                                RECEIVE: "تم استلام مبلغ {{0}} من المستخدم {{1}} برقم التتبع {{2}}.",
                            }
                        }
                    },
                    STEPS_HINT: {
                        "SELECT_WALLET": "اختر المحفظة التي ترغب في السحب منها.",
                        "SELECT_THIRD_PARTY_WALLET": "حدد محفظة المستلم لإرسال المبلغ",
                        "ENTER_SEND_AMOUNT": "أدخل المبلغ المرسل",
                        "ACCEPT_INFO": "لإرسال الطلب، تحقق من المعلومات وتأكد من صحتها.",
                    },
                }
            },
            RECEIVE: {
                "AMOUNT": "المبلغ المستلم",
                "ARCHIVE": "الأرشيف",
                "ARCHIVED": "مؤرشف",
                "ARCHIVED_DATE_FROM": "الأرشيف من تاريخ",
                "ARCHIVED_DATE_TO": "الأرشيف إلى تاريخ",
                "ARCHIVED_SUCCESSFULLY": "تمت أرشفة المعاملة بنجاح.",
                "BE_ARCHIVED": "تم الأرشفة",
                "FROM_USER": "من المستخدم",
                "FROM_WALLET": "من المحفظة",
                "MORE_INFO": "مزيد من المعلومات",
                "RECEIVE_DATE": "تاريخ الاستلام",
                "RECIEVE_INFO": "تفاصيل المدفوعات المستلمة",
                "RECIVE": "استلام",
                "SENDER": "المرسل",
                "TO_WALLET": "إلى المحفظة",
                OTHER_WAY: {
                    NOTIFY: {
                        NOTIFICATION: {
                            BODY: {
                                TO_ANOTHER: "تم استلام مبلغ {{0}} من المستخدم {{1}} برقم التتبع {{2}}.",
                            }
                        }
                    }
                }
            },
            EXCHANGE: {
                "CHANGE": "تم حفظ التغييرات بنجاح.",
                "CURRENCY": "خدمة دفع التبادل",
                "ELECTRONIC_MONEY": "الأموال الإلكترونية",
                "ELECTRONIC_MONEY_TO_ELECTRONIC_MONEY": "تبادل الأموال الإلكترونية",
                "EXCHANGE": "التبادل",
                "EXCHANGE_AMOUNT": "مبلغ التبادل",
                "EXCHANGE_DATE": "تاريخ التبادل",
                "EXCHANGE_INFO": "معلومات التبادل",
                "EXCHANGE_TYPE": "نوع التبادل",
                "GET_SERVICE": "الاستلام بالأموال الإلكترونية",
                "LOCAL_PAYMENT": "الدفع المحلي",
                "NEW_EXCHANGE": "تبادل جديد",
                "NO_HAVE_ANY_GET_SERVICE": "لا تتوفر خدمة الاستلام.",
                "SELECT": "اختيار",
                "SELECTED_GET_SERVICE": "الدفع بواسطة الأموال الإلكترونية",
                "SELECTED_PAY_SERVICE": "الدفع باستخدام الأموال الإلكترونية",
                "SELECT_CURRENCY": "تحويل العملات",
                "SELECT_GET_SERVICE": "اختر خدمة استلام الأموال الإلكترونية",
                "SELECT_PAY_SERVICE": "اختر خدمة دفع الأموال الإلكترونية",
                "TC_TO_TC": "تحويل TC إلى TC",
                "TC_WALLET": "محفظة TC",
                "PAY_SERVICE": "خدمة الدفع",
                "SUBSERVICE": "الخدمة الفرعية",
                STEPS_HINT: {
                    "SELECT_WALLET": "اختر المحفظة التي ترغب في السحب منها.",
                    "SELECT_WALLET_TO_TRANSFER": "اختر المحفظة التي ترغب في تحويل الأموال منها.",
                    "ENTER_EXCHANGE_AMOUNT": "أدخل المبلغ الذي ترغب في تحويله",
                    "ACCEPT_INFO": "لإرسال الطلب، تحقق من المعلومات وتأكد من صحتها.",
                    "SELECT_PAY_GET_SERVICE": "حدد الخدمة المدفوعة / المستلمة للتحويل.",
                    "ENTER_ACCOUNT_INFO": "حدد معلومات حسابك أو حساب المستلم.",
                    "PAYMENT": "تم تقديم طلبك بنجاح، يرجى إيداع المبلغ في الحساب المذكور ثم تسجيل معلومات الدفع الخاصة بك.",
                },

                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: "إشعار خدمة التبادل",
                        },
                        BODY: {
                            "DONE": "تم تنفيذ الطلب برقم التتبع {{0}} بنجاح. تم إيداع مبلغ {{1}} في حساب وجهتك.",
                            "MESSAGE": "تم إرسال رسالة من قبل الخبير للطلب الذي يحمل رقم التتبع {{0}}.",
                            "REFUND": "تمت إعادة الطلب برقم التتبع {{0}}.",
                            "REJECT": "تم رفض الطلب برقم التتبع …",
                            "REJECTED": "تم رفض الطلب برقم التتبع {{0}}.",
                        }
                    }
                },
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: "يجب ألا يتجاوز مبلغ التبادل رصيد المحفظة.",
                }
            },
            VOUCHER: {
                "AMOUNT": "المبلغ",
                "COMISSION": "العمولة",
                "EXCHANGE_RATE": "سعر الصرف",
                "MAX_QUANTITY": "الكمية القصوى",
                "MIN_QUANTITY": "الكمية الدنيا",
                "PURCHASED_DATE": "تاريخ الشراء",
                "PURCHASED_INFO": "تفاصيل الشراء",
                "PURCHASED_VOUCHERS": "القسائم المشتراة",
                "QUANTITY": "الكمية",
                "SERIAL_NUMBER": "الرقم التسلسلي",
                "TOTAL_COMISSION": "إجمالي العمولة",
                "TOTAL_PRICE": "إجمالي السعر",
                "UNIT_COMMISSION": "عمولة الوحدة",
                "UNIT_PRICE": "السعر لكل وحدة",
                "USER_PRICE": "سعر المستخدم",
                "VOUCHER": "القسيمة",
                "VOUCHER_ITEM": "عنصر القسيمة",
                "VOUCHER_TYPE": "نوع القسيمة",
                "WOULD_RECEIVE_VOUCHER_INFO_EMAIL": "هل ترغب في استلام معلومات القسائم المشتراة عبر البريد الإلكتروني؟",
                "VOUCHER_NAME": "اسم القسيمة",
                "TYPE": "النوع",
                STEPS_HINT: {
                    "SELECT_WALLET": "اختر المحفظة لشراء قسيمة.",
                    "NUMBER_OF_PURCHASE": "أدخل الرقم المطلوب لشراء القسيمة المحددة.",
                    "ACCEPT_INFO": "لإرسال الطلب، تحقق من المعلومات وتأكد من صحتها.",
                }
            },
            POINTS: {
                "CHANGE_STATUS": "تغيير الحالة",
                "CHANGE_TYPE": "تغيير الحالة",
                "EACH": "كل 1000 نقطة",
                "EACH_1000_POINT": "كل 1000 نقطة",
                "GET_AMOUNT": "استلام المبلغ",
                "INVOICE_TYPE": "تحويل النقاط إلى الرصيد",
                "MIN_NUM_FOR_WITHDAWAL": "الحد الأدنى للنقاط للسحب",
                "MY_POINTS": "نقاطي",
                "NEW_WITHDRAWAL": "سحب جديد",
                "NUMBER_OF_POINT": "عدد النقاط",
                "NUMBER_OF_POINTS": "عدد النقاط",
                "POINTS": "نقطة",
                "TOTAL_POINTS": "إجمالي النقاط",
                "TO_TC_WALLET": "الإيداع في محفظة TC",
                "TRANSACTION_NAME": "اسم المعاملة",
                "TRANSACTION_TYPE": "نوع المعاملة",
                "WALLET": "المحفظة",
                "WHITDRAW_POINT": "سحب النقاط",
                "WITHDRAWAL": "سحب النقاط",
                "WITHDRAWAL_INFO": "تفاصيل السحب",
                "WITHDRAWAL_POINTS": "النقاط المسحوبة",
                "WITHDRAW_DATE": "تاريخ السحب",
                STEPS_HINT: {
                    "SELECT_WALLET": "اختر المحفظة التي ترغب في إيداع المبلغ فيها.",
                    "POINT_WITHDRAWAL": "أدخل النقاط المطلوبة للسحب.",
                    "ACCEPT_INFO": "لإرسال الطلب، تحقق من المعلومات وتأكد من صحتها.",
                },
                ALERT: {
                    IS_LOWER_THAN_MIN: "إجمالي نقاطك أقل من الحد الأدنى للسحب.",
                },
                VALIDATION: {
                    MIN_POINT_FOR_WITHDRAWAL: "الحد الأدنى لمبلغ السحب:",
                }
            },
            CONFIRMATION: {
                "CONFIRMATION_CODE": "رمز التأكيد",
                "CONFIRMATION_HELP_EMAIL": "لإرسال طلبك، يرجى إدخال رمز التأكيد الذي تم إرساله إلى بريدك الإلكتروني.",
                "CONFIRMATION_HELP_SMS": "لإرسال طلبك، يرجى إدخال رمز التأكيد الذي تم إرساله إلى هاتفك المحمول.",
                "CONFIRMATION_HELP_2FA": "لإرسال طلبك، يرجى إدخال الرمز المكون من 6 أرقام من تطبيق المصادقة.",
                "SECURITY_CODE": "رمز التأكيد",
                "SEND_CODE": "إرسال الرمز",
                "AUTHENTICATOR_CODE": "رمز المصادقة",
                "ENTER_CODE_FROM_AUTHENTICATOR": "يرجى التحقق من مجلد البريد العشوائي إذا لم تستلم الرمز في صندوق الوارد الخاص بك.",
            },
            PAYMENT: {
                "ACCOUNT_INFO": "معلومات الحساب",
                "ADD": "إضافة دفعة",
                "AMOUNT": "المبلغ",
                "AMOUNT_MUST_PAY": "يرجى إيداع {{value}} في هذا الحساب ثم تسجيل معلومات الدفع الخاصة بك.",
                "AMOUNT_MUST_PAY_CASH": "يرجى تسليم مبلغ {{value}} إلى الموقع المحدد ثم تسجيل معلومات الدفع الخاصة بك.",
                "AMOUNT_OUT_STANSING": "المبلغ المستحق",
                "CREATED_DATE": "تاريخ التقديم",
                "INTER_PAYMENT_INFO": "يرجى إدخال معلومات الدفع",
                "MY_PAYMENTS": "مدفوعاتي",
                "NEW_PAYMENT": "دفعة جديدة",
                "PAYMENT": "الدفع",
                "PAYMENT_AMOUNT": "المبلغ المستحق الدفع",
                "PAYMENT_DATE": "تاريخ الدفع",
                "PAYMENT_DETAILS": "تفاصيل الدفع",
                "PAYMENT_HISTORY": "سجل المدفوعات",
                "PAYMENT_INFO": "معلومات الدفع",
                "PAYMENT_LOCATION": "موقع الدفع",
                "PAYMENT_REF_NUMBER": "رقم المرجع",
                "PAY_AMOUNT": "مبلغ الدفع",
                "PAY_NOW": "دفع",
                "REFRENCE_NUMBER": "رقم الطلب",
                "TRANSACTIONS_PAYMENTS": "دفع المعاملات",
                "SENDER": "المرسل",
                "SENDER_ACCOUNT_NUMBER": "معلومات الحساب",
                "WALLET_ADDRESS": "عنوان المحفظة",
                "HASH": "هاش (Hash)",
                "MEMO": "مذكرة",
                "TAG": "علامة (Tag)",
                "SEND_BY_THIRD_PARTY": "الدفع من حساب طرف ثالث",
                "SUM_OF_TOTAL_AMOUNT_APPROVED": "إجمالي المبلغ المعتمد",
                "TC_ACCOUNT": "حساب TC",
                "TC_PAYMENTS": "مدفوعات TC",
                "TC_SERVICE_ACCOUNT": "حساب TC",
                "TOTAL_AMOUNT_PAID": "إجمالي المبلغ المدفوع",
                "TOTAL_WAITING_FOR_CONFIRMATION": "إجمالي المبلغ المعلق",
                "YOUR_ACCOUNT": "حسابك",
                "YOUR_SERVICE_ACCOUNT": "سيتم التحقق من حسابك بواسطة الخبراء بعد المراجعة.",
                "YOU_HAVE": "لديك",
                "YOUR_REQUEST_WILL_BE_REJECT_AFTER_TIME_FINISHED": "دقائق لإضافة دفعاتك، بعد هذا الوقت سيتم رفض الطلب.",
                "TIME_FINISHED": "انتهى الوقت المحدد لإضافة الدفع",
                E_MONEY: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                REJECTED: "تم رفض الدفع",
                            },
                            BODY: {
                                REJECTED: "تم رفض الدفع للطلب برقم التتبع {{0}}",
                            }
                        }
                    }
                },
                BANK: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                "REJECTED": "تم رفض الدفع",
                                "ACCOUNT_ASSIGNED": "معلومات الدفع",
                            },
                            BODY: {
                                "ACCOUNT_ASSIGNED": "تم تقديم تفاصيل الحساب البنكي للطلب برقم التتبع {{0}}.",
                                "REJECTED": "تم رفض الدفع للطلب برقم التتبع {{0}}",
                            }
                        }

                    }

                },

                CASH: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                REJECTED: "تم رفض الدفع",

                            },
                            BODY: {
                                REJECTED: "تم رفض الدفع للطلب برقم التتبع {{0}}",
                            }
                        }
                    }
                },
                ALERT: {
                    CANT_DELETE_PAYMENT: "لا يمكنك حذف هذا الدفع.",
                }
            },
            PAYMENT_GATEWAY: {
                TRANSACTION_ID: "معرف المعاملة",
                TYPE: "النوع",
                AMOUNT: "المبلغ",
                REQUESTED_AMOUNT: "المبلغ المطلوب",
                REQUESTED_AMOUNT_DETAIL: "المبلغ المطلوب",
                PAY_AMOUNT: "مبلغ الدفع",
                GET_AMOUNT: "المبلغ المستلم",
                SETTLEMENT_AMOUNT: "مبلغ التسوية",
                STATUS: "الحالة",
                MERCHANT: "التاجر",
                CREATED_IP_ADDRESS: "عنوان IP المُنشأ",
                "STATUS_HISTORY": "سجل الحالة",
                "INVOICE_NUMBER": "رقم الفاتورة",
                "TERMINAL_ID": "معرف المحطة",
                "TERMINAL_WALLET": "محفظة المحطة",
                "CONSUMER_WALLET": "محفظة المستهلك",
                "USER": "المستخدم",
                "SETTLEMENT_DATE": "تاريخ التسوية",
                "ADDITIANAL_DATA": "بيانات إضافية",
                "TERMINAL": "المحطة",
                "LOCAL_DATE_TIME": "التاريخ والوقت المحلي",
                "CONSUMER_ID": "معرف المستهلك",
                "RETURN_URL": "عنوان الإرجاع",
                "STATUS_DATE": "تاريخ الحالة:",
                EXCHANGE_RATE: "سعر الصرف",
            },
            ALERT: {
                "ONLINE_PAYMENT": "يرجى استخدام البطاقة المحددة في صفحة الدفع الخاصة بـ TopChange لإكمال المعاملة. وإلا، فلن يتم تنفيذ طلبك، ولن يكون المبلغ قابلًا للتتبع لمدة تصل إلى 72 ساعة!",
                "ADD_NEW_BANK": "إذا كنت مهتمًا بإضافة حساب بنكي جديد.",
                "AMOUNT_MUST_BE_INTEGER": "يجب أن يكون المبلغ بالأرقام.",
                "AMOUNT_PRECISION_ERROR": "يجب أن يكون النطاق العشري أقل من...",
                "BETWEEN_MY_WALLET_SUCCESS": "تم تحويل الأموال بنجاح بين المحافظ المطلوبة",
                "CAN_SEND_MESSAGE": "يتم تفعيل إرسال الرسائل بعد تسجيل الطلب",
                "COMMISION_DATA_NOT_FOUND": "لم يتم العثور على معلومات العمولة.",
                "COMMISSION_DATA_IS_NOT_DEFIENED": "لم يتم تسجيل معلومات العمولة.",
                "CONFIRM_PAYMENT_DELETE": "هل أنت متأكد من أنك تريد حذف هذا الدفع؟",
                "CONFIRM_REQUEST_DELETE": "هل أنت متأكد من أنك تريد حذف هذا الطلب؟",
                "CURRENCY_EXCHANGE_RATE_LIST_NOT_FOUND": "لم يتم العثور على قائمة العمولات الخاصة بتبادل العملات.",
                "CURRENCY_LIST_IS_NOT_FOUND": "لم يتم العثور على قائمة العملات.",
                "ONLINE_SUCCESS": "تم الدفع بنجاح وتم شحن محفظتك.",
                "PAYMENT_ADD_SUCCESSFUL": "تم تقديم دفعتك بنجاح.",
                "PAYMENT_DELETED_SUCCESS": "تم حذف الدفعة المحددة بنجاح.",
                "PAYMENT_TEXT": "طلبك في حالة الدفع.",
                "PROCESSING_TEXT": "طلبك قيد المعالجة.",
                "REJECTED_TEXT": "تم رفض طلبك.",
                "REQUEST_DELETED_SUCCESS": "تم حذف الطلب المحدد بنجاح.",
                "REQUEST_WAS_NOT_FOUND": "لم يتم العثور على الطلب.",
                "THERE_IS_NO_MESSAG": "لا توجد رسالة للعرض.",
                "THERE_IS_NO_MESSAGE": "لا توجد رسالة للعرض.",
                "THERE_IS_NO_MESSAGE_NEW": "لا توجد رسالة حاليًا.",
                "USE_V1": "عزيزي المستخدم، لمتابعة هذا الطلب، يرجى الرجوع إلى الإصدار القديم من الموقع.",
                "WAITING_FOR_INFORMATION": "يرجى انتظار معلومات الدفع.",
                "WAITING_MESSAGE": "عزيزي المستخدم، يرجى الانتظار حتى يقوم خبراؤنا بمراجعة طلبك",
                "WAIT_FOR_GET_BANK_ACCOUNT_DETAILS": "تم تقديم طلبك بنجاح، وسيتم إخطارك قريبًا بمعلومات الحساب البنكي للدفع عبر الإشعارات. يمكنك الخروج من الطلب في هذه المرحلة وبعد استلام المعلومات، قم بتسجيل الدفع لإكمال شحن محفظتك.",
                "WAIT_FOR_PROCESS_CREDIT_REQUEST": "عزيزي المستخدم، بعد مراجعة وتأكيد معلومات الدفع الخاصة بك من قبل خبرائنا، سيتم شحن المحفظة المطلوبة.",
                "WAIT_FOR_PROCESS_WITHDRAW_CASH_PAYMENT": "عزيزي المستخدم، بعد مراجعة وتأكيد طلبك من قبل خبرائنا، سيتم تحويل المبلغ إلى المستلم المطلوب.",
                "WAIT_FOR_PROCESS_WITHDRAW_PAYMENT_REQUEST": "عزيزي المستخدم، بعد مراجعة وتأكيد طلبك من قبل خبرائنا، سيتم إيداع المبلغ في الحساب المطلوب.",
                "WAIT_FOR_PROCESS_WITHDRAW_BANK_PAYMENT_REQUEST": "تم تقديم طلب السحب الخاص بك. يرجى ملاحظة أن جميع عمليات سحب الريال في TopChange تتم معالجتها عبر نظام PAYA البنكي. لذلك، يجب عليك الانتظار حتى مساء اليوم التالي لاستلام المبلغ. من الواضح أنه لن تكون هناك تسويات من نظام PAYA أيام الجمعة والعطلات الرسمية. أيضًا، كن على علم بأنه بعد اكتمال طلبك، لن يقوم TopChange بخصم المبلغ من محفظتك إلا بعد التأكد من استلامك للمبلغ في حسابك. لا يمكن إلغاء أي طلب سحب بعد تقديمه.",
                "WAIT_FOR_PROCESS_WITHDRAW_BANK_PAYMENT_REQUEST2": "يرجى الانتظار حتى مساء اليوم التالي لاستلام المبلغ والتواصل مع قسم الدعم فقط بعد انقضاء الوقت المذكور.",
                "WAIT_TILL_ACCEPT_PAYMENT": "يرجى انتظار تأكيد الدفع من قبل الخبراء",
                "WHAIT_FOR_ASSIGN_PAYMENT": "يرجى انتظار معلومات الدفع من الخبراء.",
                "WITHDRAWAL_POINT_SUCCESS": "تم سحب النقاط بنجاح وإيداع المبلغ في المحفظة المطلوبة.",
                "MIN_ORDER": "يجب أن يكون الحد الأدنى للطلب أكبر من {{value}}",
                "MAX_ORDER": "يجب أن يكون الحد الأقصى للطلب أقل من {{value}}",
                "NEED_VERIFY": "لاستخدام هذا القسم، يجب عليك إجراء التحقق المطلوب",
                REQUEST_SUCCESS_WAITING: 'تم تسجيل طلبك وهو قيد المراجعة حالياً.',
                ALERT_REQUEST_SUCCESS_WAITING_TEXT: 'سيتم مراجعة طلبك خلال الساعات القادمة، وسيتم تطبيقه على رصيد المحفظة المطلوبة.'
            },
            SELECTED_WALLET: "تم الاختيار ",
            CURRENCY: "العملة",
            NOTIFY: {
                TITLE: {
                    "DEPOSIT_E_MONEY": "إيداع (الأموال الإلكترونية)",
                    "DEPOSIT_MONEY_CURRENCY": "إيداع (الدفع المحلي)",
                    "EXCHANGE_MONEY_CURRENCY": "التبادل (المحفظة)",
                    "POINT": "سحب النقاط",
                    "RECEIVE_OTHER_WAY": "استلام (الدفع المحلي)",
                    "RECEIVE_TC_WALLET": "استلام (المحفظة)",
                    "SEND_OTHER_WAY": "إرسال (الدفع المحلي)",
                    "SEND_TC_WALLET": "إرسال (الأموال الإلكترونية)",
                    "VOUCHER": "قسيمة",
                    "WITHDRAWAL_E_MONEY": "سحب (الأموال الإلكترونية)",
                    "WITHDRAWAL_MONEY_CURRENCY": "سحب (الدفع المحلي)",
                    "DEPOSIT_CRYPTO": "إيداع (العملات الرقمية)",
                    "WITHDRAWAL_CRYPTO": "سحب (العملات الرقمية)",
                },
                NOTIFICATION: {
                    TITLE: {
                        MESSAGE: "رسالة طلب الإيداع",
                    },
                    BODY: {
                        "DONE": "تم تنفيذ الطلب برقم التتبع {{0}} بنجاح. تم إيداع {{1}} في محفظتك.",
                        "MESSAGE": "تم إرسال رسالة من قبل الخبير للطلب برقم التتبع {{0}}.",
                        "REFUND": "تم إعادة الطلب برقم التتبع {{0}}.",
                        "REJECT": "تم رفض الطلب برقم التتبع {{0}}.",
                    }
                }
            },
            COMMISSION: {
                "BONUS": "مكافأة",
                "BONUS_FIXED_AMOUNT": "المبلغ الثابت",
                "BUY_AMOUNT": "مبلغ الشراء",
                "CALCULATED_AMOUNT": "المبلغ المحسوب مع العمولة",
                "CHARGE_AMOUNT": "مبلغ الإيداع",
                "COMMISSION": "العمولة",
                "CONVERTED_AMOUNT": "مبلغ التبادل",
                "EXCHANGE_RATE": "سعر الصرف",
                "FIXED_AMOUNT": "المبلغ الثابت",
                "GET_AMOUNT": "المبلغ المستلم",
                "GET_AMOUNT_THIRD_PARTY": "المبلغ المستلم من طرف ثالث",
                "INITIAL_COST": "التكلفة الأولية",
                "MAXIMUM_COMMISION": "الحد الأقصى للعمولة",
                "MINIMUM_COMMISION": "الحد الأدنى للعمولة",
                "MAXIMUM_BONUS": "الحد الأقصى للمكافأة",
                "MINIMUM_BONUS": "الحد الأدنى للمكافأة",
                "PAY_AMOUNT": "مبلغ الدفع",
                "POINT": "نقطة",
                "REQUESTED_AMOUNT": "المبلغ المطلوب",
                "SELL_AMOUNT": "مبلغ البيع",
                "SEND_AMOUNT": "مبلغ الإرسال",
                "UPDATE_TIME": "تحديث",
                "WITHDRAWAL_AMOUNT": "مبلغ السحب",
                "CALCULATED_AMOUNT_BUNOS": "المبلغ المحسوب",
                "CALCULATIONS": "الحسابات",
                "CALCULATION_DETAILS": "تفاصيل الحساب",
            },

            "DIGITAL_CURRENCY_CRYPTO": "العملات الرقمية",
            "TRANSACTION_NETWORK": "شبكة المعاملة",
            "TRANSACTION_ID": "معرف المعاملة",
            "AMOUNT_CRYPTO": "المبلغ",
            "REQUESTED_DATE_TRANSACTION": "تاريخ المعاملة",
            "MORE": "المزيد",
            "DEPOSIT_METHOD": "طريقة الإيداع",
            "TRANSACTION_SOURCE_ADDRESS": "عنوان مصدر المعاملة",
            "TRANSACTION_DESTINATION_ADDRESS": "عنوان وجهة المعاملة",
            "RECEIVED_AMOUNT": "المبلغ المستلم",
            "MORE_INFORMATION": "مزيد من المعلومات",
            "POINTS_CRYPTO": "النقاط",
            "VIEW_TRANSACTION_LINK": "عرض رابط المعاملة",
            DIRECTDEPOSIT: {
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            DIRECT_DEPOSIT: {
                                SUCCESSFUL: 'تم التحويل البنكي بنجاح',
                                REFUND: 'تم استرجاع التحويل البنكي'
                            }
                        },
                        BODY: {
                            DIRECT_DEPOSIT: {
                                SUCCESSFUL: 'تم استلام تحويلك البنكي وتم شحن محفظتك بنجاح.',
                                REFUND: 'نظرًا لأن الحساب المرسل لم يكن مسجلاً في توب تشينج، فقد تم استرجاع المبلغ المحوّل إلى حسابك البنكي.'
                            }
                        }
                    }
                }
            }
        },
        HISTORY: {
            "SERVICE": "الأموال الإلكترونية",
            "WALLET": "المحفظة",
            "REQUEST_STATUS": "حالة الطلب",
        },
        PROFILE: {
            "ACCOUNT_INFO": "معلومات الحساب",
            "CONTACT_INFO": "معلومات الاتصال",
            "ADDRESS": "العنوان",
            "ADDRESSES_DOC": "اختر وثيقة إثبات السكن",
            "ADDRESS_INFO": "العنوان",
            "BACK_IMAGE": "الجهة الخلفية للبطاقة",
            "BACK_OF_ID_CARD": "اختر صورة الجهة الخلفية لبطاقة الهوية",
            "BIRTH_DATE": "تاريخ الميلاد",
            "CHANGE_PASSWORD": "تغيير كلمة المرور",
            "CHANGE_YOUR_PHONE_NUMBER_QUESTION": "هل ترغب في تغيير رقم هاتفك المحمول؟",
            "CITY": "المدينة",
            "PHONECALL_INTERVIEW": "مقابلة هاتفية",
            "KYC": "التحقق من الهوية (KYC)",
            "LETTER_OF_COMMITMENT": "خطاب الالتزام",
            "CONFIRM_NEW_PASSWORD": "تأكيد كلمة المرور الجديدة",
            "COUNTRY": "الدولة",
            "DRIVING_LICENSE": "رخصة القيادة",
            "EDIT_MOBILE_INFO": "لتغيير رقم هاتفك المحمول، يجب أولاً تأكيد رقمك الحالي",
            "ENTER_CODE": "أدخل الرمز",
            "ENTER_YOUR_PHONE_NUMBER": "أدخل رقم هاتفك المحمول",
            "FRONT_IMAGE": "الصورة الأمامية",
            "FRONT_OF_ID_CARD": "اختر صورة الجهة الأمامية لبطاقة الهوية",
            "IDENTITY_CARD": "بطاقة الهوية",
            "IF_IMAGE_NOT_GOOD": "إذا لم تكن جودة الصورة جيدة بما يكفي",
            "IMAGE_DETAIL": "تفاصيل الصورة",
            "LANDLINE_NUMBER": "رقم الهاتف الأرضي",
            "MOBILE_NUMBER": "رقم الهاتف المحمول",
            "NEW_PASSWORD": "كلمة مرور جديدة",
            "NOT_VERIFIED": "غير مُحقق",
            "NOT_VERIFIED2": "غير مُحقق",
            "NOT_VERIFIED3": "غير مُحقق",
            "OLD_PASSWORD": "كلمة المرور السابقة",
            "PASSPORT": "جواز السفر",
            "PERSONAL_INFO": "المعلومات الشخصية",
            "PHONE_NUMBER": "رقم الهاتف المحمول",
            "PHOTO": "الصورة",
            "PLEASE_VERFY_PROFILE": "لاستخدام خدمات الموقع، يرجى تأكيد معلوماتك",
            "REG_DATE": "تاريخ التسجيل",
            "SELECT_ONE_BELOW_OPTIONS": "يرجى اختيار أحد الخيارات التالية",
            "STATE": "الولاية",
            "TAKE_IMAGE": "التقاط صورة",
            "TAKE_NEW_ONE": "التقاط صورة جديدة",
            "TAKE_PIC_DESCRIPTION": "عزيزي المستخدم، لمنع أي انتهاكات وضمان أمان المعاملات، يرجى إرسال صورتك بالمواصفات التالية:<br/>*يجب أن تكون جميع المعلومات مكتوبة على ورقة بيضاء بشكل تلقائي.<br/>*يجب أن يكون حجم الصورة أقل من 2 ميجابايت.<br/> <div class='title'>1- ورقة بيضاء</div> قم بأخذ ورقة بيضاء مع المعلومات المحددة في الصورة أمامك.<br/> <div class='title'>2- إرفاق بطاقة الهوية</div> - قم بإرفاق بطاقة الهوية بالورقة كما هو موضح في الصورة.<br/> <div class='title'>3-الرمز</div>  اكتب الكود الموضح في النموذج التالي بخط يدك على الورقة.<br/> <div class='title'>4- النص</div> أنا ............................ برقم الهوية الوطنية ................. قمت بإرسال مستنداتي للتحقق من هويتي في موقع TopChange في ../../.. . أؤكد أنني لم أقدم هذه المعلومات لأي شخص آخر، وأوافق على عدم شراء أو بيع العملات الرقمية أو الأموال النقدية لأي أطراف ثالثة. أفهم وأوافق على جميع المسؤوليات التي تأتي مع مشاركتي في كلا الموقعين المذكورين<br/> <div class='title'>5-التوقيع</div>  توقيعك.",
            "TITLE": "الملف الشخصي",
            "UPLOAD_DRIVING_PHOTO": "اختر صورة رخصة القيادة",
            "UPLOAD_IDENTITY_CARD_PHOTO": "رفع بطاقة الهوية",
            "UPLOAD_FRONT_OF_YOUR_IDENTITY_CARD_IMAGE": "رفع صورة الجهة الأمامية لبطاقة الهوية",
            "UPLOAD_BACK_OF_YOUR_IDENTITY_CARD_IMAGE": "رفع صورة الجهة الخلفية لبطاقة الهوية",
            "UPLOAD_IMAGE": "اختر صورة",
            "UPLOAD_IMAGE_FROM_YOUR_STORAGE": "رفع من ذاكرة النظام",
            "UPLOAD_PASSPORT_PHOTO": "اختر صورة جواز السفر",
            "UPLOAD_PHOTO_OF_PASSPORT": "رفع صورة جواز السفر",
            "USER_GROUP": "مجموعة المستخدم",
            "USE_CAMERA_TO_TAKE_IMAGE": "استخدم كاميرا هاتفك لالتقاط صورة.",
            "VERIFICATION": "التحقق",
            "VERIFIED": "تم التحقق",
            "VERIFIED2": "تم التحقق",
            "VERIFY_CURRENT_PHONE_NUMBER": "تأكيد رقم الهاتف المحمول الحالي",
            "VERIFY_NOW": "التحقق من المعلومات",
            "VERIFY_PERSONAL_INFO": "التحقق من المعلومات الشخصية",
            "VERIFY_TEXT": "تحقق",
            "WRITE_BLOW_CODE_ON_PAPER": "اكتب هذا الرمز على ورقة.",
            "YOUR_PHONE_NUMBER": "رقم الهاتف المحمول",
            "ZIP_CODE": "الرمز البريدي",
            "VERIFY_DESCRIPTION": "عزيزي المستخدم، من أجل زيادة أمانك ومنع أي انتهاكات من قبل المحتالين، يرجى تأكيد المعلومات التالية",
            "FIRST_NAME": "الاسم الأول",
            "LAST_NAME": "اسم العائلة",
            "BIRTHDAY": "تاريخ الميلاد",
            "BIRTHDATE": "تاريخ الولادة",
            "GENDER": "الجنس",
            "CHANGE_AVATAR": "تغيير الصورة الرمزية",
            "YOUR_PHONE_NUMBER_IS": "رقم هاتفك المحمول هو",
            "SELECT_AVATAR_MESSAGE": 'يرجى تحديد صورة المستخدم ثم الضغط على "إرسال"',
            "SELECT_AVATAR": "اختر الصورة الرمزية",
            "PHONECALL_INTERVIEW_DESCRIPTION": "يرجى ملاحظة أنه للحفاظ على أمان حساب TC الخاص بك وتحسينه، يجب عليك أولاً إكمال التحقق عبر المكالمة الهاتفية لاستخدام الخدمات المالية. يرجى الضغط على الزر أدناه لتلقي مكالمة هاتفية من أحد مسؤولينا. يرجى ملاحظة أنه إذا لم ترد على مكالمة خبرائنا، فلن تتمكن من إعادة تقديم طلب لمقابلة هاتفية خلال 3 ساعات.",
            "PHONECALL_INTERVIEW_DESCRIPTION1": "1. يرجى ملاحظة أنك بحاجة إلى إجراء خطوة التحقق عبر المكالمة الهاتفية فقط إذا كنت تنوي تقديم أي من الطلبات التالية؛ وإلا، يمكنك تخطي هذه الخطوة في عملية التحقق.",
            "ADDRESS_DESCRIPTION1": "2. يرجى ملاحظة أنك بحاجة إلى إجراء خطوة التحقق من العنوان فقط إذا كنت تنوي تقديم أي من الطلبات التالية؛ وإلا، يمكنك تخطي هذه الخطوة في عملية التحقق.",
            "PHONECALL_INTERVIEW_DESCRIPTION2": "3. يرجى ملاحظة أنه في حالة عدم الرد على مكالمة خبرائنا لمدة تصل إلى 3 ساعات، فلن تتمكن من تسجيل طلب لمقابلة هاتفية.",
            "CALL_ME": "اتصل بي!",
            "RETRY_CALL_DIALOG_TEXT": 'يرجى ملاحظة أنه يجب عليك أولاً إكمال التحقق عبر المكالمة الهاتفية لاستخدام الخدمات المالية. يرجى النقر فوق الزر "حاول مرة أخرى" لإتمام العملية.1',
            "WAITING_FOR_PHONECALL": "عزيزي المستخدم، تم إرسال طلبك وسيقوم خبراؤنا بالاتصال بك خلال ساعتين. يرجى التحلي بالصبر.",
            "PHONECALL_INTERVIEW_DONE": "لقد اجتزت مقابلة المكالمة الهاتفية بنجاح!",
            "PHONECALL_INTERVIEW_REJECTED": "تم رفض طلبك",
            "PHONECALL_INTERVIEW_CONFIRM_DES": "عزيزي المستخدم، يرجى ملاحظة أن التحقق عبر المكالمات الهاتفية مطلوب فقط للحالات التالية، وإلا فلن تحتاج إلى هذا التحقق:",
            "SUPPORT": "الدعم",
            "SUSPENDED": "معلق",
            "SUSPEND_ALERT": "محفظة الطلب الخاصة بك",
            "SKIP": "تخطي",
            ERROR: {
                "PASSWORD_MIN_LENGTH": "يجب أن تحتوي كلمة المرور على {{value}} أحرف على الأقل",
                "PASSWORD_MAX_LENGTH": "الحد الأقصى لطول كلمة المرور هو {{value}} أحرف",
                "PASSWORD_IS_NOT_SAME": "تأكيد كلمة المرور الجديدة يختلف عن كلمة المرور الجديدة.",
            },
            REQUESTS_TYPE: {
                "DEPOSIT_E_MONEY": "الإيداع عن طريق الدفع المحلي",
                "DEPOSIT_MONEY_CURRENCY": "الإيداع عن طريق الأموال الإلكترونية",
                "EXCHANGE_MONEY_CURRENCY": "التبادل (محفظة TC)",
                "WITHDRAWAL_POINT": "نقطة السحب",
                "SEND_E_MONEY": "إرسال الأموال الإلكترونية",
                "SEND_TC_WALLET": "الإرسال من محفظة TC",
                "SEND_MONEY_CURRENCY": "الإرسال عن طريق الدفع المحلي",
                "VOUCHER": "شراء قسيمة",
                "WITHDRAWAL_E_MONEY": "السحب عن طريق الأموال الإلكترونية",
                "WITHDRAWAL_MONEY_CURRENCY": "السحب عن طريق الدفع المحلي",
            },
            VERIFY: {
                "VERIFY": "التحقق",
                "REQUIRED": "مطلوب",
                "OPTIONAL": "اختياري",
                TYPE: {
                    "ADDRESS": "معلومات العنوان",
                    "PERSONAL": "المعلومات الشخصية",
                    "PERSONAL_IDENTITY": "المعلومات الشخصية",
                    "PERSONAL_PASSPORT": "المعلومات الشخصية",
                    "DRIVER_LICENSE": "المعلومات الشخصية",
                    "PHOTO_UPLOAD": "معلومات الصورة",
                    "PHOTO_CAMERA": "معلومات الصورة",
                    "PHOTO": "صورة",
                },
                NOTIFY: {

                    TITLE: {
                        VERIFY_INFO: "التحقق من المعلومات",
                    },
                    NOTIFICATION: {
                        BODY: {
                            "ACCEPTED": "تم التحقق من {{0}}.",
                            "REJECTED": "تم رفض {{0}}.",
                        }
                    },
                    KYC: {
                        NOTIFICATION: {
                            TITLE: {
                                "ACCEPTED": "التحقق من الهوية (KYC)",
                                "REJECTED": "التحقق من الهوية (KYC)",
                            },
                            BODY: {
                                "REJECTED": "تم رفض هويتك في النظام.",
                                "ACCEPTED": "تم التحقق من هويتك بنجاح في النظام.",
                            }
                        }
                    }
                },
                KYC: {
                    "INFORMATION": "المعلومات",
                    "ENTER_TO_KYC": "الدخول إلى التحقق من الهوية (KYC)",
                    "IRANIAN_USERS_CONFIRM_ALERT": "إذا كانت الدولة التي أصدرت مستنداتك هي إيران، يرجى إدخال اسمك ولقبك باللغة الفارسية.",
                    "DESCRIPTION": "عزيزي المستخدم، من أجل زيادة الأمان ومنع أي انتهاكات من قبل المحتالين، يرجى إكمال عملية التحقق الخاصة بك",
                    "ALERT_ERROR": "للأسف، فشل التحقق الخاص بك، يرجى الاتصال بفريق الدعم",
                    "ALERT_DONE": "تم إكمال عملية التحقق الخاصة بك بنجاح.",
                    "ALERT_WAITING": "إكمال عملية التحقق...",
                },
                LETTER_OF_COMMITMENT: {
                    "ALERT_DONE": "لقد قمت بتقديم خطاب الالتزام الخاص بك بنجاح.",
                    "ALERT_MISS_MATCH_DATA": "للأسف، فشل التحقق الخاص بك، يرجى الاتصال بفريق الدعم",
                    "TEXT": "أنا {{name}} برقم الهوية الوطنية {{code}} أرسلت مستنداتي إلى Top Change للتحقق، وأؤكد أن التسجيل قد تم من قبلي. أوافق أيضًا على عدم قبول أي أموال نقدية أو عملات رقمية بأي شكل من الأشكال مقابل السماح لأي شخص باستخدام حسابي. أؤكد أنني لم أقدم تفاصيل حسابي البنكي لأي شخص آخر، وإذا تلقيت إيداعًا غير قانوني، فسأتحمل المسؤولية القانونية، بما في ذلك العقوبات القانونية والتعويض للمدعي.",
                    "CONFIRM_CHECKBOX": "أؤكد صحة المعلومات أعلاه",
                    "MISS_MATCH_DATA": "بيانات غير متطابقة",
                }
            },
            ALERT: {
                "ADDRESS_HAS_BEEN_UPDATED": "تم تحديث معلومات عنوانك بنجاح.",
                "ADDRESS_IS_OPTIONAL": "يرجى ملء نموذج معلومات العنوان أولاً لتفعيل قسم تأكيد المعلومات الشخصية لك",
                "ADDRESS_UPLOAD_HINT": "ملاحظة: لتأكيد العنوان، يرجى تحميل نسخة واضحة من أحد المستندات الصالحة مثل فاتورة هذا العام (الهاتف الأرضي، المياه، الكهرباء، الغاز)، سند الملكية، أو عقد الإيجار والتأمين على المركبات. لتأكيد المعلومات، يجب أن يكون العنوان المدخل في النظام متطابقًا مع المعلومات الموجودة على الفاتورة المقدمة.",
                "ADDRESS_VERIFYED": "تم التحقق من عنوانك بنجاح",
                "ADDRESS_VERIFY_IS_PENDING": "يتم حاليًا مراجعة معلومات عنوانك من قبل خبرائنا.",
                "DOCUMENTS_UPLOADED": "تم تحميل المستندات بنجاح",
                "ERROR_ADDRESS_INFO_NOT_VERIFIED": "لم يتم التحقق من معلومات عنوانك",
                "ERROR_ADDRESS_INFO_REJECTED": "تم رفض طلب التحقق من عنوانك.",
                "ERROR_PERSONAL_INFO_NOT_VERIFIED": "لم يتم التحقق من معلوماتك الشخصية",
                "ERROR_PERSONAL_INFO_REJECTED": "تم رفض طلب التحقق من معلوماتك الشخصية",
                "ERROR_PHOTO_VERIFY_REJECTED": "تم رفض طلب التحقق الخاص بك",
                "MOBILE_NUMBER_HAS_BEEN_VERIFIED": "تم التحقق من رقم هاتفك المحمول بنجاح",
                MOBILE_NUMBER_HAS_BEEN_SUCCESSFULLY_REGISTERED: "تم تسجيل رقم هاتفك المحمول بنجاح.",
                "NEED_FILL_ADDRESS_FORM": "تأكيد العنوان ليس إلزاميًا، ولكن إذا كنت ترغب في الاستفادة من جميع ميزات الموقع، فيجب عليك تأكيد عنوانك",
                "NEED_FILL_PERSONAL_FORM": "يرجى ملء نموذج المعلومات الشخصية أولاً لتفعيل قسم التحقق من معلومات المستخدم لك",
                "PASSWORD_CHANGED_SUCCESSFULLY": "تم تغيير كلمة المرور بنجاح! يرجى تسجيل الدخول مرة أخرى",
                "PASSWORD_MAX_LENGTH": "يجب أن تحتوي كلمة المرور على… أحرف كحد أقصى.",
                "PASSWORD_MIN_LENGTH": "يجب أن تحتوي كلمة المرور على… أحرف على الأقل.",
                "PEERSONAL_INFO_HAS_BEEN_UPDATED": "تم تحديث معلوماتك الشخصية بنجاح.",
                "PERSONAL_INFO_SHOULD_MATCH_WITH_ID_CARD": "ملاحظة: يجب أن تتطابق المعلومات الشخصية المدخلة مع بطاقة الهوية أو جواز السفر.",
                "PERSONAL_INFO_VERIFYED": "تم التحقق من معلوماتك بنجاح.",
                "PERSONAL_INFO_VERIFY_IS_PENDING": "يتم حاليًا مراجعة معلوماتك من قبل خبرائنا.",
                "PHOTO_VERIFY_ACCEPTED": "تم التحقق من هويتك بنجاح.",
                "PHOTO_VERIFY_IS_PENDING": "يتم حاليًا مراجعة معلوماتك من قبل خبرائنا.",
                "VERIFY_NEEDS": "لم يتم التحقق من معلوماتك الشخصية.",
                "CAMERA_PERMISSION_ERROR": "لاستخدام هذا الخيار، اسمح للمتصفح بالوصول إلى الكاميرا.",
                "NOT_FOUND_CAMERA": "جهازك لا يحتوي على كاميرا.",
            }

        },
        NOTIFICATION: {
            "ADMIN": "الدعم",
            "DESCRIPTION": "الوصف",
            "EMPTY": "لا يوجد إشعارات",
            "EMPTY_FRIENDS": "لا يوجد طلب جديد",
            "EMPTY_TICKETS": "لا يوجد شيء لعرضه",
            "FRIENDS": "الأصدقاء",
            "ME": "أنا",
            "NEW": "جديد",
            "NOTIFICATIONS": "الإشعارات",
            "SELL_SUCCESSFUL": "بيع ناجح",
            "BUY_SUCCESSFUL": "شراء ناجح",
            "MY_ORDERS": "طلباتي",
            "REGISTER_NEW_AD": "تسجيل إعلان جديد",
            "SELL": "بيع",
            "TICKETS": "التذاكر",
            "TITLE": "إشعار",
            "TYPE": "نوع الإشعار",
            ALERTS: 'التنبيهات',
            YOU_HAVE_NO_NEW_MESSAGES: 'ليس لديك رسائل جديدة.',
            SHOW_ALL: "عرض الكل",
            READ_ALL: 'اقرأ الكل',
            ANNOUNCEMENT: 'الإعلانات',
        },
        P2P: {
            DEPOSIT_PAGE: {
                "EARN_MORE_P2P": "اربح المزيد مع P2P واحصل على جوائز",
                "SALE": "البيع",
            },
            USER: {
                NOTIFICATION: {
                    BODY: {
                        ADVERTISEMENT: {
                            "INPROGRESS": 'لديك مشتري للإعلان عن البيع <span class="fa-number-dir">&rlm;{{0}}<span>{{3}}</span></span>.',
                            "CREATED": 'تم تسجيل إعلان البيع الخاص بك <span class="fa-number-dir">&rlm;{{0}}<span>{{3}}</span></span> (P2P) بنجاح.',
                            "DONE": 'تم إكمال إعلان البيع الخاص بك <span class="fa-number-dir">&rlm;{{0}}<span>{{3}}</span></span> (P2P) بنجاح.',
                            "CANCEL": 'تم إلغاء إعلان البيع الخاص بك <span class="fa-number-dir">&rlm;{{0}}<span>{{3}}</span></span> (P2P) بنجاح.',
                            "CLOSED": 'تم إغلاق إعلان الشراء الخاص بك <span class="fa-number-dir">&rlm;{{0}}<span>{{3}}</span></span> (P2P).',
                            RETURN: {
                                REMAIN: {
                                    AMOUNT: {
                                        "P2P.USER.NOTIFICATION.BODY.ADVERTISEMENT.RETURN.REMAIN.AMOUNT.DONE": "إعلان البيع الخاص بك <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{2}}</span></span> (P2P) انخفض إلى أقل من الحد الأدنى للشراء وتم تحويل <span class=\"fa-number-dir\">&rlm;{{1}}<span>{{2}}</span></span> إلى المحفظة {{3}}.",
                                    }
                                }
                            },
                            ORDER: {
                                TAKECOLLATERAL: "تم أخذ مبلغ <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> من الضمان الخاص بك من قبل الدعم.",
                            }
                        },
                        SELLER: {
                            DONE: "تم إكمال طلب البيع الخاص بك <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) بنجاح.",
                        },
                        BUYER: {
                            DONE: "تم إكمال طلب الشراء الخاص بك <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) بنجاح.",
                        },
                        ORDER: {
                            "CONFIRM": "عزيزي المستخدم، يرجى التحقق من صلاحية الدفع وإطلاق إعلان البيع <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> (P2P) في أقرب وقت ممكن.",
                            "TAKECOLLATERAL": "تم أخذ مبلغ <span class=\"fa-number-dir\">&rlm;{{2}}<span>{{3}}</span></span> من الضمان الخاص بك من قبل الدعم.",
                        }
                    },
                    TITLE: {
                        ADVERTISEMENT: {
                            "INPROGRESS": "طلب شراء P2P",
                            "CREATED": "إعلان مبيعات P2P",
                            "DONE": "إعلان مبيعات P2P",
                            "CANCEL": "إلغاء إعلان P2P",
                            "CLOSED": "إغلاق إعلان P2P",
                            RETURN: {
                                REMAIN: {
                                    AMOUNT: {
                                        DONE: "إعادة المبلغ المتبقي P2P",
                                    }
                                }
                            },
                            ORDER: {
                                TAKECOLLATERAL: "الضمان P2P",
                            }
                        },
                        ORDER: {
                            CONFIRM: "تأكيد الدفع P2P",
                            TAKECOLLATERAL: "الضمان P2P",
                        },
                        SELLER: {
                            DONE: "طلب مبيعات P2P",
                        },
                        BUYER: {
                            DONE: "طلب شراء P2P",
                        }
                    }
                }
            },
            ADMIN: {
                NOTIFICATION: {
                    TITLE: {
                        ADVERTISEMENT: {
                            CANCEL: "إلغاء إعلان P2P",
                        }
                    },
                    BODY: {
                        ADVERTISEMENT: {
                            CANCEL: "تم إلغاء إعلانك بمعرف المعاملة {{1}} من قبل الدعم.",
                        }
                    }
                }
            },
            "FILTER": "تصفية",
            "TYPE": "النوع",
            "STATUS": "الحالة",
            "WALLET": "المحفظة",
            "SELECT_WALLET": "اختيار المحفظة",
            "FROM_DATE": "من تاريخ",
            "TO_DATE": "إلى تاريخ",
            "CLEAR_ALL": "مسح الكل",
            "SEARCH": "بحث",
            "TRACKING_NUMBER": "رقم التتبع",
            "OPERATION": "العملية",
            "VALUE": "القيمة",
            "PAYMENT_METHOD": "طريقة الدفع",
            "REQUEST_DATE": "تاريخ الطلب",
            "BUYERS": "المشترون",
            "BUYER": "المشتري",
            "TABLE_EMPTY_MESSAGE": "لم يتم العثور على نتائج!",
            "BUY": "شراء",
            "SELL": "بيع",
            "DONE": "تم",
            "IN_PROGRESS": "قيد التنفيذ",
            "SUPPORT": "الدعم",
            "CLOSED": "مغلق",
            "TRANSFER_RATE": "سعر التحويل",
            "PRICE": "السعر",
            "BACK": "الرجوع",
            "RELEASE": "تحرير",
            "CARD_NUMBER": "رقم البطاقة",
            "DEPOSIT": "إيداع",
            "DOCUMENT": "المستند",
            "RECEIVE_CONFIRMATION_TITLE": "هل أنت متأكد من صحة دفعة المشتري؟",
            "CONFIRM_CONTINUE": "تأكيد والمتابعة",
            "CONFIRM": "تأكيد",
            "CANCEL": "إلغاء",
            "GET_CODE": "إرسال الرمز",
            "CHECK_AGAIN": "تحقق مرة أخرى",
            "TWO_STEP_VERIFICATION": "التحقق الثنائي للحساب",
            "CALL_SUPPORT": "الاتصال بالدعم",
            "ENTER_CONVERSATION": "طلب المساعدة",
            "MY_ADS": "إعلاناتي",
            "CREATE_NEW_AD": "إنشاء إعلان جديد",
            "SOLD_PERCENTAGE": "نسبة البيع",
            "SELLABLE_AMOUNT": "المبلغ المتاح",
            "SOLD_AMOUNT": "المبلغ المباع",
            "EXCHANGE_REATE": "معدل التحويل",
            "AD_CREATE_DATE": "تاريخ تسجيل الإعلان",
            "SHOW_ORDER": "عرض الطلب",
            "PERCENTAGE": "النسبة المئوية",
            VALIDATION: {
                "CANT_BE_MORE_THAN_REQUEST_AMOUNT": "يجب ألا يكون المبلغ أكبر من المبلغ القابل للبيع",
                "CANT_BE_SET_ZERO": "لا يمكن أن يكون المبلغ صفرًا",
                "CANT_BE_LESS_VALUE": "لا يمكن أن يكون المبلغ أقل من {{value}}",
                "SELECT_WALLET_FIRST": "يرجى تحديد المحفظة التي تريدها",
                "AMOUNT_CANT_BE_MORE_THAN_BALANCE": "لا يمكن أن يكون المبلغ أكبر من رصيد المحفظة",
                "AMOUNT_CANT_BE_MORE_THAN_ADV_AMOUNT": "لا يمكن أن يكون المبلغ المطلوب أكبر من إجمالي مبلغ الإعلان",
                "AMOUNT_CANT_BE_LESS_THAN_TEN": "لا يمكن أن يكون المبلغ المطلوب أقل من 10 {{value}}",
                "AMOUNT_CANT_BE_LESS_THAN": "لا يمكن أن يكون المبلغ المطلوب أقل من {{value}} {{currency}}",
                "AMOUNT_CANT_BE_SET_ZERO": "لا يمكن أن يكون المبلغ المطلوب صفرًا",
                "AMOUNT_CANT_BE_MORE_MAX_PAY": "لا يمكن أن يكون المبلغ المطلوب أكبر من {{amount}} {{currency}}",
            },
            DESCRIPTION: {
                "RELEASE_PROPERTY": "يرجى الإفراج عن الممتلكات المباعة خلال الوقت المحدد. وإلا، سيقوم المشتري بالاتصال بالدعم وبعد التحقق، سيقوم خبراء المنصة بتحويل العملة المباعة إلى محفظة المشتري.",
                "PAYMENT_LIMIT": "بسبب الحد الأقصى للدفع من خلال التحويل البنكي بين البطاقات، من الممكن أن يكون المشتري قد استخدم عدة بطاقات بنكية، لذا يرجى التحقق من معلومات الإيداع بعناية.",
                "INFORMATION_DISCREPANCY": "في حالة وجود أي تناقض في معلومات الدفع الخاصة بالبائع، لا تقم بالإفراج عن عملتك واضغط على زر \"معلومات غير صحيحة\". لن نكون مسؤولين عن استرداد مدفوعاتك في حالة الإفراج الخاطئ.",
                "IMPORTANT_INFORMATION": "لا تعطي معلوماتك المصرفية الحساسة للمستخدمين حتى لا يتم إساءة استخدامها.",
                "TRANSFORM_THROUGH_CHANNEL": "يجب ألا تستخدم أي طريقة تحويل أموال يتم الإعلان عنها عبر قنوات خارجية مثل شبكات التواصل الاجتماعي أو تطبيقات المراسلة أو الإعلانات المباشرة. المنصة غير مسؤولة عن أي أضرار تحدث خارجها. كما أن المنصة لا تدعم P2P في أي مكان.",
                "PAYMENT_SPECIFIED_TIME": "يرجى إجراء الدفع خلال الوقت المحدد والتأكد من النقر على زر \"تم الدفع التالي\". بعد تأكيد البائع للدفع، يقوم النظام بتحويل الأصل الرقمي إلى حسابك.",
                "POSSIBLE_MULTIPLE_CARD": "بسبب الحد الأقصى للدفع من خلال التحويل بين البطاقات، من الممكن استخدام عدة بطاقات بنكية.",
                "DEPOSIT_FROM_ACCOUNT": "يرجى ملاحظة أنه يجب عليك إيداع الأموال من الحساب المصرفي الذي تختاره. في حالة وجود أي تناقض في معلومات الدفع، لن يقوم البائع بالإفراج عن العملة ولن يكون مسؤولًا عن استرداد دفعتك.",
                "DEPOSIT_AMOUNT_CORRECTLY": "كن حذرًا عند إيداع الأموال، قم بإيداع المبلغ الصحيح. إذا كان مبلغ الإيداع منخفضًا، فستقوم المنصة بإيداع عملة تعادل المبلغ المودع في محفظتك. أيضًا، إذا قمت بإيداع مبلغ أكثر من المطلوب، حاول التحدث إلى البائع وحل المشكلة. المنصة لن تكون مسؤولة في هذا الصدد.",
                "AFTER_EACH_PAYMENT": "بعد كل دفعة، أدخل رقم بطاقتك، رقم التتبع (الإحالة)، ومبلغ الدفع، كما يجب عليك تحميل صورة إيصال الدفع في المكان المخصص.",
                "PAYMENT_RECEIPT": "يرجى الاحتفاظ بإيصال الدفع حتى نهاية المعاملة.",
                "PAY_ATTENTION": "انتبه للوقت المتبقي للدفع.",
                "PAY_WITH_BANK": "للدفع باستخدام بطاقة بنكية، يمكنك إرسال المبلغ باستخدام بطاقة واحدة أو عدة بطاقات.",
                "NOTE_BANK_CARDS": "يجب أن تكون جميع البطاقات البنكية المستخدمة باسمك. وإلا، قد يرفض البائع الدفع، وقد يتم إلغاء المعاملة ولن تكون المنصة مسؤولة عن ذلك.",
                "ENSURE_AMOUNT_SEND": "تأكد من أن المبلغ الذي ترسله ليس أقل أو أكثر من المبلغ المطلوب. إذا كان كذلك، فسيكون على المنصة الاتصال بالبائع، وقد تستغرق معالجة المشكلة وقتًا طويلًا.",
                "AFTER_PAYMENT": "بعد كل دفعة، أدخل رقم بطاقتك، رقم الإحالة، والمبلغ المدفوع، كما يجب عليك تحميل صورة إيصال الدفع في المكان المخصص.",
                "PAYMENT_RECEIPTS": "يرجى الاحتفاظ بإيصالات الدفع حتى تكتمل المعاملة.",
                "CONDUCT_TRANSACTION": "تحت أي ظرف من الظروف، لا ينبغي عليك إجراء معاملة تحويل أموال عبر قناة خارجية مثل وسائل التواصل الاجتماعي أو تطبيقات المراسلة أو المعاملات المباشرة. المنصة ليست مسؤولة عن أي خسائر أو أضرار ناتجة عن المعاملات التي تتم خارج المنصة.",
                "ADDITIONALLY": "بالإضافة إلى ذلك، لا تتدخل المنصة في معاملات P2P وتوفر فقط البنية التحتية لمعاملاتك.",
            },
            "CUSTOMER_PAYMENT_INFORMATION": "معلومات دفع العميل",
            "PAYMENT_INFORMATION": "معلومات الدفع",
            "TOO_MUCH_DEPOSITED": "",
            "EXCESS_AMOUNT": "المبلغ الزائد",
            "REMAINING_RELEASE_TIME": "الوقت المتبقي للإفراج",
            "CHAT_WITH_SUPPORT": "الدردشة مع الدعم",
            "ENTER_YOUR_MESSAGE": "أدخل رسالتك",
            CONFIRMATION: {
                "CONFIRMING": "يرجى ملاحظة أن تأكيد هذه الرسالة يعني استلام المال بالكامل وتأكيد صحة معلومات الدفع الخاصة بالمشتري.",
                "DISCREPANCIES": "يرجى الاتصال بالدعم إذا لاحظت أي تناقضات.",
                "AFTER_CONFIRMING": "بعد تأكيد هذه الرسالة، سيتم الإفراج عن أموالك ولن تكون المنصة مسؤولة عن ذلك.",
            },
            "EMAIL_CODE": "رمز البريد الإلكتروني",
            "SENT_EMAIL_TEXT": "أدخل الرمز المكون من 6 أرقام المرسل إلى {{value}}.",
            ADVERTISE: {
                "SEARCH": "بحث",
                "CURRENCY_TYPE": "العملة",
                "CURRENCY_AMOUNT": "المبلغ المطلوب",
                "DESIRED_AMOUNT": "المبلغ المطلوب",
                "ACTIVE_ADVERTISES": "الإعلانات النشطة",
                "SELLER": "البائع",
                "TRANSACTION": "المعاملة",
                "COMPLETE": "مكتمل",
                "EXCHANGE_RATE": "سعر الصرف",
                "SELL_AMOUNT": "سعر البيع",
                "SELL": "البيع",
                "MIN": "على الأقل",
                "PAYMENT_METHOD": "طريقة الدفع",
                "BUY_CURRENCY": "شراء العملة",
                "BUY": "شراء",
                "ADVERTISE": "الإعلانات",
                "VIDEOHELP": "دليل الفيديو",
                "CREATE_ADVERTISE": "إنشاء إعلان",
                "MY_ORDERS": "طلباتي",
                "ENTER_AMOUNT": "أدخل مبلغ العملة",
                "PAID_VALUE": "مبلغ دفعتك",
                "SELECT_WALLET": "اختر محفظة",
                "USER": "المستخدم",
                "ORDER": "الطلب",
                "COMPLETED": "مكتمل",
                "AVAILABLE": "متاح",
                "TIME_LIMIT": "حد الإيداع الزمني",
                "MINUTE": "دقائق",
                "CANCEL": "إلغاء",
                "DOLLAR": "دولار",
                "RIAL": "ريال",
                "DERHAM": "درهم",
                "EURO": "يورو",
                "DERHAM_WALLET": "محفظة الدرهم",
                "EURO_WALLET": "محفظة اليورو",
                "DOLLAR_WALLET": "محفظة الدولار",
                "EMPTY_DATA": "غير موجود",
                "ORDER_BY": "الترتيب حسب",
                "NewestListing": "أحدث الإعلانات",
                "LowestPrice": "أدنى سعر صرف",
                "HighestAmount": "أعلى كمية",
                "DEALS": "الصفقات",
                "SUCCESSFUL": "ناجح",
                "AMOUNT": "المبلغ",
            },
            "BUYER_INFORMATION": "معلومات المشتري",
            "ENTERED_VALUE_EXCEEDS_LIMITS": "القيمة المدخلة تتجاوز الحد المسموح به",
            "MINIMUM_ALLOWED_AMOUNT": "الحد الأدنى المسموح به هو {{number}} {{currency}}",
            "VIEW_MY_ORDERS": "عرض طلباتي",
            "MY_AD_INFO": "معلومات إعلاني",
            "DETAILS": "التفاصيل",
            "REQUESTED_FOR_SALE": "المبلغ المطلوب للبيع",
            "SALABLE_AMOUNT": "المبلغ القابل للبيع",
            "COLLATERAL_AMOUNT": "مبلغ الضمان ({{value}}%)",
            "COMMISSION": "العمولة ({{value}}%)",
            "EQUIVALENT_RIAL": "ما يعادل بالريال",
            "MINIMUM_PURCHASE": "الحد الأدنى للشراء لكل طلب",
            "CARD_TO_CARD": "تحويل من بطاقة إلى بطاقة",
            "SATNA": "ساتنا",
            "PAYA": "بايا",
            "BUYER_DIPOSIT_LIMIT": "حد الإيداع للمشتري",
            "ADVERTISING_PERIOD": "فترة الإعلان",
            "VIEW_PAYMENTS": "عرض المدفوعات",
            "ORDER_COMPLETED": "تم إكمال طلبك",
            "SHARE_YOUR_EXPERIENCE": "يرجى مشاركة تجربتك معنا.",
            "PAYMENTS": "المدفوعات",
            "PURCHASE_INFO": "معلومات مبيعاتي",
            "PAYMENT_INFO": "معلومات الدفع الخاصة بي",
            "NEXT": "التالي",
            STEPPER: {
                "PURCHASE_AMOUNT": "تحديد مبلغ الشراء",
                "SALES_DETERMINATION": "تحديد المبيعات",
                "COMMITMENT_LATER": "خطاب الالتزام",
                "CONFIRM_INFORMATION": "تأكيد المعلومات",
                "ADVERTISEMENT_REGISTRATION": "تسجيل الإعلان",
                "CURRENCY_RECEIPT": "إيصال العملة",
                "PAYMENT": "الدفع",
            },
            "ENTER_CURRENCY_AMOUNT": "أدخل مبلغ العملة",
            "CURRENCY_AMOUNT": "مبلغ العملة",
            "DOLLAR": "دولار",
            "PAYMENT_AMOUNT": "مبلغ دفعتك",
            "RIAL": "ريال",
            "CHOOSE_WALLET": "اختر محفظة",
            "CHOOSE_BANK_ACCOUNT": "اختر حسابًا بنكيًا",
            "USER_DOT": "المستخدم:",
            "DIPOSIT_DOT": "الإيداع:",
            "TRANSFER_RATE_DOT": "معدل التحويل:",
            "PAYMENT_METHOD_DOT": "طريقة الدفع:",
            "DIPOSIT_TIME_LIMIT_DOT": "الحد الزمني للإيداع:",
            "BUY_CURRENCY": "شراء عملة",
            COMMITMENT_LATER_DESCRIPTION: {
                "RESPONSIBLE_FOR_AD": "كن صادقًا وعادلًا، تعامل مع الآخرين باحترام تام، وتحمل المسؤولية عن إعلاناتك.",
                "SALLER_PRICE_BUYER": "سعر الطلبات المتفق عليه بين البائع والمشتري نهائي وغير قابل للتفاوض.",
                "SPECIFIED_TIME": "يرجى إتمام عملية الإفراج خلال الوقت المحدد. إذا انتهت هذه المدة، يجب أن تكون مسؤولًا أمام المشتري وفريق الدعم. في حالة عدم الاستجابة، يحق للمنصة الإفراج عن مبلغ الإعلان.",
                "CONTROLLED_ASSETS_PLATFORM": "يذهب الدفع الخاص بك مباشرةً إلى حساب البائع، ويتم التحكم فقط في الأصل الرقمي الذي يريد البائع بيعه خلال المعاملة من قبل المنصة.",
                "DIPOSIT_FROM_ACCOUNT": "يجب أن يتم إيداع المبلغ المستلم من نفس الحساب المذكور في نموذج الدفع. في حالة وجود أي اختلاف، لا تقم بالإفراج عن الدفع بأي شكل من الأشكال واتصل بالدعم. إذا تم الإفراج عن المبلغ بواسطة النظام، فإنه لا يتحمل أي مسؤولية عن ذلك.",
                DIPOSIT_FROM_ACCOUNT2: 'يرجى ملاحظة أن المبلغ المستلم يجب أن يتم إيداعه من نفس الحساب المذكور في نموذج الدفع. في حال وجود أي اختلاف، يرجى عدم تنفيذ عملية الإفراج تحت أي ظرف وإبلاغ فريق الدعم. وفي حال تم تنفيذ الإفراج، فإن المنصة لا تتحمل أي مسؤولية عن المبلغ المُفرَج عنه.',
                "OVERPAY_CARE": "في حالة وجود فرق بين المبلغ المستلم والمبلغ المذكور في نموذج الدفع، لا تقم بالإفراج عن المبلغ تحت أي ظرف من الظروف، وراجع الدعم الفني.",
                "PRESS_WITHOUT_PAYING": "إذا قمت بإدخال معلومات خاطئة في نموذج الدفع دون الدفع الفعلي، ثم نقرت على زر الدفع، فسيتم إغلاق وصولك إلى هذه الخدمة نهائيًا، وستحتفظ المنصة بالحق في المطالبة بأي أضرار ناتجة عن ذلك.",
                "DOES_NOT_PAY_LIMITATION": "إذا لم تقم بالإفراج عن الأموال بعد استلامها في حسابك البنكي، يمكن للمنصة تنفيذ الإفراج ومنع وصولك إلى خدمة الدفع من شخص لشخص (P2P) نهائيًا.",
                "DIGITAL_ASSETS_MENTION": "يرجى عدم ذكر أي معلومات تتعلق بأصولك الرقمية أثناء التحويلات البنكية. وإلا، فقد يتم اعتراض دفعتك أو قد يقوم البنك بحظر معاملتك.",
                "AVAILABLE_UNFULFILLED": "إذا كان لديك طلبات غير مكتملة أو نزاعات مع المشتري، تأكد من أنك متاح دائمًا عبر رقم الهاتف المحمول أو البريد الإلكتروني المسجل على المنصة.",
                "THIRD_CHANNELS": "لا يجب عليك مطلقًا إجراء معاملة تحويل أموال عبر قناة خارجية مثل وسائل التواصل الاجتماعي أو تطبيقات المراسلة أو المعاملات المباشرة وجهًا لوجه. المنصة غير مسؤولة عن أي أضرار أو خسائر تحدث خارجها. كما أن المنصة ليست طرفًا في أي عمليات تحويل P2P.",
                "COMMITMENT_LATER": "يجب على المستخدمين الامتناع عن استخدام الألفاظ النابية أو الكلمات المهينة أثناء استخدام المنصة. في حالة ملاحظة مثل هذا السلوك، سيتم التعامل مع المستخدم وفقًا للسياسات.",
                "SHARE_ACCOUNT_WARNING": "لا تستخدم حساب شخص آخر تحت أي ظرف من الظروف، ولا تشارك معلومات حسابك مع الآخرين. إذا تم رصد مثل هذا السلوك، فسيتم حظر حسابك، وسيتم إبلاغ شرطة الجرائم الإلكترونية (FATA) إذا لزم الأمر.",
                "AGENDA_VIOLATION": "في حالة حدوث أي انتهاك لـ \"إرشادات البائع\"، قد تتخذ المنصة الإجراءات التي تراها مناسبة وفقًا للقوانين واللوائح ذات الصلة أو وفقًا لتقديرها، بما في ذلك مصادرة الأموال، أو حظر الحساب المخالف، أو تعطيل أي من وظائف الحساب داخل المنصة.",

                THIRD_PARTY_PAYMENT_WARNING: "استخدم فقط حساباً مصرفياً وطريقة دفع مسجلة باسمك وتتطابق مع معلومات هويتك الموثقة؛ لا يُسمح بالدفع من طرف ثالث.",
                ASSET_LOCK_WARNING: "بمجرد بدء المعاملة، سيتم تجميد أصول البائع في الضمان ولن يكون بالإمكان الوصول إليها حتى اكتمال الطلب أو إلغائه.",
                PAYMENT_DEADLINE_WARNING: "يلتزم المشتري بتحويل المبلغ الكامل للطلب خلال الإطار الزمني المحدد ووفقاً لمعلومات الدفع المُعلنة.",
                FINAL_TRANSACTION_WARNING: "معاملات P2P نهائية؛ يرجى مراجعة المبلغ والسعر وتفاصيل الدفع بعناية قبل تقديم الطلب.",

                BUYER_PAYMENT_DEADLINE: "يجب على المشتري دفع المبلغ الكامل للطلب خلال المهلة الزمنية المحددة ووفقًا لبيانات الدفع المقدمة.",
                RELEASE_DEADLINE_WARNING: "يرجى تحرير المبلغ خلال المهلة الزمنية المحددة. إذا انتهت هذه المهلة، فسيتعين عليك الرد على المشتري وفريق الدعم. وفي حال عدم الرد، يحق للمنصة تحرير مبلغ الإعلان.",
                FAKE_PAYMENT_CONFIRMATION_WARNING: "إذا نقرت على زر «تم الدفع» دون إجراء عملية الدفع وقدمت معلومات غير صحيحة في نموذج الدفع، فسيتم حظر وصولك إلى هذه الخدمة نهائيًا. وتحتفظ المنصة بحق المطالبة بالتعويض عن أي أضرار ناتجة عن ذلك.",
                OFF_PLATFORM_TRANSACTION_WARNING: "يجب عليك عدم تحويل الأموال أو إجراء أي معاملات عبر قنوات خارجية، مثل شبكات التواصل الاجتماعي أو تطبيقات المراسلة أو الترتيبات المباشرة وجهًا لوجه. ولا تتحمل المنصة مسؤولية أي خسارة أو ضرر ناتج عن معاملات تتم خارجها. كما أن المنصة لا تشارك في أي مرحلة من مراحل تحويل الأموال بنظام P2P.",
            },
            COMMITMENT_ACCEPTION_PT_ONE: "أنا {{value}} قد قرأت خطاب الالتزام أعلاه وأوافق على القوانين واللوائح.",
            RULES: " خطاب الالتزام ",
            COMMITMENT_ACCEPTION_PT_TWO: "، القواعد واللوائح، وأنا أوافق عليها.",
            COMMITMENT_ACCEPTION: "أنا {{value}} قد قرأت خطاب الالتزام أعلاه <span class=\"username\">خطاب الالتزام</span> وأوافق على القوانين واللوائح.",
            TERMS_COMMITMENT_AGREEMENT: "أنا، {{value}}، قد قرأت <a>شروط الخدمة</a> وأوافق عليها.",
            "DATE_DOT": "التاريخ:",
            "TIME_DOT": "الوقت:",
            "PAYMENT_TO_DOT": "الدفع إلى:",
            "RECEIVER_PARAMETER_DOT": "المستلم: <span>{{value}} (البائع)</span>",
            "PRICE_DOT": "السعر:",
            "CARD_NUMBER_DOT": "رقم البطاقة:",
            ACCOUNT_NUMBER_DOT: "رقم الحساب:",
            IBAN_NUMBER_DOT: "رقم الآيبان:",
            BANK_TITLE_DOT: "اسم البنك:",
            "ENTER_PAYMENT_INFORMATION": "أدخل معلومات الدفع الخاصة بك",
            "REMAINING_TIME_DOT": "الوقت المتبقي:",
            "ENTER_DEPOSIT_AMOUNT": "أدخل مبلغ الإيداع",
            "DEPOSIT_AMOUNT": "مبلغ الإيداع",
            "ENTER_TRACKING_NUMBER": "أدخل رقم التتبع",
            "RECEIPT_IMAGE": "صورة الإيصال (مطلوبة)",
            "UPLOAD_LIMIT_HINT": "أقل من {{value}} ميجابايت",
            "UPLOAD_LIMIT_ERROR": "الحد الأقصى لحجم الملف: {{value}} ميجابايت",
            "UPLOAD_LIMIT_TYPE": "الحد الأقصى لحجم الملف: {{value}} ميجابايت",
            "SUBMIT": "إرسال",
            "DONE_NEXT": "تم التالي",
            "EXPECTATION": "توقعات!",
            "PAYMENT_NOTIFIED": "عزيزي المستخدم، لقد تم إخطار البائع بدفعتك.",
            "AFTER_SELLER_CONFIRMED": "بعد تأكيد دفعتك من قبل البائع، سيتم تحويل الأموال إلى محفظتك.",
            WATING_SELLER_CONFIRMATION: "عزيزي المستخدم، تم إشعار البائع بدفعتك. للتواصل مع البائع، يمكنك الدخول إلى محادثة هذا الطلب عبر أيقونة الدردشة في أعلى الصفحة أو الانتقال إلى قائمة طلباتي. بعد تأكيد الدفع، سيتم تحويل المبلغ إلى محفظتك.",
            NEED_TO_CONTACT_THE_SELLER: 'هل تحتاج إلى التواصل مع البائع؟',
            ENTER_THE_ORDER_CHAT: 'الدخول إلى محادثة الطلب',
            "REMAINING_AMOUNT": "المبلغ المتبقي",
            "MY_SALES_INFORMATION": "معلومات الشراء الخاصة بي",
            "DESIRED_CURRENCY_AMOUNT": "مبلغ العملة المطلوبة",
            "VALUE_NOT_ALLOWED": "القيمة المدخلة غير مسموح بها",
            "MINIMUM_PURCHASE_PER_ORDER": "الحد الأدنى للشراء لكل طلب",
            "AD_DURATION": "مدة الإعلان",
            "DAY": "يوم",
            "COMPUTING": "الحساب",
            "TOTAL_REQUESTED_AMOUNT": "إجمالي المبلغ المطلوب",
            "MINIMUM_ORDER_LIMIT": "الحد الأدنى للطلب",
            "EXCHANGE_RATES_TYPES": "أنواع أسعار الصرف",
            "FLOATING_CONVERSION_RATE": "سعر الصرف العائم",
            "FINAL_RATE_CONVERTION": "السعر النهائي = سعر الصرف العائم في السوق",
            "USER_DETERMINES_SALES_RATE": "المستخدم يحدد سعر البيع (التحويل)",
            "FIXED_CONVERTION_RATE": "سعر الصرف الثابت",
            "ATTENTION": "تنبيه",
            "GUARANTEE_AMOUNT_COMPLY": "يُعتبر مبلغ الإيداع بمثابة ضمان من المستخدم للامتثال لمبادئ وقواعد منصة P2P. سيتم إعادة هذا المبلغ إلى محفظتك بعد إغلاق الإعلان.",
            "HIDDEN_AD_CASE": "سيتم إخفاء إعلانك عن العرض العام في الحالات التالية:",
            "AD_TIME_OVER": "إذا انتهت المهلة الزمنية المحددة لعرض الإعلان، يمكنك حذف إعلانك الحالي وإنشاء إعلان جديد.",
            "AD_REMAIN_AMOUNT": "إذا كان المبلغ المتبقي من إعلانك أقل من الحد الأدنى للشراء لكل طلب، يمكنك حذف إعلانك. سيتم إعادة المبلغ المتبقي إلى محفظتك.",
            "ORDERS_FOR_SALE": "سيتم إخفاء إعلان البيع الخاص بك تلقائيًا عندما يكون هناك 4 طلبات عليه.",
            "SUPPORT_AGAINST_ORDERS": "بمجرد تلقيك 3 طلبات دعم ضد طلباتك، سيتم إخفاء جميع إعلاناتك مؤقتًا.",
            "RULES_VIOLATION_BAN": "وفقًا لانتهاك القواعد المحددة، يمكن للخبير المختص حظرك مؤقتًا أو دائمًا من استخدام خدمة P2P.",
            "NEW_BANK_REGISTERATION": "عزيزي المستخدم، إذا كنت بحاجة إلى تسجيل معلومات حساب مصرفي جديد، يمكنك",
            "CLICK_HERE": "<span>انقر هنا</span>",
            "GOT_IT": "تم الفهم",
            "RETURN_TO_WALLET_CONFIRMATION": "إعادة المبلغ المتبقي إلى المحفظة",
            "REMAINING_AMOUNT_TRANSFER_NOTICE": "المبلغ المتبقي من إعلانك أقل من الحد الأدنى للشراء، لذلك سيتم تحويل هذا المبلغ المتبقي إلى محفظتك. يُرجى ملاحظة أن إعلانك لم يعد مرئيًا. يمكنك إنشاء إعلان جديد.",
            "TRANSFER_NOTICE_CREATE": "سيتم تحويل المبلغ المتبقي من إعلانك إلى محفظتك. يُرجى ملاحظة أن إعلانك لم يعد مرئيًا. يمكنك إنشاء إعلان جديد.",
            "CANCEL_ADVERTISEMENT": "إلغاء الإعلان",
            "DELETE_ADVERTISEMENT_WARNING": "لا يمكن حذف الإعلان. يجب أولًا متابعة الطلبات قيد التنفيذ وإكمالها.",
            "NO_BUYER_FOUND": "لم يتم العثور على مشتري",
            "ADVERTISEMENT_CLOSED_NOTIFICATION": "عزيزي المستخدم، نظرًا لعدم العثور على مشتري خلال الفترة الزمنية المحددة لإعلانك، فقد تم إغلاقه.",
            "CANCEL_SALE_CONFIRMATION": "هل أنت متأكد أنك تريد إلغاء إعلان البيع الخاص بك؟",
            "YES_SALE_CONFIRMATION": "نعم",
            "NO_SALE_CONFIRMATION": "لا",
            "MINUTES": "دقائق",
            "EDIT_INFORMATION": "تعديل المعلومات",
            "MY_ORDERS": "طلباتي",
            "ALL_ITEMS": "الكل",
            "RETURN_TO_MAIN": "العودة إلى الصفحة الرئيسية",
            "AD_SUCCESSFULLY_REGISTERED": "تم تسجيل إعلانك بنجاح",
            "AD_RESPONSIBILITY": "يُرجى أن تكون مسؤولًا عن إعلانك وإذا تلقيت إشعارًا فقم بمعالجته في أقرب وقت ممكن.",
            "PAYMENT_PERIOD": "فترة الدفع",
            "CARD_INFO": "معلومات البطاقة",
            "DESIRED_AMOUNT": "أدخل المبلغ المطلوب",
            "CURRENT_RATE": "السعر الحالي",
            "WARNING": "تحذير",
            "I_REALIZED": "لقد أدركت",
            "AVOID_BECOMING_VICTIM": "لتجنب أن تكون ضحية للاحتيال، لا تقم أبدًا بتحويل العملة الرقمية قبل الدفع الفعلي! لا تصدق أي شخص يدعي أنه دعم العملاء ويقنعك بإكمال المعاملة قبل استلام الدفعة، لأنهم محتالون. بمجرد تأكيد الطلب من قبل البائع ونقل الملكية إلى المشتري، تعتبر المعاملة مكتملة ولا يمكن الطعن فيها. كما أن المنصة لن تكون مسؤولة عن المعاملات خارجها.",
            "CHOOSE_FILE": "اختر ملفًا",
            ORDER_STATUS: {
                "NEW_BUY": "دفع",
                "NEW": "في انتظار المشتري",
                "IN_PROGRESS": "قيد التنفيذ",
                "SUPPORT": "الدعم",
                "CANCEL": "إلغاء",
                "CLOSED": "مغلق",
                "DONE": "مكتمل",
            },
            ADVERTISE_TYPES: {
                "BUY": "شراء",
                "SELL": "بيع",
            },
            "TIME_REMAINING_TO_COMPLETE_PAYMENT": "الوقت المتبقي لإكمال الدفع",
            "SUBTITLE_CHECK_TIMER": "إذا لم يتم تسجيل الدفعة خلال الفترة الزمنية المحددة، فسيتم إرسال الطلب إلى الدعم.",
            "REGISTER_PAYMENT_INFORMATIN": "تسجيل معلومات الدفع",
            "ACTION_TO_RELEASE": "إصدار",
            "DELETE_ADVERTISMENT": "حذف الإعلان",
            "DETAIL_ADVERTISMENT": "تفاصيل الإعلان",
            "DELETE_ORDER": "حذف الطلب",
            "DETAIL_ORDER": "تفاصيل الطلب",
            "BALANCE_WALLET": "الرصيد: {{balance}} {{currency}}",
            "CURENTR_MARKET_RATE": "سعر السوق الحالي",
            "CURENTR_MARKET_RATE_CRYPTO": "سعر السوق الحالي",
            "YOUR_EXCHANGE_RATE": "سعر الصرف الخاص بك",

            ALLOWED_RANGE: "النطاق المسموح: {{min}} - {{max}}",
            ALLOWED_RANGE_PERCENTAGE: "النطاق المسموح: <span class='percent-range'>{{min}}% - {{max}}%</span>",
            ERROR_VALIDATE_ALLOWED_RANGE: "يجب أن تكون القيمة بين {{min}} و {{max}}.",
            ERROR_VALIDATE_ALLOWED_RANGE_PERCENTAGE: "يجب أن تكون النسبة بين <span class='percent-range'>{{min}}% - {{max}}%</span>",


            "TEXT_CHANGE_PERCENT_LOWER": "سعر البيع الخاص بك سيكون دائمًا {{value}}% أقل من سعر \"\"توب تشينج\"\".",
            "TEXT_CHANGE_PERCENT_HIGHER": "سعر البيع الخاص بك سيكون دائمًا {{value}}% أعلى من سعر \"\"توب تشينج\"\".",
            "TEXT_CHANGE_PERCENT_STATIC": "سعر البيع الخاص بك سيكون دائمًا مساويًا لسعر \"\"توب تشينج\"\".",
            "TEXT_CHANGE_PERCENT_LOWER_CRYPTO": "سعر البيع الخاص بك سيكون دائمًا {{value}}% أقل من سعر السوق.",
            "TEXT_CHANGE_PERCENT_HIGHER_CRYPTO": "سعر البيع الخاص بك سيكون دائمًا {{value}}% أعلى من سعر السوق.",
            "TEXT_CHANGE_PERCENT_STATIC_CRYPTO": "سعر البيع الخاص بك سيكون دائمًا مساويًا لسعر السوق.",
            "AMOUNT_PAID": "مبلغ الدفع",
            "EXCHANGE_RATE": "سعر الصرف",
            "ORDER_TRACKING_NUMBER": "رقم تتبع الطلب",
            "AD_TRACKING_NUMBER": "رقم تتبع الإعلان",
            DESTINATION_BANK: 'البنك المستلم',
            VIEW_DESTINATION_BANK: "عرض البنك المستلم",
            VIEW_DESTINATION_BANK_DESCRIPTION: "يمكنك الآن رؤية البنك المستلم لدى البائع قبل الدخول في الصفقة، مما يتيح لك اتخاذ قرار أكثر دقة.",
            BANK_NAME: '{{name}} Bank',
            DIALOG_EXCHANGE_RATE: {
                CHANGE: {
                    "TITLE": "سعر الصرف المدخل يختلف بشكل كبير عن السعر الفعلي",
                    "NEW_EXCHANGERATE": "سعر الصرف الخاص بك:",
                    "TC_EXCHANGERATE": "سعر الشراء الحالي من TopChange:",
                    "DESCRIPTON": "سعر الصرف الذي قمت باختياره يختلف بشكل كبير عن السعر الفعلي في TopChange. يرجى مراجعته قبل التأكيد. هل أنت متأكد من هذا المبلغ؟",
                    "EDIT_EXCHANGE_RATE": "تعديل سعر الصرف",
                    "CONTINUE": "متابعة"
                }
            },
            PRICE_TOLERANCE_VALIDATION_FAILED: "السعر المُدخل يختلف بشكل كبير عن سعر السوق. يرجى تعديله والمحاولة مرة أخرى.",
            DIALOG_TERMS_COMMITMENT_AGREEMENT: {
                ALERT_TXT: 'يرجى قراءة القواعد بعناية قبل نشر الإعلان!'
            },

            ACTIVE_ORDERS_AD_VISIBILITY_WARNING: "عندما توجد 4 طلبات نشطة لإعلان البيع الخاص بك، سيتم إخفاء الإعلان تلقائيًا.",
            SUPPORT_REQUESTS_AD_VISIBILITY_WARNING: "بمجرد تقديم 3 طلبات دعم ضد طلباتك، سيتم إخفاء جميع إعلاناتك مؤقتًا.",
            FINAL_P2P_TRANSACTION_WARNING: "معاملات P2P نهائية. قبل تقديم الطلب، راجع المبلغ والسعر وبيانات الدفع بعناية.",
            P2P_COLLATERAL_NOTICE: "يُعد مبلغ الضمان تعهدًا بالتزام المستخدم بقواعد ولوائح خدمة P2P الخاصة بالمنصة. وسيُعاد هذا المبلغ إلى محفظتك بعد إغلاق الإعلان.",
            P2P_SERVICE_RESTRICTION_WARNING: "إذا خالفت القواعد المحددة، فقد يمنعك المختص المسؤول من استخدام خدمة P2P بصورة مؤقتة أو دائمة.",

            P2P_SEND_METHOD_PRICE_NOTICE: 'عزيزي المستخدم، للمبالغ التي تصل إلى 15 مليون تومان، يُرجى تحويل الأموال عن طريق التحويل من بطاقة إلى بطاقة. أما للمبالغ التي تزيد على 15 مليون تومان وتصل إلى 200 مليون تومان، فيُرجى استخدام التحويل من حساب إلى حساب. يُرجى ملاحظة أنه في هذه الطريقة يجب أن يكون البنك المُرسِل والبنك المُستقبِل متطابقين، ويُرجى عدم تحويل الأموال باستخدام رقم الآيبان (IBAN).',

        },
        AFFILIATE: {
            AFFILIATE_REQUEST: {
                "ENTER_CODE_DESCRIPTION": "يمكنك أيضًا أن تتم دعوتك من قبل شخص آخر أثناء كونك شريكًا تابعًا لدينا وكسب النقاط بناءً على شروط الشخص الذي دعاك.",
                "ENTER_CODE": "أدخل رمز الإحالة",
                "AFFILIATE_CONDITIONS": "الشروط والأحكام",
                "SOCIAL_MANAGEMENT_BLOCKCHAIN": "امتلاك مجموعات اجتماعية في مجال الأسواق المالية وتحويل العملات التي تديرها.",
                "ONLINE_FINANCIAL_PLATFORMS": "وجود حضور فعال على شبكات التواصل الاجتماعي المتعلقة بأسواق رأس المال مثل يوتيوب، تويتر، إنستجرام، وتليجرام.",
                "COMMUNITY_EVENTS_ATTRACTION": "الوصول إلى نوادي المعجبين، والبرامج المالية، والمؤتمرات، والقدرة على إنشاء مساحة إعلانية لجذب مستخدمين جدد إلى منصة TopChange.",
                "CONTENT_COLLABORATION_IMPACT": "الخبرة والقدرة على إنشاء محتوى متعلق بالأنشطة المشتركة مع TopChange والتأثير على مجموعات المستخدمين المختلفة.",
                "SEND_REQUEST": "إذا كنت ترغب في أن تصبح عضوًا في برنامج الشراكة الخاص بـ TopChange، انقر هنا:",
                "SEE_FORM": "نموذج طلب الانتساب",
            },
            AFFILIATE_SEND_REQUEST: {
                "SEND_AFFLIATE_REQUEST": "إرسال طلب تعاون",
                "WEBSITE_ADDRESS": "عنوان الموقع",
                "SOCIAL_MEDIA": "موقع الويب أو أي وسيلة تواصل اجتماعي أخرى تكون عضوًا فيها مثل تليجرام أو تويتر، إلخ.",
                "COOPEREATED_COMPANY": "برنامج الشراكة السابق أو الشركة التي عملت معها",
                "DESCRIPTION": "اشرح استراتيجيتك للتعاون (إنشاء محتوى، حملات التواصل الاجتماعي، التسويق عبر البريد الإلكتروني، أو أي تقنيات إعلانية أخرى).",
                "ENTER_DESCRIPTION": "اكتب رسالتك...",
                "TRANSACTION_VOLUME": "حجم المعاملات",
                "ESTIMATED_MONTHLY_TRADING_VOLUME": "يُرجى كتابة متوسط حجم التداول الشهري المتوقع بالدولار.",
                "SEND": "إرسال",
                "SUBMIT_SUCCESS_MESSAGE": "تم تسجيل طلبك بنجاح. يُرجى الانتظار لتلقي مكالمة من TC.",
            },
            INVITEE_ENTER_CODE: {
                "INVITATION_CODE": "رمز الإحالة",
                "ENTER_INVITATION_CODE": "قم بتطبيق رمز الدعوة الخاص بممثلك أولاً.",
                "YOUR_INVITATION_CODE": "رمز الإحالة",
                "ENTER_INVITAION_CODE_HINT": "أدخل رمز الإحالة الخاص بك",
                "ACTIONS": "إرسال",
                "CAN_INVITED": "أثناء كونك شريكًا تابعًا، يمكنك أن تتم دعوتك من قبل شخص آخر وكسب النقاط وفقًا لشروط الشخص الذي دعاك.",
            },
            INVITEE_INDEX: {
                "YOUR_INVITATION_CODE": "رمز التعريف الخاص بك",
                "REQUEST_EMAIL": "إذا كنت ترغب في تغيير الشخص الذي دعاك، يُرجى تقديم طلب عبر البريد الإلكتروني أدناه.",
                "DEFAULT_BONUS": "مكافأة تعريفية من جانب الشراكة لك",
                "FROM_AFFILIATE_SHARE": "من حصة الشراكة",
                "MY_PERFORMANCE": "أدائي",
                "VIEW_HISTORY": "عرض السجل",
                "MY_AFFILIATE": "الشراكة التابعة لي",
                "UNPAID_BONUS": "المكافأة غير المدفوعة",
                "PAID_BONUSES": "إجمالي المكافآت المستلمة",
                "SCORE": "النقاط",
            },
            INVITEE_HISTORY: {
                "FILTERS": "الفلاتر",
                "TRACKING_NUMBER": "رقم التتبع",
                "IDENTIFICATION_CODE": "رمز التعريف",
                "PROGRAM": "البرنامج",
                "FROM_DATE": "من التاريخ",
                "TO_DATE": "إلى التاريخ",
                "TYPE": "النوع",
                "MY_REWARD": "مكافآتي",
                "SCORE": "النقاط",
                "AFFILIATE": "الشريك التابع",
                "STATUS": "الحالة",
                "ACTION_DATE": "تاريخ الإجراء",
                "ACTION": "الإجراء",
            },
            "FILTER": "تصفية",
            "FROM_DATE": "من التاريخ",
            "TO_DATE": "إلى التاريخ",
            "CLEAR_ALL": "مسح الكل",
            "SEARCH": "بحث",
            "YOUR_AFFILIATE_PROGRAM": "برنامج تحقيق الدخل الخاص بنا",
            "BONUS_FROM_BROKER": "مكافأة من الوسيط",
            "BONUS_FROM_SPECIAL_WALLETS": "{{bonus}}% مكافأة من محفظة {{specialWallets}}",
            "FROM_ALL_BROKERS": "مكافأة من جميع الوسطاء",
            "SHARE_YOUR_REFERRAL": "شارك رابط الإحالة الخاص بك مع متابعيك أو قنواتك.",
            "ENCOURAGE_FRIENDS_TRANSACTIONS": "شجع الأصدقاء على إجراء المعاملات",
            "RECEIVE_REWARDS": "استلم المكافآت",
            "YOUR_REFERRAL_CODE": "رمز الدعوة الخاص بك",
            "MANAGEMENT_OF_CODES": "إدارة الأكواد",
            "SHARE": "مشاركة",
            "EXPLANATION_STEPS": "شرح الخطوات",
            "MORE_GUIDANCE": "المزيد من الإرشادات",
            "CREATE_YOUR_OWN_CODE": "أنشئ رمز الدعوة الخاص بك ورابطه.",
            "SHARE_YOUR_CODE": "شارك الرابط أو الرمز الذي لديك مع الآخرين.",
            "ENCOURAGE_FRIENDS_COMPLETE_TRANSACTIONS": "شجع أصدقاءك على المشاركة وإكمال المعاملات المحددة في تطبيقاتهم الخاصة.",
            "MANAGE_REFERRAL_CODES": "إدارة أكواد الدعوة الخاصة بك.",
            "CHANGE_BONUSES_PERCENTAGE": "يمكنك ضبط نسب المكافآت للأكواد المختلفة بناءً على شروطك.",
            "REFERRAL_CODE": "رمز الإحالة",
            "INVITEE_USERNAME": "اسم المدعو",
            "OPERATION": "العملية",
            "BONUS_RECEIVED": "المكافأة المستلمة",
            "INTRODUCED_PEOPLE_NUMBER": "عدد الأشخاص الذين تم تقديمهم",
            "INTRODUCED_PERSON_SHARE": "حصة المقدم",
            "MY_SHARE": "حصتي",
            "INVITATION_CODE": "رمز الدعوة",
            "MY_OVERALL_PERFORMANCE": "أدائي العام",
            "VIEW_HISTORY": "عرض السجل",
            "THE_REFEREES": "المحكمون",
            "BONUS_AVAILABLE": "المكافأة المتاحة",
            "TOTAL_REWARDS_RECEIVED": "إجمالي المكافآت المستلمة",
            "MY_BEST_REFEREE": "أفضل محكم لدي",
            "YOUR_INVITATION_CODE": "رمز الدعوة الخاص بك",
            "GENERATE_REFERRAL_SAHRE": "إنشاء أكواد الإحالة ومشاركة العمولات مع المدعوين.",
            "CREATE_INVITATION_CODE": "إنشاء رمز دعوة",
            "EDIT": "تحرير",
            "VIEW_TRANSACTIONS": "عرض المعاملات",
            "NAME_CHANGE": "تغيير الاسم",
            "NEW_NAME": "اسم جديد",
            "CHANGE": "تغيير",
            "CREATE_CODE": "إنشاء رمز",
            "INVITED_PERSON_SHARE": "حصة المدعو",
            "YOUR_SHARE": "حصتك",
            "NAME": "الاسم",
            "CANCEL": "إلغاء",
            "CREATE": "إنشاء",
            "INVITED_PERSON": "مدعو",
            "TOTAL_REWARDS": "إجمالي المكافأة",
            "MY_REWARD": "مكافأتي",
            "INVITED_PERSON_REWARD": "مكافأة المدعو",
            "OPERATION_DATE": "تاريخ العملية",
            "TRACKING_NUMBER": "رقم التتبع",
            "TRANSACTION_TYPE": "نوع المعاملة",
            "CHANGE_STATUS": "تغيير الحالة",
            "SCORE": "النقاط",
            "TOTAL_SCORE": "إجمالي النقاط",
            "INVITING_MONETIZATION_PROGRAM": "برنامج تحقيق الدخل لدعوة الأصدقاء",
            "BECOME_AFFILIATE": "طلب تعاون مع TopChange",
            "INVITED_BY_FRIENDS": "لقد تمت دعوتي من قبل صديقي",
            "REFERRAL_LINK": "رابط الإحالة",
            "INCOME_SOURCE_REFERRALS": "أكواد الإحالة لمصدر الدخل",
            "SUCCESSFUL_REFERRALS": "أكواد الإحالة الناجحة",
            "AFFILIATE_SHARE": "حصة الشراكة",
        },
        TRANSFER: {
            "TRANSFER_FROM_TC_TO_GC": "التحويل من محفظة Topchange إلى موقع GreenChange",
            "GC_ADDRESS": "https://GreenChange.io",
            "TOPCHANGE_LOOKING_FOR_SAFETY": "",
            TRANSFER_ANNOUNCEMENT: {
                "TITLE": "تحويل العملات الرقمية من Topchange إلى موقع GreenChange",
                "DESCRIPTION": "يمكن للمستخدمين الذين سبق لهم استخدام خدمات العملات الرقمية من Topchange استخدام نفس البريد الإلكتروني وكلمة المرور للدخول إلى GreenChange دون الحاجة إلى التسجيل والتحقق من الهوية. بعد نقل المحافظ الرقمية، يمكنك إجراء عمليات التبادل الخاصة بك في GreenChange ولكن لا يزال بإمكانك استخدام محفظتك الورقية في Topchange.",
                "ITEM1": "السحب والإيداع التلقائي",
                "ITEM2": "زيادة أمان المعاملات",
                "ITEM3": "إضافة المزيد من الخدمات في مجال العملات الرقمية",
            },
            NEW_CHANGES: {
                TITLE: "تغييرات جديدة في Topchange",
                BUY: {
                    "TITLE": "شراء العملات الرقمية",
                    "PRE_DESCRIPTION": "اشحن محافظ GreenChange الخاصة بك عبر محافظك الورقية في Topchange",
                    "DESCRIPTION": "يمكنك شحن محافظ العملات الرقمية في GreenChange عبر المحافظ الورقية في Topchange.",
                },
                SELL: {
                    "TITLE": "بيع العملات الرقمية",
                    "PRE_DESCRIPTION": "السحب من محافظ GreenChange للعملات الرقمية واستلامها في محفظتك في Topchange",
                    "DESCRIPTION": "يمكنك استبدال عملتك الرقمية من محفظة GreenChange إلى محافظك الورقية في Topchange واستلام المبلغ المطلوب من خلال طرق السحب المتاحة في Topchange مثل (نقدًا، بنك، إلخ).",
                }
            },
            TRANSFER_LERANING: {
                "TITLE": "كيف يمكنني تحويل محافظ العملات الرقمية الخاصة بي من Topchange إلى GreenChange؟",
                "QUESTION_ONE_LOGIN_TITLE": "لقد أجريت معاملة متعلقة بمحافظ العملات الرقمية في Topchange",
                "QUESTION_ONE_LOGIN_DESCRIPTION": "لا يزال بإمكانهم استخدام المحافظ الورقية في Topchange، ولكن بعد تحويل محافظ العملات الرقمية إلى GreenChange، يجب عليهم إجراء جميع عمليات التبادل المتعلقة بالعملات الرقمية على موقع GreenChange.",
                "QUESTION_ONE_LOGIN_BTN": "تسجيل الدخول إلى GreenChange",
                "QUESTION_ONE_REGISTER_TITLE": "لم أقم بتسجيل أي طلب في Topchange بخصوص العملات الرقمية",
                "QUESTION_ONE_REGISTER_DESCRIPTION": "يمكن لهذه الفئة من المستخدمين الاستمرار في أنشطتهم على المحافظ الورقية في Topchange، ولكن إذا كانوا مهتمين باستخدام خدمات تبادل العملات، فيجب عليهم التسجيل والتحقق من الهوية على موقع GreenChange.",
                "QUESTION_ONE_REGISTER_BTN": "التسجيل في GreenChange",
                "TRANSFER_DEADLINE": "الموعد النهائي للتحويل: 17 يوليو في الساعة 14:00 بتوقيت غرينتش",
                "QUESTION_TWO_REGISTER_DESCRIPTION": "خلال هذه الفترة، لديك الفرصة لنقل عملاتك الرقمية من <span class=\"tc-span\">Topchange</span> إلى <span class=\"gc-span\">GreenChange</span> أو سحب أرصدة العملات الرقمية الخاصة بك، وإلا فسيتم تنفيذ التحويل تلقائيًا في 17 يوليو الساعة 14:00 بتوقيت غرينتش.",
            },
            TRANSFER_REPORT: {
                "TITLE": "تحويل محافظ Topchange إلى موقع GreenChange",
                "DESCRIPTION": "نص تجريبي",
                "WALLET": "المحفظة",
                "PRICE": "السعر",
                "CLICK_HERE": "انقر هنا!",
                "I_WANT_MORE_ABOUT_TRANSFER": "أريد معرفة المزيد عن تحويل محافظ العملات الرقمية.",
                BOX_INFO: {
                    "TITLE": "الخصائص",
                    "TEXT": "عزيزي المستخدم، نظرًا لأن لديك بالفعل معاملات بالعملات الرقمية على Topchange، لديك حساب على موقع GreenChange، ويمكنك الدخول إليه باستخدام اسم المستخدم وكلمة المرور من Topchange. يُرجى التحقق منه، وإذا كان كل شيء على ما يرام، فتابع عملية المعاملة، وإلا فاتصل بنا من خلال قسم <a href=\"/support/tickets\">التذاكر</a>.",
                    "FULL_NAME": "الاسم الكامل",
                    "USERNAME": "اسم المستخدم",
                    "DATE_OF_BIRTH": "تاريخ الميلاد",
                    "NATIONAL_CODE": "الرقم الوطني",
                    "PASSPORT": "جواز السفر",
                },
                "CHECK_INFO_TXT": "المواصفات المعروضة على موقع GreenChange تخصني.",
                "CHECK_POLICY_TXT": "أوافق على: <ul><li>فتح حساب مستخدم جديد في GreenChange (https://GreenChange.io).</li> <li>للوصول إلى حسابي في GreenChange، يجب علي استخدام نفس اسم المستخدم وكلمة المرور الخاصة بـ Topchange.</li> <li>سيتم تحويل جميع أصولي المشفرة من Topchange إلى GreenChange.</li></ul>",
                "TRANSFER_BTN": "التحويل",
                "ALERT_AFTER_TRANSFER": "عزيزي المستخدم، لقد تم تنفيذ التحويل الخاص بك.",
            },
            CONFIRM_DIALOG: {
                "TITLE": "تأكيد التحويل",
                "ENTER_CODE": "لتقديم طلبك، يرجى إدخال رمز التحقق المرسل إلى <span> {{phoneNumber}} </span> و <span> {{userEmail}} </span>.",
                "CANCEL": "إلغاء",
            },
            LEARN_FILES: {
                "TITLE": "ملفات تعليمية",
                "FILE_NAME1": "كيفية تحويل الأموال من GreenChange إلى Topchange",
                "FILE_NAME2": "المصادقة",
                "FILE_NAME3": "كيفية تحويل الأموال من Topchange إلى GreenChange",
            },
            ALERT: {
                "TRANSFER_DONE_SUCCESSFULLY": "تمت عملية التحويل بنجاح.",
                "TRANSFER_DONE": "عزيزي المستخدم، تم تحويل محافظ العملات الرقمية الخاصة بك من Topchange إلى GreenChange بنجاح.",
                "TRANSFER_DONE1": "عزيزي المستخدم، لقد تم تنفيذ التحويل الخاص بك!",
                "TRANSFER_DONE2": "يمكنك تسجيل الدخول إلى GreenChange وعرض محافظ العملات الرقمية الخاصة بك.",
                "TRANSFER_DONE3": "تسجيل الدخول إلى GreenChange",
                "WITHOUT_TRANSACTION": "عزيزي المستخدم، لا توجد أي معاملات في محافظ العملات الرقمية الخاصة بك.",
            }
        },
        GENERAL: {
            "STATUSES": "الحالة",
            "ATTENTION": "تنبيه",
            "ACTION": "إجراء",
            "ACTIONS": "إجراء",
            "ACTIVE": "نشط",
            "ADD": "إرسال",
            "ADD2": "إضافة",
            "ALERT": "تحذير",
            "ALERT_DELETE": "هل أنت متأكد أنك تريد الحذف…؟",
            "ALERT_SECURE_CODE_TIME_EXPIRED": "انتهت صلاحية الرمز",
            "ALL": "الكل",
            "ALLOWED_FILES": "الملفات المسموح بها",
            "ATTACHMENT": "الملفات",
            "ATTACHMENT_VIEW": "ملف مرفق",
            "AUTHENTICATION": "التحقق",
            "AUTH_ALERT_TEXT": "عزيزي المستخدم، للتحقق… تحتاج إلى التحقق من هذه العناصر:",
            "AT_LEAST": "على الأقل",
            "BALANCE": "الرصيد",
            "VIDEO_GUIDE": "دليل الفيديو",
            "GUIDE": "دليل",
            "BACK": "رجوع",
            "BLOCK": "حظر",
            "BUY": "شراء",
            "CANCEL": "إلغاء",
            "CATEGORY": "الفئة",
            "CHANGE_FILE": "تغيير الملف",
            "CLEARE_ALL": "مسح الكل",
            "CLICK_HERE": "انقر هنا",
            "IMPORTANT_POINTS": "نقاط مهمة",
            "CLICK_TO_COPY_NUMBER": "انقر لنسخ الرقم",
            "TRACKING_NUMBER_COPIED_SUCCESSFULLY": "تم نسخ رقم التتبع بنجاح",
            "COPIED": "تم النسخ",
            "CLOSE": "إغلاق",
            "CODE": "رمز",
            "CONFIRM": "تأكيد",
            "OPTIONAL": "اختياري",
            "CONFIRM_AND_UPLOAD": "تأكيد وتحميل",
            "CONGRATULATION": "تهانينا",
            "CONTINUE_CONFIRM": "متابعة التأكيد",
            "CONTANCT_SUPPORT_FOR_MORE_INFO": "اتصل بالدعم لمزيد من المعلومات",
            "CREATE": "إنشاء",
            "DASHBOARD": "لوحة التحكم",
            "DATE": "التاريخ",
            "DATE_FROM": "من التاريخ",
            "DATE_TO": "إلى التاريخ",
            "DEACTIVE": "إلغاء التنشيط",
            "DELETE": "حذف",
            "DEPOSIT": "إيداع",
            "DESCRIPTION": "الوصف",
            "DETAILS": "التفاصيل",
            "DONE": "تم التأكيد",
            "DOWNLOAD": "تحميل",
            "EDIT": "تحرير",
            "EMAIL": "البريد الإلكتروني",
            "SMS": "رسالة نصية",
            "ERROR": "خطأ",
            "EXAMPLE": "مثال",
            "EXCHANGE": "تبادل",
            "CHANGE": "تغيير",
            "EXIT": "خروج",
            "EXPERT_COMMENT": "تعليق خبير",
            "EXPORT": "تصدير",
            "FEMALE": "أنثى",
            "FILTER": "تصفية",
            "HELP": "مساعدة",
            "HOME": "الصفحة الرئيسية",
            "HOURS_AGO": "منذ ساعات",
            "LAST_UPDATE": "آخر تحديث",
            "MALE": "ذكر",
            "MESSAGE": "رسالة",
            "MINUTES_AGO": "منذ دقائق",
            "MORE_INFO": "مزيد من المعلومات",
            "NAME": "الاسم",
            "NEW": "جديد",
            "NEW_STATUS": "حالة جديدة",
            "NEXT": "التالي",
            "NO": "لا",
            "NOTHING_TO_DISPLAY": "لا يوجد عنصر لعرضه",
            "NO_ITEM_TOـSHOW": "لا يوجد عنصر لعرضه",
            "PHONE": "الهاتف",
            "POINT": "نقاط",
            "QUICK_ACCESS": "الوصول السريع",
            "RECIEVE": "استلام",
            "REFUND": "استرداد",
            "REJECTED": "مرفوض",
            "REPLAY": "رد",
            "REQUEST": "طلب",
            "RETURN": "إرجاع",
            "ROW": "صف",
            "SAVE": "حفظ",
            "SEARCH": "بحث",
            "SECOND_AGO": "منذ ثوانٍ",
            "SECURITY_CODE": "رمز الأمان",
            "SELECT_FILE": "حدد ملف",
            "SELL": "بيع",
            "SEND": "إرسال",
            "SEND_CODE": "إرسال الرمز",
            "SERVICE": "الأموال الإلكترونية",
            "SHOW_ALL": "عرض الكل",
            "SMS_CREDIT": "رصيد الرسائل القصيرة",
            "STATUS_DATE": "تاريخ تغيير الحالة",
            "LAST_STATUS_DATE": "تاريخ آخر تغيير للحالة",
            "STATUS_TEXT": "الحالة",
            "SUBJECT": "الموضوع",
            "SUBMIT": "إرسال",
            "SUMMARY": "تفاصيل الطلب",
            "TEXT": "نص",
            "TITLE": "عنوان",
            "TRACKING_NUMBER": "رقم التتبع",
            "TRANSACTIONS": "المعاملات",
            "UPDATE": "تحديث",
            "UPLOADING": "تحميل",
            "WAITING": "انتظار",
            "WATING": "انتظار",
            "WITHDRAW": "سحب",
            "YES": "نعم",
            "EMONEY": "الأموال الإلكترونية",
            "CHOOSE": "اختر",
            "CRYPTO": "العملات الرقمية",
            "UNKNOWN": "غير معروف",
            "NOT_APPLICABLE": "غير قابل للتطبيق",
            "TYPE": "النوع",
            "TEXT_COPIED": "تم النسخ إلى الحافظة!",
            "CLICK_FOR_COPY": "انقر للنسخ",
            "RETRY": "إعادة المحاولة",
            "SELECT": "تحديد",
            "VERIFY": "تحقق",
            "I_UNDERSTAND": "أنا أفهم",
            "PLEASE_CONTACT_SUPPORT": "يرجى الاتصال بالدعم.",
            "ENTER_THE_INFORMATION_FIRST": "أدخل المعلومات أولاً.",
            "FROM_DATE": "من التاريخ",
            "TO_DATE": "إلى التاريخ",
            "TH_1": "الأول",
            "TH_2": "الثاني",
            "TH_3": "الثالث",
            "TH_4": "الرابع",
            "TH_5": "الخامس",
            "TH_6": "السادس",
            "TH_7": "السابع",
            "TH_8": "الثامن",
            "TH_9": "التاسع",
            "TH_10": "العاشر",
            "TH_11": "الحادي عشر",
            "TH_12": "الثاني عشر",
            "TH_13": "الثالث عشر",
            "TH_14": "الرابع عشر",
            "TH_15": "الخامس عشر",
            "TH_16": "السادس عشر",
            "TH_17": "السابع عشر",
            "TH_18": "الثامن عشر",
            "TH_19": "التاسع عشر",
            "TH_20": "العشرون",
            "_1": "واحد",
            "_2": "اثنان",
            "_3": "ثلاثة",
            "_4": "أربعة",
            "_5": "خمسة",
            "_6": "ستة",
            "_7": "سبعة",
            "_8": "ثمانية",
            "_9": "لا",
            "_10": "عشرة",
            "_11": "أحد عشر",
            "_12": "اثنا عشر",
            "_13": "ثلاثة عشر",
            "_14": "أربعة عشر",
            "_15": "خمسة عشر",
            "_16": "ستة عشر",
            "_17": "سبعة عشر",
            "_18": "ثمانية عشر",
            "_19": "تسعة عشر",
            "_20": "عشرون",
            FILE_UPLOAD_LIMITAION: {
                "SIZE": "أقصى حجم للملف: {{value}} ميجابايت",
                "FORMAT": "أنواع الملفات المسموح بها: {{value}}",
            },
            INPUT: {
                "CHOOSE_CURRENCY": "اختر العملة",
                "MORE_INFO": "مزيد من المعلومات",
            },
            STATUS: {
                "PENDING": "قيد الانتظار",
                "WAITING": "انتظار",
            },
            "DISABLED": "معطل",
            "TRANSACTION_NUMBER": "رقم المعاملة",
            "DIGITAL_CURRENCY": "العملات الرقمية",
            "TRANSACTION_ID": "معرّف المعاملة (تجزئة)",
            "SEE_ALL": "عرض الكل",
            "VIEW_PROFILE": "عرض الملف الشخصي",
            "NO_RESULTS": "لم يتم العثور على نتائج",
            "DOWNLOAD_APP": "تحميل",
            VALIDATION_CALCULATION: {
                CalculationFunctionRequired: 'دالة الحساب المحددة مطلوبة ولكن لم يتم توفيرها.',
                CalculationFunctionNotFound: 'تعذر العثور على دالة الحساب المحددة.',
                AmountNotFound: 'المبلغ المطلوب غير موجود.',
                NullTierRanges: 'نطاقات الشرائح فارغة (null).',
                TierRangesValidationError: 'واحد أو أكثر من نطاقات الشرائح غير صالحة.',
                TargetTierRangeNotFound: 'تعذر العثور على نطاق الشريحة المستهدف المحدد.',
                RequestedAmountRequired: 'المبلغ المطلوب ضروري ولكن لم يتم توفيره.',
                PayOrGetAmountRequired: 'مبلغ الدفع أو التحصيل ضروري ولكن لم يتم توفيره.',
                RequestedAmountOutOfTierRange: 'المبلغ المطلوب خارج نطاقات الشرائح المعرفة.',
                PayOrGetAmountOutOfTierRange: 'مبلغ الدفع أو التحصيل خارج نطاقات الشرائح المعرفة.',
                ExchangeRateIsIncorrect: 'سعر الصرف غير صحيح.',
                Overlap: 'نطاقات الشرائح لديها تداخل.',
                Gap: 'توجد فجوات بين نطاقات الشرائح.',
                ComingSoon: 'هذا التحقق محجوز للاستخدام المستقبلي.',
                RequestedAmountNotInTierRange: 'المبلغ المطلوب ليس ضمن نطاق الشريحة!',
                AMOUNT_BECAME_NEGATIVE: "أصبح المبلغ سالبًا"
            },
            DEACTIVATION: "إلغاء التفعيل",
            TRACKING_CODE: 'رمز التتبع',
            TRANSACTION_INFORMATION: 'معلومات المعاملة',
            TRANSACTION_STATUS: 'حالة المعاملة',
            CONTACT_SUPPORT: 'التواصل مع الدعم',
            PRICE: "السعر"
        },

        ENUM: {
            WALLET_TYPES: {
                "SAVING_ACCOUNT": "حساب التوفير",
                "TRANSIT_ACCOUNT": "حساب العبور",
            },
            ARCHIVE: {
                ARCHIVED: "مؤرشف",
                NONE_ARCHIVED: "غير مؤرشف",
            },
            CHANGE_TYPE: {
                "DECREASE": "نقصان",
                "INCREASE": "زيادة",
            },
            WALLET_CHANGE_TYPE: {
                "INCOMING_PAYMENTS": "إيداع",
                "OUTGOING_PAYMENTS": "سحب",
            },
            SEEN_USER_TYPES: {
                "NOBODY": "لا أحد",
                "FRIENDS": "الأصدقاء",
                "EVERYONE": "الجميع",
            },
            PRIORITY_TYPES: {
                "HIGH": "مرتفع",
                "MEDIUM": "متوسط",
                "LOW": "منخفض",
            },
            TICKET_STATUS: {
                "ANSWERD": "تمت الإجابة",
                "CLOSED": "مغلق",
                "CUSTOMER_REPLY": "رد العميل",
                "IN_PROGRESS": "قيد المعالجة",
                "ON_HOLD": "معلق",
                "OPEN": "مفتوح",
                "TC_CONTACT": "رد TC",
                "ARCHIVED": "مؤرشف",
            },
            PAYMENT_TYPE: {
                "BANK": "بنك",
                "CASH": "نقدي",
                "CREDIT": "ائتمان",
                "ELECTRONIC_MONEY": "الأموال الإلكترونية",
                "ONLINE": "عبر الإنترنت",
                "ID": 'التحويل البنكي',
                Crypto: 'الرقمية',
                OfflineCard: 'بطاقة إلى بطاقة غير متصل',
                OfflineIBAN: 'آيبان غير متصل'
            },
            SEND_PAYMENT_TYPE: {
                "BANK": "تحويل من البنك إلى TC",
                "CASH": "تحويل نقدي إلى TC",
                "CREDIT": "تحويل ائتماني إلى TC",
                "ONLINE": "تحويل عبر الإنترنت إلى TC",
                "ELECTRONIC_MONEY": "تحويل الأموال الإلكترونية إلى TC",
            },
            PAYMENT_STATUS: {
                "ACCEPTED": "مقبول",
                "NO_CONFIRMED": "غير مؤكد",
                "PENDING": "قيد الانتظار",
                "REJECTED": "مرفوض",
                "EXIST": "موجود",
                "AWAITINGAPPROVAL": "في انتظار الموافقة",
                "FAILURE": "فشل",
                "NOTFOUND": "غير موجود",
                "CANCELED": "ملغي",
                "COMPLETED": "مكتمل",
                "Incomplete": "غير مكتمل",
                "Refund": "استرداد",
            },
            ACCOUNT_STATUS: {
                Accepted: 'مؤكد',
                Blocked: 'محظور',
                PENDING: 'بانتظار الموافقة',
                Rejected: 'غير مؤكد',
                Unverified: 'غير موثق',
                VERIFIED: 'غير مؤكد',
                New: 'بانتظار الموافقة',
                Inquiring: 'بانتظار الموافقة',
                OnHold: 'بانتظار الموافقة',
            },
            REQUEST_STATUS: {
                "ACCEPTED": "مقبول",
                "DELETED": "محذوف",
                "DONE": "تم",
                "FAILED": "فشل",
                "NEW": "جديد",
                "PAYMENT": "دفع",
                "PENDING": "قيد الانتظار",
                "PROCESSING": "قيد المعالجة",
                "REFUND": "استرداد",
                "REJECTED": "مرفوض",
                "Paying": "دفع",
            },
            REQUEST_STATUS_DIRECT_DEPOSIT: {
                Done: "تم",
                Refunded: "استرداد",
            },
            REQUEST_STATUS_CRYPTO: {
                "New": "جديد",
                "Processing": "قيد المعالجة",
                "Accepted": "مقبول",
                "Failed": "فشل",
                "Completed": "مكتمل",
                "Broadcast": "بث",
                "Pending": "قيد الانتظار",
                "Sending": "جارِ الإرسال",
                "AwatingApproval": "في انتظار الموافقة",
                "Paying": "جارِ الدفع",
                "Done": "تم",
                "Canceled": "ملغي",
                "Failure": "فشل",
                "Exception": "استثناء",
                "Scheduled": "قيد المعالجة",
            },
            GATE_WAY_REQUEST_STATUS: {
                "New": "جديد",
                "Cancel": "إلغاء",
                "Paid": "مدفوع",
                "Verified": "موثّق",
                "ExpireToken": "رمز منتهي الصلاحية",
                "ExpireRequest": "طلب منتهي الصلاحية",
                "Refund": "استرداد",
            },
            ONLINE_PAYMENT_STATUS: {
                "FAILED": "فشل",
                "INCOMPLETE": "غير مكتمل",
                "REFUND": "استرداد",
                "SUCCESS": "ناجح",
            },
            DIRECT_DEPOSIT_PAYMENT_STATUS: {
                "Refund": "استرداد",
                "ACCEPTED": "ناجح",
                "NO_CONFIRMED": "غير مؤكد",
                "PENDING": "قيد الانتظار",
                "REJECTED": "مرفوض",
                "EXIST": "موجود",
                "AWAITINGAPPROVAL": "في انتظار الموافقة",
                "FAILURE": "فشل",
                "NOTFOUND": "غير موجود",
                "CANCELED": "ملغي",
                "COMPLETED": "مكتمل",
                "Incomplete": "غير مكتمل",
            },
            POINT_CHANGE_TYPE: {
                "ReceivedPoints": "النقاط المستلمة",
                "WithdrawalPoints": "النقاط المسحوبة",
            },
            TRANSACTION_TYPES: {
                "BETWEEN_MY_WALLETS": "بين المحافظ",
                "BUY_SERVICE": "شراء الأموال الإلكترونية",
                "CHARGE_SMS_PANEL": "شحن رصيد الرسائل القصيرة",
                "CHARGE_WALLET_CREDIT": "شحن رصيد المحفظة",
                "DEPOSIT": "إيداع",
                "EXCHANG_ESERVICE": "تبادل الأموال الإلكترونية",
                "INTERNAL_TRANSFER": "التحويل الداخلي",
                "SELL_SERVICE": "بيع الأموال الإلكترونية",
                "TC_PAY_GATEWAY": "بوابة الدفع TopChange",
                "VOUCHER_SERVICE": "خدمة القسائم",
                "WITHDRAWAL": "سحب",
                "WITHDRAWAL_POINT": "سحب النقاط",
                "WalletCorrectionRequest": "تصحيح المحفظة",
                "PointCorrectionRequest": "تصحيح النقاط",
                "Transition": "الانتقال",
                "TerminalSettlement": "تسوية المحطة",
                "BrokerDeposit": "إيداع الوسيط",
                "DirectDeposit": "التحويل البنكي",
                "LOCK_WALLET": "قفل المحفظة",
                "UNLOCK_WALLET": "إلغاء قفل المحفظة",
                "P2P_INTERNAL_TRANSFER": "التحويل الداخلي P2P",
                "P2P_PENALTY": "غرامة P2P",
                "AffiliateProgram": "برنامج الشراكة",
                "P2PCommission": "عمولة P2P",
                "CryptoDeposit": "إيداع العملات الرقمية",
                "CryptoWithdrawal": "سحب العملات الرقمية",
            },
            NOTIFICATION_TYPE: {
                "ContactUs": "اتصل بنا",
                "Deposit": "إيداع",
                "Exchange": "صرف العملات",
                "ExpertTicket": "تذاكر الدعم",
                "Friend": "الأصدقاء",
                "Point": "نقاط",
                "Receive": "استلام",
                "RequestMessage": "رسالة الطلبات",
                "Send": "إرسال",
                "Ticket": "التذاكر",
                "VerifyBankAccount": "التحقق من الحساب البنكي",
                "VerifyInfo": "التحقق من المعلومات",
                "Voucher": "خدمة القسائم",
                "WalletChange": "المحفظة",
                "Withdrawal": "سحب",
                "DirectDeposit": "التحويل البنكي",
                "PointChange": "تغييرات النقاط",
                "P2P": "P2P",
                "Crypto": "إيداع العملات الرقمية",
                "CryptoWithdraw": "سحب العملات الرقمية",
                Chat: "دردشة",
            },
            GATEWAY_ACTION_TYPE: {
                "50": "إيداع",
                "100": "سحب",
                "Deposit": "إيداع",
                "Withdraw": "سحب",
            },
            SETTLEMENT_STATUS_TYPE: {
                "1": "جديد",
                "2": "مكتمل",
                "3": "فشل",
                "New": "جديد",
                "Completed": "مكتمل",
                "Failed": "فشل",
            },
            REQUEST_TYPE_VALIDATION: {
                "0": "إيداع بواسطة الأموال الإلكترونية",
                "1": "إيداع بالعملة",
                "2": "تحويل العملات",
                "3": "تحويل الأموال الإلكترونية",
                "4": "سحب النقاط",
                "5": "إرسال العملات",
                "6": "إرسال من المحفظة",
                "7": "شراء القسيمة",
                "8": "سحب الأموال الإلكترونية",
                "9": "سحب العملات",
            },
            REQUEST_TYPE: {
                "1": "إيداع",
                "2": "سحب",
                "3": "إرسال",
                "4": "تحويل",
                "5": "نقاط",
                "6": "قسيمة",
            },
            REQUEST_TYPE_ACTICE_REQUESTS: {
                "1": "إيداع",
                "2": "سحب",
                "3": "إرسال",
                "4": "إرسال",
                "5": "سحب",
                "6": "إيداع",
                "7": "تحويل",
                "8": "شحن رصيد لوحة الرسائل القصيرة",
                "9": "نقاط",
                "10": "قسيمة",
            },
            INVITEE_STATUS: {
                "CLEARED": "تم التصفية",
                "OUTSTANDING": "معلّق",
            },
            POINT_SORT_OPTION: {
                Newest: 'الأحدث',
                Oldest: 'الأقدم',
                MostPoints: 'أعلى تقييم',
                LeastPoints: 'أدنى تقييم'
            }
        },
        VALIDATION: {
            "AGREEMENT_REQUIRED": "قبول اتفاقية الخصوصية والسياسة مطلوب.",
            "FILE_MAX_SIZE": "حجم الملف كبير جدًا.",
            "INVALID": "غير صالح",
            "INVALID_FIELD": "{{name}} غير صالح",
            "NOT_FOUND": "لم يتم العثور على الطلب.",
            "FILE_EXTENSION": "تنسيق الملف المحدد غير صحيح.",
            "MIN_LENGTH": "أقل طول لـ {{name}}: {{value}}",
            "MAX_LENGTH": "أقصى طول لـ {{name}}: {{value}}",
            "REQUIRED": "{{name}} مطلوب",
            "MIN_LENGTH_FIELD": "أقل طول للحقل:",
            "SELECT": "{{name}} مطلوب",
        },
        USER: {
            ACCOUNT: {
                BANK: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                "BLOCKED": "الحساب البنكي",
                                "REJECTED": "الحساب البنكي",
                                "ACCEPTED": "الحساب البنكي",
                            },
                            BODY: {
                                "ACCEPTED": "تم قبول معلومات الحساب البنكي",
                                "BLOCKED": "تم حظر الحساب",
                                "REJECTED": "تم رفض معلومات الحساب البنكي",
                            }
                        }
                    }
                }
            },
            CREDIT: {
                POINT: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                "CORRECTION_INCREASE": "زيادة النقاط",
                                "CORRECTION_DECREASE": "تقليل النقاط",
                            },
                            BODY: {
                                "CORRECTION_INCREASE": "تمت إضافة النقاط للتصحيح إلى إجمالي نقاطك.",
                                "CORRECTION_DECREASE": "تم خصم نقاط التصحيح من إجمالي نقاطك.",
                            }
                        }
                    }
                }
            },
            ALERT: {
                ERROR: {
                    TRY_COUNT_EXPIRED_OR_KEY_NOT_FOUND: "الكود المدخل غير صحيح.",
                }
            }
        },
        FRIEND: {
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        "NEW_REQUEST": "طلب صداقة",
                        "NEW_REQUEST_TO_NOT": "طلب صداقة",
                        "ACCEPTED": "طلب صداقة",
                        "REJECTED": "طلب صداقة",
                        "CANCEL": "طلب صداقة",
                    },
                    BODY: {
                        "NEW_REQUEST": "تم إرسال طلب جديد لك من {{0}}.",
                        "ACCEPTED": "تم قبول طلب صداقتك من قبل {{0}}.",
                        "REJECTED": "تم رفض طلب صداقتك من قبل {{0}}.",
                        "CANCEL": "تم حذف طلب صداقتك من قبل {{0}}.",
                    }
                }
            }
        },
        WALLET: {
            "BALANCE": "الرصيد",
            "CHANGE_TYPE": "تغيير النوع",
            "CHOOSE_CURRENCY": "نوع العملة",
            "DESCRIPTION": "الوصف",
            "DIACTIVE": "غير نشط",
            "EDIT_WALLET": "تعديل المحفظة",
            "EDIT_WALLETS": "تعديل المحفظة",
            "EVERYONE": "الجميع",
            "LOCK_MESSAGE": "تم قفل محفظتك. يرجى الاتصال بالدعم.",
            "CURRENCY_IS_DEACTIVE": "لا يمكن استخدام هذه المحفظة بسبب نقص الخدمة أو تعطل سعر الصرف. يرجى الانتظار حتى يتم حله.",
            "MY_WALLETS": "محافظي",
            "NEW_WALLET": "محفظة جديدة",
            "NOBODY": "خاص",
            "SAVING": "المحافظ العابرة",
            "SEEN_USER_REQURED": "يرجى اختيار من يمكنه رؤية محفظتك.",
            "SELECT_DATE_FOR_REPORTING": "يرجى اختيار من وإلى التاريخ. الحد الأقصى للفترة الزمنية التي يمكنك اختيارها هي 31 يومًا.",
            "SELECT_WALLET_FOR_REPORTING": "يرجى اختيار المحفظة أولًا.",
            "SUPPORT_TICKET": "تذكرة الدعم",
            "TC_WALLETS": "محفظة TC",
            "TEXT": "ملاحظة",
            "TRANSACTIONS": "المعاملات",
            "TRANSACTION_TYPE": "نوع المعاملة",
            "TRANSIT": "حفظ المحافظ",
            "VIEW_FRIENDS": "الأصدقاء",
            "WALLET": "المحفظة",
            "WALLETS": "المحافظ",
            "WALLET_TYPE": "نوع المحفظة",
            "WHO_CAN_SEE_MY_WALLET": "عرض لـ",
            "ACCOUNT_NUMBER": "رقم الحساب",
            "WALLET_NAME": "اسم المحفظة",
            "CRYPTO_CURRENCY": "العملات الرقمية",
            "CRYPTO_CURRENCIES": "العملات الرقمية",
            "FIAT": "العملات الورقية",
            "FIAT_WALLETS": "محافظ العملات الورقية",
            "CRYPTO_WALLETS": "محافظ العملات الرقمية",
            "WHAT_IS_SAVING_WALLET": "ما هي محافظ الادخار في TC؟",
            "WHAT_IS_TRANSIT_WALLET": "ما هي المحافظ العابرة في TC؟",
            INVOICE_NUMBER: "رقم الفاتورة",
            INFO_USER: 'محافظ <span>{{dispalyName}}</span> <span>({{email}})</span>',
            WALLET_OWNERSHIP_CERTIFICATE_RETRIEVAL: 'الحصول على شهادة المحافظ',
            ALERT: {
                "BALANCE_IS_LOW": "رصيد محفظتك غير كافٍ.",
                "CANT_USE_WALLET_FOR_INTERNAL_TANSFER": "لا يمكنك استخدام هذه المحفظة للتحويل الداخلي.",
                "SUCCESS_ADD": "تم إنشاء محفظة جديدة بنجاح.",
                "SUCCESS_EDIT": "تم تعديل المحفظة بنجاح.",
                "EXPORT_TRANSACTION_HINT": "الحد الأقصى المسموح به للتصدير هو شهر واحد.",
                "FOR_CREATE_WALLET_YOU_NEED_VERIFY": "لإنشاء محفظة، يجب عليك أولًا تنفيذ خطوات المصادقة على الموقع.",
                "THERE_IS_NO_WALLET_TO_DISPLAY": "لا توجد محفظة للعرض",

            },
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        "DECREASE": "تم تقليل رصيد المحافظ",
                        "INCREASE": "تم زيادة رصيد المحافظ",
                        "PG_DECREASE": "تم سحب مبلغ {{0}} من المحفظة {{1}} بواسطة بوابة الدفع TC مع رقم التتبع {{2}}.",
                        "PG_INCREASE": "تم إيداع مبلغ {{0}} في المحفظة {{1}} بواسطة بوابة الدفع TC مع رقم التتبع {{2}}.",
                        "CORRECTION_DECREASE": "تم خصم مبلغ {{0}} من المحفظة {{1}} للتصحيح.",
                        "CORRECTION_INCREASE": "تمت إضافة مبلغ {{0}} إلى المحفظة {{1}} للتصحيح.",
                        "IPG_SETTLEMENT_INCREASE": "تمت إضافة مبلغ {{0}} {{4}} إلى محفظتك بالريال.",
                    },
                    BODY: {
                        "PG_DECREASE": "تم سحب مبلغ {{0}} من المحفظة {{1}} بواسطة بوابة الدفع TC مع رقم التتبع {{2}}.",
                        "PG_INCREASE": "تم إيداع مبلغ {{0}} في المحفظة {{1}} بواسطة بوابة الدفع TC مع رقم التتبع {{2}}.",
                        "CORRECTION_DECREASE": "تم خصم مبلغ {{0}} من المحفظة {{1}} للتصحيح.",
                        "CORRECTION_INCREASE": "تمت إضافة مبلغ {{0}} إلى المحفظة {{1}} للتصحيح.",
                        "IPG_SETTLEMENT_INCREASE": "تمت إضافة مبلغ {{0}} {{4}} إلى محفظتك بالريال.",
                    }
                }
            },
            VALIDATION: {}
        },
        SUPPORT: {
            TICKET: {
                DISABLED_NEW_TICKET_MESSAGE: "عزيزي المستخدم، إنشاء تذكرة جديدة معطل، يرجى استخدام الدردشة عبر الإنترنت بدلًا من ذلك.",
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            "CLOSED": "التذاكر",
                            "ADD_REPLY": "التذاكر",
                            "EXPERT_TICKET": "تذكرة خبير",
                        },
                        BODY: {
                            "ADD_REPLY": "هناك رد جديد من خبير على التذكرة رقم {{0}}.",
                            "CLOSED": "تم إغلاق التذكرة رقم {{0}} بواسطة خبير.",
                            "EXPERT_TICKET": "تم إرسال تذكرة لك من قبل الخبراء.",
                        }
                    }
                }
            },
            CHAT: {
                TRACKING_NUMBER: "رقم التتبع",
                SELLER: "البائع",
                BUYER: "المشتري",
                TRANSACTIONS: "المعاملات",
                SUCCESS: "نجاح",
                SUPPORT: "الدعم",
                WRITE_YOUR_MESSAGE_HERE: "اكتب رسالتك هنا...",
                CONFIRM_AND_START_CHAT: "تأكيد وبدء المحادثة",
                THIS_CONVERSATION_HAS_ENDED: "انتهت هذه المحادثة.",
                SHOW_ALL: "عرض الجميع",
                SHOW_LESS: "عرض أقل",
                CHAT_WITH_SELLER: "محادثة مع البائع",
                CHAT_WITH_BUYER: "محادثة مع المشتري",
                GROUP_YESTERDAY: "الأمس",
                GROUP_TODAY: "اليوم",
                RULES: {
                    RULE_ONE: {
                        TITLE: "التحقق من الهوية",
                        TEXT_ONE: "تؤكد أنك قد حددت هويتك بدقة سواء كنت مشتريًا أو بائعًا.",
                        TEXT_TWO: "يُمنع استخدام هوية مزيفة أو التضليل أو محاولة خداع الطرف الآخر."
                    },
                    RULE_TWO: {
                        TITLE: "الأمان والسرية",
                        TEXT_ONE: "تجنب مشاركة المعلومات الحساسة أو السرية أو الشخصية في المحادثات والتي قد تُستغل.",
                        TEXT_TWO: "أنت مسؤول عن حماية معلوماتك الخاصة."
                    },
                    RULE_THREE: {
                        TITLE: "السلوك المسؤول والالتزام بالقانون",
                        TEXT_ONE: "يُمنع توجيه التهديدات أو الإهانات أو الطلبات غير القانونية أو أي سلوك غير مهني.",
                        TEXT_TWO: "يجب أن تكون الاتفاقيات المالية أو معاملات البيع واضحة وقابلة للتتبع ومتوافقة مع القانون."
                    },
                    RULE_FOUR: {
                        TITLE: "تجنب تحويل الأموال خارج الإطار الآمن",
                        TEXT_ONE: "لا تقم بتحويل أي أموال قبل أن تكون شروط المعاملة نهائية وواضحة.",
                        TEXT_TWO: "عند الضرورة، استخدم فقط الطرق الآمنة التي يقدمها النظام."
                    },
                    RULE_FIVE: {
                        TITLE: "الشفافية في المعاملات",
                        TEXT_ONE: "يجب على البائع توضيح تفاصيل السلع أو الخدمات والسعر النهائي وشروط التسليم وأي مشكلات محتملة.",
                        TEXT_TWO: "يجب على المشتري توضيح شروطه وتوقعاته واحتياجاته."
                    },
                    RULE_SIX: {
                        TITLE: "تدخل فريق الدعم",
                        TEXT_ONE: "يحق لفريق الدعم الدخول إلى المحادثة في أي وقت دون إشعار مسبق.",
                        TEXT_TWO: "في حال ملاحظة أي سلوك مريب أو مخالفات أو طلبات غير طبيعية من أي طرف، قد يقوم الدعم بمراجعة المحادثة أو تقييدها أو إنهائها."
                    },
                    INTERNAL_CHAT_ONLY: "يجب إجراء جميع المراسلات المتعلقة بالمعاملة حصرياً عبر الدردشة الداخلية للمنصة.",
                    EXTERNAL_CHANNEL_FORBIDDEN: "يُحظر نقل المحادثات إلى أي قناة خارج المنصة ولن تُعتبر صالحة في تسوية النزاعات.",
                    CONTACT_SHARING_FORBIDDEN: "يُمنع منعاً باتاً مشاركة أرقام الاتصال أو معرفات وسائل التواصل الاجتماعي أو نقل المحادثات خارج المنصة.",
                    UNPROFESSIONAL_MESSAGE_WARNING: "تجنب إرسال رسائل غير مهنية أو غير معيارية، أو طلب تغيير شروط المعاملة.",
                    DISPUTE_EVIDENCE_POLICY: "في حال نشوء نزاع، تُعدّ فقط المستندات والمعلومات المسجلة في الدردشة الداخلية للمنصة أساساً للمراجعة واتخاذ القرار.",
                },
                REPORT_VIOLATION: 'الإبلاغ',
                CONVERSATION_BLOCKED: 'تم حظر المحادثة.',
                THIS_CONVERSATION_HAS_BEEN_CLOSED_BY_AN_ADMIN: 'تم إغلاق هذه المحادثة من قبل المشرف.',
                REPORT_OF_RULE_VIOLATION: 'الإبلاغ عن مخالفة القواعد',
                REPORT_OF_RULE_VIOLATION_TEXT: 'إذا لاحظت أي نشاط مشبوه، يرجى الإبلاغ عن المستخدم المعني فورًا. يساعدنا هذا الإجراء على اتخاذ التدابير اللازمة بسرعة وفعالية، مما يضمن أمن وسلامة بيئة المستخدمين. نحن نقدر تعاونك في هذا الأمر.',
                CONFIRM: 'تأكيد',
                EDIT: 'تعديل',
                ENTER_THE_DESCRIPTION: 'أدخل الوصف...',
                WE_ARE_REVIEWING_YOUR_REPORT: 'تم استلام بلاغك مسبقًا وهو قيد المراجعة حالياً.',
                REPORT_OF_RULE_VIOLATION_WARN: 'الإبلاغ عن مخالفة القواعد',
                REPORT_OF_RULE_VIOLATION_WARN_TEXT: "سلوكك أو المحتوى الذي قمت بمشاركته لا يتوافق مع بعض قواعد ومعايير المنصة. قد يكون قد تم تقديم هذا البلاغ لأسباب مثل انتهاك إرشادات السلامة، أو التواصل غير المناسب، أو الأنشطة غير المصرح بها. يرجى مراجعة القواعد والالتزام بها في التفاعلات القادمة لتجنب تكرار هذا الموقف.",
                CONFIRM_AND_CONTINUE_CHAT: 'تأكيد ومتابعة الدردشة',
                REASON_REPORT: {
                    offPlatform: 'معاملة خارج المنصة',
                    shareContact: 'مشاركة معلومات الاتصال',
                    abuse: 'لغة مسيئة',
                    illegal: 'نشاط احتيالي',
                    spam: 'إرسال رسائل مزعجة',
                    threat: 'تهديد أو ابتزاز',
                },
                ALERTS: {
                    TITLE_SUCCESSFULL_REPORT: 'تم إرسال البلاغ بنجاح.',
                    DESCRIPTION_SUCCESSFULL_REPORT: 'شكرًا لاتخاذك هذا الإجراء. يقوم فريقنا بمراجعة البلاغ.',
                }
            },
        },
        ADV_BANNER: {
            ADV_BANNER_BANNER: "عرض TC لك",
        },
        CRYPTO_DEPOSIT: {
            DIALOG_ALERT: {
                "TITLE_CHANGE_ADDRESS": "تغيير عناوين إيداع Tether",
                "BIG_DESCRIPTION_CHANGE_ADDRESS": "ستتغير عناوين إيداع Tether الخاصة بك بدءًا من 3 فبراير.",
                "TEXT_ONE": "اعتبارًا من هذا التاريخ:",
                "TEXT_TWO": "استخدم العناوين الجديدة فقط في هذه الصفحة.",
                "TEXT_THREE": "ستكون الإيداعات إلى العناوين القديمة على مسؤوليتك الشخصية.",
                "GOT_IT": "تم الفهم",
            },
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        CRYPTO_DEPOSIT: "تم الاستلام (محفظة)",
                    },
                    BODY: {
                        CRYPTO_DEPOSIT: "تم استلام مبلغ <span class=\"fa-number-dir\">&rlm;{{0}} </span> على شبكة <span>{{1}}</span> برقم المعاملة <span>{{2}}</span>.",
                    }
                }
            }
        },
        CRYPTO_WITHDRAW: {
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        CRYPTO_WITHDRAW: "السحب من المحفظة",
                    },
                    BODY: {
                        CRYPTO_WITHDRAW: "تم سحب مبلغ <span class=\"fa-number-dir\">&rlm;{{0}} </span> على شبكة <span>{{1}}</span> مع رقم التتبع <span>{{2}}</span>.",
                    }
                },
            }
        },
        APPLICATION_PWA: {
            TEXT: "تطبيق TopChange",
            INSTALL: "تثبيت",
            UPDATE_VERSION: 'إصدار جديد جاهز. حدّث الآن للحصول على أحدث التغييرات.',
            UPDATE: 'تحديث',
            ALERTS_PAGE: {
                UPDATE: 'تحديث',
                NEED_UPDATE_TEXT: "لتحسين تجربتك، أضفنا ميزات جديدة وأجرينا تغييرات على أداء التطبيق. نوصيك بتحديث التطبيق.",
                FORCE_UPDATE_TEXT: "للحفاظ على أمان حسابك وضمان الوصول المستمر إلى الخدمات، يرجى تحديث التطبيق إلى أحدث إصدار. لن يستغرق ذلك سوى لحظة.",
                LATER: 'لاحقًا',
                SERVICE_DISABLED_TITLE: 'انقطاع الخدمة',
                SERVICE_DISABLED_TEXT: 'انتهت فترة نشاط هذا الإصدار من التطبيق ولم يعد مدعومًا. نشكرك بصدق على مرافقتك لنا خلال هذه الفترة. إذا كان لديك رصيد متبقٍ أو أي استفسار بخصوص حسابك، يرجى التواصل مع الدعم فورًا.',
                EXIT_APP: 'الخروج من التطبيق',
                DEVICE_IS_ROOTED_TITLE: 'تم حظر الوصول إلى التطبيق',
                DEVICE_IS_ROOTED_TEXT: 'للحفاظ على أمان حسابك وأصولك، لا يمكن تشغيل TopChange على الأجهزة التي تحتوي على صلاحيات Root.',
            },
            BIOMETRIC: {
                TITLE: 'TopChange',
                SUB_TITLE: 'تحقّق من هويتك لتسجيل الدخول',
                CANCEL: 'إلغاء',
                SAVE_TITLE: "حفظ كلمة المرور",
                SAVE_DESC: "احفظ كلمة مرورك لتسجيل دخول أسرع في المرة القادمة.",
                SAVE_CONFIRM: "حفظ",
                SAVE_CANCEL: "لا، شكراً"
            },
            FILE_DOWNLOAD: {
                SUCCESS_IOS: "تم حفظ الملف في مجلد المستندات",
                SUCCESS_ANDROID: "تم حفظ الملف في مجلد التنزيلات",
                ERROR: "خطأ في تنزيل الملف"
            }
        },
        DASHBOARD_NEW: {
            KYC_VERIFICATION: {
                "TEXT": "يرجى إكمال عملية التوثيق للوصول إلى خدمات TopChange وتفعيل الإيداعات وشراء العملات الرقمية وصلاحيات التداول.",
                "AUTHENTICATION": "التوثيق",
                "CONTINUE": "متابعة",
                "ALERT_KYC_TITLE": "لا يمكنك استخدام هذه الميزة",
                "ALERT_KYC_TEXT": "للوصول إلى خدمات TopChange، يرجى إكمال عملية التوثيق أولاً."
            },
            ACTIVE_REQUEST: {
                "TITLE_ACTIVE_REQUEST": "الطلبات النشطة",
                "VIEW": "عرض",
                "AMOUNT_AND_TYPE": "النوع والمبلغ",
                "CHANGE_STATUS_DATE": "وقت تغيير الحالة",
                "YOU_HAVE_NO_ACTIVE_REQUESTS": "ليس لديك أي طلبات نشطة."
            },
            EXCHANGE_RATE: {
                "TILTE_EXCHANGE_RATE": "سعر الصرف",
                "BUY": "شراء:",
                "SELL": "بيع:",
                "NOT_FOUND_SEARCH": "لم يتم العثور على نتائج لبحثك. يرجى تجربة اسم عملة آخر.",
                "SEARCH": "بحث"
            },
            DIALOG_MARATHON: {
                TITLE: 'ماراثون الأرباح قد بدأ!',
                DESC_ONE: 'انضم إلى المنافسة من خلال شراء أو بيع <span class="bold">Tether</span> على <span class="en-number">P2P</span> واربح الجوائز!',
                DESC_TWO: 'لديك وقت حتى 17 يونيو فقط!',
                COMPETITION_INFORMATION: 'معلومات المنافسة',
                BUY_ADS: 'إعلان شراء'
            }
        },
        KYC_AUTH_NEW: {
            "MOBILE_PHONE": "رقم الجوال",
            "IDENTITY_INFORMATION": "معلومات الهوية",
            "COMMITMENT_LETTER": "تأكيد الالتزام",
            "AUTHENTICATION": "التوثيق",
            "TEXT_STEPPER": "يرجى إكمال الخطوات التالية للتحقق من هويتك.",
            "PHONE_STEP_DESC": "يرجى إدخال رقم هاتف جوال يخصك.",
            "COUNTRY": "الدولة",
            "CONFIRM_CODE": "تأكيد الرمز",
            "CHANGE_NUMBER": "تغيير الرقم",
            "DESCRIPTION_CONFIRM_PHONE_NUMBER_DIALOG": "يرجى إدخال الرمز المرسل إلى <strong class=\"dltr\">{{value}}</strong>.",
            "YOUR_PROFILE_IS_INCOMPLETE": "ملفك الشخصي غير مكتمل",
            DESCRIPTION_KYC_ALERT_DIALOG: 'لعرض المعلومات في ملفك الشخصي، يرجى إكمال عملية التحقق أولاً.',
            IDENTITY_INFO: {
                DESC_START_KYC: 'عندما تكون مستعدًا، اضغط على "ابدأ" لبدء العملية.',
                TITLE_NOT_COMPLETE_KYC: 'معلومات الهوية غير مكتملة',
                DESC_NOT_COMPLETE_KYC: 'عزيزي المستخدم، لم تكمل بعد عملية التحقق من الهوية. عندما تكون مستعدًا، اضغط على "متابعة" لبدء العملية.',
                START: 'ابدأ',
                CONTINUE: 'متابعة',
                TITLE_PENDING_CHECK_KYC: 'مراجعة معلومات الهوية',
                DESC_PENDING_CHECK_KYC: 'عزيزي المستخدم، تم تحميل مستنداتك بنجاح وهي قيد المراجعة من قبل خبرائنا. نرجو منك التحلي بالصبر.',
                LIST_INFO_FOR_KYC: {
                    TITLE_PERSONAL_INFO: 'المعلومات الشخصية',
                    DESC_PERSONAL_INFO: 'يرجى إدخال معلوماتك الشخصية (الاسم الأول واسم العائلة، رقم الهوية الوطنية، تاريخ الميلاد، الجنس) باللغة الفارسية وفقًا للمستند المقدم.',
                    TITLE_DOCUMENTS: 'مستندات الهوية',
                    DESC_DOCUMENTS: 'يرجى اختيار أحد الخيارات (بطاقة الهوية الوطنية، جواز السفر، رخصة القيادة) وتحميل صورة له. تأكد من أن المستند غير منتهي الصلاحية وبحالة جيدة قبل إرسال صورة عالية الجودة.',
                    TITLE_FACE_VERIFICATION: 'التحقق من الوجه',
                    DESC_FACE_VERIFICATION: 'يتم التحقق من الهوية البصرية بكل بساطة عن طريق تحريك الرأس لبضع لحظات أمام الكاميرا.'
                },
                PHONE_NUMBER_INFO_EDIT: {
                    "TILTE_IDENTITY_INFO_DOES_NOT_MATCH": "معلومات الهوية لا تتطابق مع صاحب رقم الهاتف.",
                    DESC_IDENTITY_INFO_DOES_NOT_MATCH: 'عزيزي المستخدم، المستندات التي قدمتها لا تعود لصاحب رقم الهاتف الذي أدخلته. يرجى المحاولة مرة أخرى بعد إدخال رقم هاتف يخصك.',
                    "DOCUMENTS": "المستندات",
                    "INFO_DOCUMENTS_UPLOADED": "المستندات التي قمت بتحميلها هي كالتالي:",
                    "FULL_NAME": "الاسم الكامل",
                    "DATE_OF_BIRTH": "تاريخ الميلاد",
                    NATIONAL_CODE: 'الرقم الوطني',
                    PENDING_REVIEW_PHONE_NUMBER: 'رقمك قيد المراجعة، يرجى التحلي بالصبر',
                },
                REJECTED: {
                    TITLE: 'فشل التحقق',
                    MESSAGE_TEXT: 'عزيزي المستخدم، للأسف حدثت مشكلات أثناء عملية التحقق الخاصة بك. يرجى التواصل مع الدعم للمتابعة.',
                    "CONTACT_SUPPORT": "اتصل بالدعم"
                },
            },
            COMMITMENT_CONFIRMATION: {
                CONFIRMATION_OF_THE_COMMITMENT_LETTER: 'تأكيد خطاب الالتزام',
                SUB_TEXT_CONFIRMATION_OF_THE_COMMITMENT_LETTER: 'لإكمال عملية التحقق من الهوية، يرجى تأكيد خطاب الالتزام.',
                TEXT_CONFIRM_COMMITMENT_LETTER: 'أنا، {{name}}، صاحب رقم الهوية الوطنية {{nationalIdentityNumber}}، قد قدمت مستنداتي للتحقق من الهوية على موقع (TopChange) وأقر وأؤكد تمامًا ما يلي:',
                CONFIRM: 'تأكيد',
                ITEM_COMMITMENT_LETTER: {
                    TITLE_ONE: 'التحقق من الهوية الشخصية',
                    DESC_ONE: 'تم التسجيل وتقديم المستندات من قبلي شخصيًا، ولم أقم بتسليم مستنداتي الشخصية لأي شخص آخر.',
                    TITLE_TWO: 'المسؤولية عن استخدام الحساب',
                    DESC_TWO: 'أتعهد باستخدام حسابي بشكل شخصي ولن أشارك معلوماتي البنكية أو الشخصية مع أي شخص. كما أنني أتعهد بعدم استلام أي مبالغ نقدية أو عملات رقمية من الآخرين مقابل استخدام حسابي.',
                    TITLE_THREE: 'تحمل المسؤوليات القانونية',
                    DESC_THREE: 'في حال حدوث أي استخدام غير مصرح به للحساب، بما في ذلك استلام ودائع غير قانونية، أتحمل كامل المسؤولية القانونية والقضائية، بما في ذلك العقوبات المقررة وتعويض المتضرر.',
                }
            },
            DIALOG_AUTH_SUCCESS: {
                TITLE: 'تم التحقق بنجاح',
                DESC: 'عزيزي المستخدم، لقد تم إكمال عملية التحقق بنجاح، ويمكنك الآن استخدام ميزات TopChange.',
                PROFILE: 'الملف الشخصي'
            }


        },
        DIALOG_CONTACT_SUPPORT: {
            "TITLE": "الاتصال بفريق دعم TopChange",
            "DESC": "عزيزي المستخدم، لمزيد من المعلومات أو للتواصل مع فريق الدعم لدينا، يرجى استخدام إحدى الطرق التالية."
        },
        NEW_PROFILE: {
            EMPTY_CONTENT: 'لا يوجد محتوى لعرضه.',
            TABS: {
                SECURITY: 'الأمان',
                AUTH: 'المصادقة',
                ACCOUNTS: 'الحسابات',
                POINTS: 'النقاط',
                REQUESTS: 'الطلبات',
            },
            SECTION_HEAD_PROFILE: {
                LAST_LOGIN: 'آخر تسجيل دخول:',
                TITLE_CONFIRM_TWO_FACTOR: "المصادقة الثنائية",
                TITLE_ANTI_PHISHNG: 'رمز مكافحة التصيد',
                TITLE_LOCAL_TIME: 'الوقت المحلي',
                DESC_LOCAL_TIME: 'يرجى إدخال الوقت المحلي الذي تستخدم فيه TC.',
                TITLE_DEFAULT_LANGUAGE: "اللغة الافتراضية",
                DESC_DEFAULT_LANGUAGE: "الرجاء اختيار اللغة الافتراضية؛ سيتم استخدام هذه اللغة لإرسال رسائل البريد الإلكتروني وإشعارات TC.",
                ACTIVATED: 'مفعل',
                NOT_ACTIVED: 'غير مفعل',
                CONFIRM: "تأكيد",
                CANCEL: "إلغاء",
            },
            SECURITY: {
                TITLE_ADVANCE_SETTING: 'إعدادات الأمان المتقدمة',
                TITLE_CONFIRM_TWO_FACTOR: "المصادقة الثنائية",
                DESC_CONFIRM_TWO_FACTOR: 'المصادقة الثنائية باستخدام Google Authenticator.',
                ACTIVE_BTN: 'تفعيل',
                DEACTIVE_BTN: 'تعطيل',
                EDIT_BTN: 'تعديل',
                TITLE_ANTI_PHISHNG: 'رمز مكافحة التصيد',
                DESC_ANTI_PHISHNG: 'تأكد من أن رسائل التنبيه الإلكترونية تصلك فقط من Topchange.',
                DESC_2FA_DIALOG_DISABLE: "يرجى إدخال الرمز المرسل إلى التطبيق لتعطيل التحقق بخطوتين.",
                RECENT_HISTORY: {
                    SECURITY_HISTORY: 'سجل الأمان',
                    RECENT_LOGIN_HISTORY: 'تسجيلات الدخول الأخيرة',
                    SECURITY_HISTORY_EMPTY: 'لا يوجد سجل أمان في الوقت الحالي.',
                    CHANGE_PASSWORD: 'تغيير كلمة المرور',
                    IP: 'IP',
                    TYPE: 'النوع',
                    TIME: 'الوقت',
                    ONLINE: "متصل",
                    OFFLINE: 'غير متصل',
                    DEVICE_TYPE: 'نوع الجهاز',
                    STATUS: "الحالة",
                    SECURITY_RECENT_LOGINS_HISTORY_EMPTY: 'لا توجد حالياً أي سجلات تسجيل دخول حديثة.',
                    TYPES: {
                        Register: 'تسجيل',
                        Login: 'تسجيل الدخول',
                        Login2FA: 'تسجيل الدخول باستخدام رمز التحقق بخطوتين',
                        SendRegisterCode: 'إرسال رمز التسجيل',
                        VerifyRegisterCode: 'تأكيد رمز التسجيل',
                        ChangePassword: "تغيير كلمة المرور",
                    }
                },
                CHANGE_PASSWORD: {
                    TITLE_CHANGE_PASSWORD: 'تغيير كلمة المرور',
                    DESC_DIALOG_CHANGE_PASS: 'أدخل كلمة المرور الحالية وقم بتعيين كلمة مرور جديدة.',
                    CURRENT_PASSWORD: 'كلمة المرور الحالية',
                    NEW_PASSWORD: 'كلمة المرور الجديدة',
                    REPEAT_NEW_PASSWORD: 'أعد إدخال كلمة المرور الجديدة',
                    PASSWORDS_NOT_MATCH: 'كلمتا المرور الجديدتان غير متطابقتين.',
                    FORGET_CURRENT_PASSWORD: 'نسيت كلمة المرور الحالية',
                    FORGET_PASS_DIALOG_DESC: 'يرجى اختيار إحدى الطرق التالية لاستعادة كلمة المرور الخاصة بك.',
                    SEND_CODE_TO_EMAIL: 'إرسال الرمز إلى البريد الإلكتروني',
                    FORGET_PASS_DESCRIPTIN_CONFIRM_CODE: "الرجاء إدخال الرمز المرسل إلى البريد الإلكتروني {{email}} لاستعادة كلمة المرور الخاصة بك.",
                    DESC_DIALOG_FORGOT_PASS: "يرجى تعيين كلمة مرور جديدة."
                }
            },
            AUTH: {
                YOUR_INFORMATION: 'معلوماتك',
                EXPIRETION_DATE: 'تاريخ انتهاء صلاحية التحقق الخاص بك:',
                MOBILE_PHONE_NUMBER: 'رقم الهاتف المحمول',
                CHANGE_PHONE_NUMBER: 'تغيير رقم الهاتف',
                PENDING_REVIEW_PHONE_NUMBER: 'رقمك قيد المراجعة، يرجى التحلي بالصبر',
                PAGE_CHANGE_PHONE_NUMBER: {
                    DESC_ENTER_MOBILE_MATCH: 'يرجى إدخال رقم الهاتف المحمول الذي يطابق معلوماتك.'
                }
            },
            TWO_FACTOR_AUTH: {
                SUCCESSFUL_OPERATION_DESC: "تم تفعيل التحقق بخطوتين بنجاح.",
                SUCCESSFUL_OPERATION_DESC_EDIT: "تم إلغاء تفعيل التحقق بخطوتين بنجاح.",
                DOWNLOAD_APP: {
                    DOWNLOAD_THE_APP: 'تحميل التطبيق',
                    DESC_PAGE_DOWNLOAD_APP: 'زد من أمان حسابك عن طريق تثبيت أحد تطبيقات <span class="en-number">2FA</span>. هذه التطبيقات تُولّد رموزًا لمرة واحدة لمنع الوصول غير المصرح به.',
                    GOOGLE_AUTH: 'Google Authenticator',
                    GOOGLE_AUTH_DESC: 'اقتراحنا بسيط وسريع ولا يتطلب الإنترنت.',
                    OTHER_PROGRAMS: 'برامج أخرى',
                    OTHER_PROGRAMS_DESC: 'متنوعة، موثوقة، ومناسبة لاحتياجات محددة.',
                    NEXT_STEP: 'الخطوة التالية',
                    DIALOG: {
                        DOWNLOAD_APP: 'تحميل التطبيق',
                        DOWNLOAD_APP_DESC: 'يرجى توجيه كاميرا هاتفك نحو رمز QR لتحميل التطبيق.',
                    }
                },
                BACKUP_KEY: {
                    SCAN_THE_CODE: 'مسح الرمز',
                    SCAN_THE_QR_CODE_IN_THE_AUTH_APP: 'امسح رمز QR في تطبيق المصادقة.',
                    GENERATE_CODE: 'إنشاء رمز',
                    DESC_EXPIRED_CODE: 'انتهت صلاحية الرمز السابق، يرجى إنشاء رمز جديد.',
                    DESC_USE_CODE: 'إذا لم تتمكن من مسح رمز QR، يرجى إدخال هذا الرمز يدويًا في التطبيق.',
                    TITLE_SAVE_SECURITY_KEY: 'احفظ مفتاح الأمان!',
                    DESC_SAVE_SECURITY_KEY: 'إذا قمت بحذف التطبيق، يمكنك استعادة حسابك فقط باستخدام هذا المفتاح.',
                },
            },
            ANTI_PHISHING: {
                DESCRIPTIN_CONFIRM_CODE: 'أدخل الرمز المرسل إلى البريد الإلكتروني {{email}} لتفعيل رمز الحماية من التصيد.',
                TITLE_EDIT: 'تعديل رمز الحماية من التصيد',
                TITLE_ENABLE: 'تفعيل رمز الحماية من التصيد',
                SUBTITLE_DESC: 'يرجى إدخال عبارة الحماية من التصيد التي ترغب بها.',
                INFO_ITEM_ONE_TITLE: 'ما هو رمز الحماية من التصيد؟',
                INFO_ITEM_ONE_DESC: 'هو رمز تختاره لمساعدتك على التمييز بين رسائل TopChange الأصلية والمزيفة.',
                INFO_ITEM_TWO_TITLE: 'كيف يحميك هذا الرمز؟',
                INFO_ITEM_TWO_DESC: 'يُعرض هذا الرمز في جميع رسائل TopChange الرسمية. إذا لم تكن الرسالة تحتوي على رمزك، فمن المحتمل أن تكون مزيفة.',
                ANTI_PHISHING_PHARSE: 'عبارة الحماية من التصيد',
                SUCCESSFUL_OPERATION_DESC: 'تم تسجيل رمز الحماية من التصيد بنجاح.',
                SUCCESSFUL_OPERATION_DESC_EDIT: "تم تحديث رمز مكافحة التصيّد بنجاح.",
                VALIDATE: {
                    INVALID_CHAR: 'أرقام وحروف',
                    INVALID_LENGTH: 'من 4 إلى 15 حرفًا',
                },
            },
            ACCOUNTS: {
                ACCOUNTS: 'الحسابات',
                BANK: 'البنك',
                E_MONEY: 'الأموال الإلكترونية',
                SEARCH_NOT_FOUND: 'لم يتم العثور على نتائج',
                CREATE_ACCOUNT: 'إنشاء حساب',
                DEACTIVE_DIALOG: {
                    DESCRIPTION: 'هل أنت متأكد أنك تريد إلغاء تفعيل حسابك؟',
                    DEACTIVE_BTN: 'إلغاء التفعيل',
                    DEACTIVE_ALERT_TEXT: 'تم إلغاء تفعيل حسابك بنجاح.',
                    ACTIVE_ALERT_TEXT: 'تم تفعيل حسابك بنجاح.',
                },
                BANK_DATA: {
                    IBAN_NUMBER: 'رقم الآيبان:',
                    YOU_DO_NOT_HAVE_A_REGISTRED_BANK_CARD: 'لا يوجد لديك بطاقة بنكية مسجلة.',
                    CRUD: {
                        CREATE_NEW_BANK_ACCOUNT: 'إنشاء حساب بنكي جديد',
                        ALERT_CARD_FOR_USER: 'يرجى الانتباه عند إدخال رقم البطاقة؛ يجب أن يكون هذا الرقم باسمك.',
                        HINT_IBAN_NUMBER: 'يرجى الانتباه عند إدخال رقم الآيبان، لأنه لا يمكن تعديله بعد التسجيل.',
                        BANK_ACCOUNT: 'الحساب البنكي',
                        INVALID_BANK_ACCOUNT: 'حساب بنكي غير صالح',
                        INVALID_BANK_ACCOUNT_DESC: 'توجد تناقضات في الحساب البنكي المسجل، يرجى المحاولة مرة أخرى بعد التحقق.',
                        APPLY_CHANGES: 'تطبيق التغييرات',
                        THE_IBAN_NUMBER_CANNOT_BE_EDITED: 'لا يمكن تعديل رقم الآيبان.',
                    }
                },
                ACCOUNT_HISTORY: {
                    TITLE: 'سجل الحساب',
                    HISTORY_DESCRIPTION: 'في هذا القسم، يمكنك عرض سجل الإيداعات والسحوبات من حسابك.',
                    EMPTY_TRANSACTION: 'لم تقم بأي معاملات بعد.',
                    MOUNTH: 'الشهر',
                    AMOUNT_IN_RIAL: 'المبلغ بالريال',
                    AMOUNT_IN_DOLLAR: 'المبلغ بالدولار',
                    WITHDRAWAL: 'سحب',
                    DEPOSIT: 'إيداع',
                },
                E_MONEY_DATA: {
                    YOU_DO_NOT_HAVE_A_REGISTRED_ACCOUNT: 'لا يوجد لديك حساب أموال إلكترونية مسجل.',
                    CREATE_NEW_ACCOUNT: 'إنشاء حساب إلكتروني جديد',
                    ACCOUNT_OWNERS_NAME: "اسم صاحب الحساب",
                    ELECTRONIC_ACCOUNT: 'الحساب الإلكتروني',
                    DELETE_ACCOUNT: 'تم حذف حسابك بنجاح.',
                }

            },
            POINT_TRANSACTIONS: {
                DEPOSIT_TO_WALLETS: 'إيداع في المحفظة',
                MINIMUM_POINT_WITHDRAWN: 'الحد الأدنى للنقاط التي يمكن سحبها هو <span>{{value}}</span> نقطة.',
                TRANSACTION_POINTS: 'نقاط المعاملة',
                SEARCH_TRACKING_NUMBER: 'البحث برقم التتبع',
                POINTS_WITHDRAWAL: 'سحب النقاط',
                PLEASE_SELECT_WALLET: 'يرجى اختيار إحدى محافظك للمتابعة.',
                WITHDRAWAL_POINTS: 'نقاط السحب',
                WITHDRAWAL_POINTS_MIN_DESC: 'يرجى إدخال عدد النقاط المراد سحبها. الحد الأدنى للنقاط القابلة للسحب هو {{value}}.',
                EVERY_VALUE_POINT: 'كل {{value}} نقطة',
                AMOUNT_RECEIVED: 'المبلغ المستلم:',
                CONFIRM_REQUEST: 'تأكيد الطلب',
                CONFIRM_REQUEST_DESC_DIALOG: 'لإرسال الطلب، يرجى التحقق من المعلومات وتأكيدها.',
                WITHDRAWABLE_POINTS: 'النقاط القابلة للسحب:',
                VALUE_OF_VALUE_POINT: 'قيمة {{value}} نقطة:',
                DEPOSIT: 'إيداع',
                ACCEPT_POINT_WITHDRAW: 'أُقر بصحة المعلومات المذكورة أعلاه.',
                ALERT_SUCCESS_POINT: 'تم سحب النقاط بنجاح وتم إيداع المبلغ في المحفظة المطلوبة.',
                MORE: 'یکمل …',
                VALIDATION: {
                    MINIMUM_POINT_WITHDRAWN: 'الحد الأدنى للنقاط التي يمكن سحبها هو {{value}} نقطة.',
                    MAXIMUM_POINT_WITHDRAWN: 'الحد الأقصى للنقاط التي يمكن سحبها هو {{value}} نقطة.',
                }
            }
        },
        SHARED_COMPONENTS: {
            DIALOGS: {
                INACCESSIBILITY: 'تم رفض الوصول',
                INACCESSIBILITY_DESC: 'إذا لم يكن لديك وصول إلى بريدك الإلكتروني، يرجى التواصل مع الدعم.',
                VERIFY_EMAIL: 'تأكيد البريد الإلكتروني',
                VERIFY_EMAIL_DESC: 'يرجى إرسال رمز التحقق إلى <span>{{email}}</span> للمتابعة.',
                CONFIRM_CODE: 'تأكيد الرمز',
                EMAIL_VERIFY_CODE_DESC: 'يرجى إدخال الرمز المُرسل إلى <span>{{email}}</span>.',
                TWO_FACTOR_AUTH_VERIFY_CODE_DESC: 'يرجى إدخال الرمز المعروض حاليًا في تطبيق <span class="en-number">2FA</span>.',
                CHECK_SPAM_TEXT: "يرجى التحقق من مجلد الرسائل غير المرغوب فيها أيضًا."
            },
            DATEPICKER: {
                DEFAULT_RANGES: 'النطاقات الافتراضية',
                TODAY: 'اليوم',
                YESTERDAY: 'أمس',
                LAST_WEEK: 'الأسبوع الماضي',
                THIS_WEEK: 'هذا الأسبوع',
                LAST_MONTH: 'الشهر الماضي',
                THIS_MONTH: 'هذا الشهر',
                LAST_30_DAYS: 'آخر 30 يومًا',
                PREVIOUS_QUARTER: 'الربع السابق',
                LAST_YEAR: 'السنة الماضية',
                THIS_YEAR: 'هذه السنة',
                MONTH: 'الشهر',
                DAY: 'اليوم',
                YEAR: 'السنة',
                TO: 'إلى',
                EXACT_DATE: 'تاريخ محدد',
                HOUR: 'الساعة',
                MINUTE: 'الدقيقة',
                SECOND: 'الثانية',
                FROM: "من",
                SELECT_DATES: 'اختر التواريخ'
            }
        },
        CHAT: {
            P2P: {
                USER: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: 'رسالة جديدة في دردشة <span class="en-number">P2P</span>'
                        },
                        BODY: {
                            MESSAGE: 'الطلب <span>{{2}}</span>'
                        }
                    }
                }
            }
        },
        SOCIAL_MEDIA: {
            TELEGRAM: 'تيليجرام',
            CHANNEL_LINK_TELEGRAM: 'قناة توب تشينج على تيليجرام',
            DESC_TELEGRAM: 'انضم إلى قناتنا الرسمية لتلقي آخر الأخبار والإعلانات المهمة والتواصل مباشرةً مع فريق الدعم لدينا.',
            APARAT: 'آپارات',
            DESC_APARAT: 'شاهد مقاطع الفيديو التعليمية والعروض التقديمية للمنتجات والتوثيق المرئي لأنشطة الشركة على قناتنا في آپارات.',
            CHANNEL_LINK_APARAT: 'قناة توب تشينج على آپارات',
        },

    }
};

